function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBae1(_ref, svgRef) {
  var _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98, _ref99, _ref100, _ref101, _ref102, _ref103, _ref104, _ref105, _ref106, _ref107, _ref108, _ref109, _ref110, _ref111, _ref112, _ref113, _ref114, _ref115, _ref116, _ref117, _ref118, _ref119, _ref120, _ref121, _ref122, _ref123, _ref124, _ref125, _ref126, _ref127, _ref128, _ref129, _ref130, _ref131, _ref132, _ref133, _ref134, _ref135, _ref136, _ref137, _ref138, _ref139, _ref140, _ref141, _ref142, _ref143, _ref144, _ref145, _ref146, _ref147, _ref148, _ref149, _ref150, _ref151, _ref152, _ref153, _ref154, _ref155, _ref156, _ref157, _ref158, _ref159, _ref160, _ref161, _ref162, _ref163, _ref164, _ref165, _ref166, _ref167, _ref168, _ref169, _ref170, _ref171, _ref172, _ref173, _ref174, _ref175, _ref176, _ref177, _ref178, _ref179, _ref180, _ref181, _ref182, _ref183, _ref184, _ref185, _ref186, _ref187, _ref188, _ref189, _ref190, _ref191, _ref192, _ref193, _ref194, _ref195, _ref196, _ref197, _ref198, _ref199, _ref200, _ref201, _ref202, _ref203, _ref204, _ref205, _ref206, _ref207, _ref208, _ref209, _ref210, _ref211, _ref212, _ref213, _ref214, _ref215, _ref216, _ref217, _ref218, _ref219, _ref220, _ref221, _ref222, _ref223, _ref224, _ref225, _ref226, _ref227, _ref228, _ref229, _ref230, _ref231, _ref232, _ref233, _ref234, _ref235, _ref236, _ref237, _ref238, _ref239, _ref240, _ref241, _ref242, _ref243, _ref244, _ref245, _ref246, _ref247, _ref248, _ref249, _ref250, _ref251, _ref252, _ref253, _ref254, _ref255, _ref256, _ref257, _ref258, _ref259, _ref260, _ref261, _ref262, _ref263, _ref264, _ref265, _ref266, _ref267, _ref268, _ref269, _ref270, _ref271, _ref272, _ref273, _ref274, _ref275, _ref276, _ref277, _ref278, _ref279, _ref280, _ref281, _ref282, _ref283, _ref284, _ref285, _ref286, _ref287, _ref288, _ref289, _ref290, _ref291, _ref292, _ref293, _ref294, _ref295, _ref296, _ref297, _ref298, _ref299, _ref300, _ref301, _ref302, _ref303, _ref304, _ref305, _ref306, _ref307, _ref308, _ref309, _ref310, _ref311, _ref312, _ref313, _ref314, _ref315, _ref316, _ref317, _ref318, _ref319, _ref320, _ref321, _ref322, _ref323, _ref324, _ref325, _ref326, _ref327, _ref328, _ref329, _ref330, _ref331, _ref332, _ref333, _ref334, _ref335, _ref336, _ref337, _ref338, _ref339, _ref340, _ref341, _ref342, _ref343, _ref344, _ref345, _ref346, _ref347, _ref348, _ref349, _ref350, _ref351, _ref352, _ref353, _ref354, _ref355, _ref356, _ref357, _ref358, _ref359, _ref360, _ref361, _ref362, _ref363, _ref364, _ref365, _ref366, _ref367, _ref368, _ref369, _ref370, _ref371, _ref372, _ref373, _ref374, _ref375, _ref376, _ref377, _ref378, _ref379, _ref380, _ref381, _ref382, _ref383, _ref384, _ref385, _ref386, _ref387, _ref388, _ref389, _ref390, _ref391, _ref392, _ref393, _ref394, _ref395, _ref396, _ref397, _ref398, _ref399, _ref400, _ref401, _ref402, _ref403, _ref404, _ref405, _ref406, _ref407, _ref408, _ref409, _ref410, _ref411, _ref412, _ref413, _ref414, _ref415, _ref416, _ref417, _ref418, _ref419, _ref420, _ref421, _ref422, _ref423, _ref424, _ref425, _ref426, _ref427, _ref428, _ref429, _ref430, _ref431, _ref432, _ref433, _ref434, _ref435, _ref436, _ref437, _ref438, _ref439, _ref440, _ref441, _ref442, _ref443, _ref444, _ref445, _ref446, _ref447, _ref448, _ref449, _ref450, _ref451, _ref452, _ref453, _ref454, _ref455, _ref456, _ref457, _ref458, _ref459, _ref460, _ref461, _ref462, _ref463, _ref464, _ref465;
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 183,
    viewBox: "0 0 182 183",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3437_366)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.401 84.3265C126.266 33.1441 103.844 -12.0408 69.3207 -16.5969C34.7976 -21.153 1.24644 16.6451 -5.6179 67.8275C-12.4822 119.01 9.93964 164.195 44.4628 168.751C78.9859 173.307 112.537 135.509 119.401 84.3265Z",
    fill: "url(#paint0_radial_3437_366)",
    style: {
      mixBlendMode: "color-dodge"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.901 40.8517C166.369 12.828 144.309 -5.62768 124.628 -0.370253C104.947 4.88717 95.0982 31.8668 102.63 59.8905C110.162 87.9142 132.222 106.37 151.903 101.112C171.584 95.855 181.432 68.8753 173.901 40.8517Z",
    fill: "url(#paint1_radial_3437_366)",
    style: {
      mixBlendMode: "color-dodge"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M167.042 76.5573L166.988 76.3407L166.961 76.2324V76.227L161.721 61.7659L161.759 61.7966L161.621 61.4825L161.632 61.4572L161.598 61.4283L161.531 61.2424L161.524 61.2586L157.909 52.973L157.718 52.6372L157.678 52.5686L156.899 51.2689L153.872 46.9095L153.832 46.8571L153.821 46.8427L152.548 45.2722L151.951 44.5465L151.945 44.5411L151.932 44.5267L151.217 43.7017L149.852 42.1727L149.85 42.1709L149.349 41.6276L148.983 41.2413L148.758 41.0084L147.648 39.873L147.638 39.8621L147.618 39.8423L147.288 39.5137L146.911 39.1419L146.493 38.7411L145.617 37.9162L145.2 37.5299L144.505 36.8981L144.185 36.6129L144.118 36.5551L142.906 35.5063L142.073 34.8095L142.037 34.7788L140.962 33.9105L140.236 33.3455L139.515 32.7895L139.502 32.7787L139.464 32.7498H139.461V32.7462L138.537 32.0657L137.181 31.0963L136.832 30.849L136.265 30.4591L135.638 30.0403L135.441 29.9103L134.038 29.0077L132.58 28.1178L131.113 27.2622L130.09 26.6971L129.098 26.1592L129.04 26.1285L128.939 26.0744L128.912 26.0599L127.704 25.4408L127.489 25.3343L125.902 24.5653L125.49 24.3721L124.524 23.9335L123.366 23.4334L122.567 23.0922L121.801 22.7818L121.694 22.7402L121.655 22.724L121.396 22.6229L121.283 22.5796L121.198 22.5471L120.878 22.4243L120.298 22.2059L119.013 21.7294L117.09 21.0759L115.172 20.4766L115.017 20.4296L114.872 20.3881L114.004 20.1444L112.951 19.8556L112.067 19.6264L112.058 19.657L111.453 19.4711L111.397 19.4567L111.207 19.4115L111.138 19.3953L110.486 19.2455L109.597 19.0433L109.554 19.0343H109.541V19.0325L108.228 18.7617L107.872 18.6931L105.569 18.2833L105.058 18.1985L102.9 17.8952H102.889H102.876L102.873 17.8934L102.813 17.8862L101.189 17.6984H101.187L100.166 17.6028L99.4087 17.536L99.416 17.5306L99.139 17.5125H99.1172L97.6777 17.415H97.6506H97.647L96.1912 17.3446L96.0083 17.3392L94.3407 17.2959H94.3389H92.8541L91.6283 17.3103H91.5921H91.5613H91.5523H91.545H91.5124L91.0833 17.3176H91.0091L90.1182 17.3519L89.2509 17.3898H89.2364H89.2129L87.4366 17.6172H87.433L87.4113 17.6208L87.2248 17.6587L87.1669 17.6714L86.9514 17.7165L86.926 17.7219L86.3883 17.8483L86.3394 17.8609L86.1565 17.9078L85.4304 18.101L85.3888 18.0829L85.3689 18.1136L75.0173 19.7635L74.9014 19.7888L74.8236 19.8051H74.8218L70.8781 20.7672V20.7275L70.7586 20.7961L70.6989 20.8105V20.8232L53.3346 28.7388L52.8675 28.7207L52.7969 28.764L51.7322 29.4338L51.6688 29.4753L50.4919 30.2479L50.3488 30.3454L48.9727 31.2913L48.9238 31.3256L48.1851 31.8599L48.1579 31.8797L48.1072 31.9177L47.2671 32.535L46.3328 33.239L46.3255 33.2444L45.1957 34.1326L45.0472 34.2553L43.787 35.2897L43.7852 35.2933L42.7513 36.1778L42.5557 36.3511L41.3444 37.4324L41.1959 37.5714L41.2177 37.5353L40.7324 37.9992L40.7034 38.0263L39.8615 38.8332L39.0159 39.6527L39.0123 39.6563L38.0218 40.6582L37.8915 40.7954L36.7996 41.9471L36.7924 41.9543L36.6892 42.0644L35.9287 42.8984L35.7241 43.1313L34.683 44.3245L34.6685 44.3425L33.7795 45.404L33.6708 45.5375L32.684 46.765L32.6713 46.7813L32.0485 47.5972L31.9779 47.6893L31.9308 47.7507L31.4473 48.3915L30.7991 49.2706L30.6651 49.4601L30.6271 49.5143L29.7652 50.7526L29.528 51.0992V51.0956L29.4139 51.2653L29.394 51.2942L29.0265 51.8466L29.0174 51.8592L29.0084 51.8718L28.4796 52.695L28.4018 52.8177L28.371 52.8665L27.9437 53.5398L27.3661 54.4767V54.4821H27.3625L26.6328 55.7186L26.5748 55.8197L25.8125 57.1736V57.1772L25.8089 57.179L25.1317 58.4426L25.0756 58.5509L24.3694 59.9336V59.9373L23.7973 61.1088L23.6923 61.3344L23.0404 62.7497L22.7815 63.331L22.5443 63.8833L22.3994 64.2281L21.7892 65.7138L21.6281 66.1217L21.4398 66.6055L21.2135 67.212L20.6684 68.7157V68.7193L20.2194 70.0425L20.1578 70.2375L19.6798 71.7538L19.5983 72.0246L19.2923 73.0824L19.2362 73.2882L18.8216 74.8226V74.8298L18.4848 76.1963L18.445 76.3714L18.0955 77.922V77.931L17.8438 79.1947L17.8275 79.2831V79.2903L17.6972 79.9582L17.5016 81.0449V81.0485L17.2825 82.4241L17.2553 82.6226L17.0381 84.1985L17.0145 84.3917V84.4097H17.0127L16.8842 85.5145L16.8534 85.8178L16.7049 87.3684L16.6669 87.8341L16.6198 88.4641L16.589 88.9678L16.5021 90.5653L16.455 91.9643L16.4514 92.1701L16.4297 93.7767V93.9572L16.4406 95.1919L16.4442 95.3815L16.4858 96.8761V96.8816L16.5981 99.0152V99.0225L16.6578 99.8673V99.8727L16.6705 100.035V100.06V100.068L16.7013 100.436V100.461L16.7122 100.577V100.584L16.8027 101.517L16.8298 101.795L16.9584 103.012L17.0218 103.546L17.192 104.815L17.2083 104.938L17.4418 106.454L17.4509 106.508V106.514V106.516L17.7026 107.947L17.737 108.129L18.0321 109.622L18.0339 109.635V109.64H18.0357L18.2729 110.716L18.7491 112.727L18.9067 113.35L19.0896 114.025L19.1565 114.267L19.5947 115.798L20.2936 118.002L20.424 118.401V118.404L20.4294 118.421V118.426L20.4602 118.515L20.4657 118.533L20.5689 118.832L21.0758 120.251L21.1066 120.336L21.677 121.836L21.6806 121.843L22.1206 122.921L22.1242 122.932L22.1622 123.024L22.4827 123.793L22.9155 124.8L23.0821 125.172H23.0784L23.1563 125.338L23.1762 125.383L23.6904 126.482L24.23 127.616L24.2355 127.629L24.8801 128.905L25.1082 129.34L25.655 130.373V130.374L25.6604 130.385L25.6623 130.389L26.3539 131.634L26.4101 131.735L27.1868 133.068L27.1959 133.082L27.1995 133.089V133.093H27.2013L27.9817 134.366L28.0306 134.443L28.8436 135.716L29.9264 137.317L29.9173 137.31L30.026 137.465L30.0386 137.483L30.3591 137.943L30.5112 138.162L30.6036 138.294L30.7792 138.541L31.4021 139.393L31.5288 139.563L32.474 140.805V140.808L33.334 141.891L33.4572 142.041L34.4603 143.251L34.8713 143.734L35.3421 144.272L35.4996 144.449L36.5588 145.626L36.8757 145.969L37.5782 146.711L37.6525 146.789L38.7588 147.92L38.7769 147.939L39.7691 148.913L39.914 149.052L41.0855 150.155L41.0927 150.162L41.1145 150.182H41.1163V150.186L42.2353 151.193L42.295 151.247L43.5172 152.307L43.5498 152.336L44.3193 152.971L45.2228 153.708L46.0449 154.361L46.0485 154.363L47.2019 155.244L47.3594 155.36L48.6885 156.327L50.0609 157.278L51.1111 157.977L51.5891 158.289L51.6416 158.324L52.9526 159.147L53.0123 159.183L53.8235 159.67L55.2938 160.533L56.0253 160.939L56.2588 161.066L56.7676 161.338L56.9596 161.439L57.0356 161.479L57.5317 161.735L57.7907 161.867L58.3719 162.154L58.5439 162.239L59.2989 162.598L59.4891 162.687L60.0649 162.948L60.3328 163.068L60.8452 163.291L61.1241 163.411L61.6673 163.638L61.8828 163.726L61.8954 163.732L62.8352 164.106L63.0488 164.187L63.9234 164.513L64.0356 164.555L65.0007 164.894L65.2289 164.972L66.2157 165.297L67.0287 165.548L67.2966 165.627L67.8453 165.788L68.1621 165.876L68.6673 166.015L69.0023 166.106L69.493 166.234L69.8352 166.32L70.3313 166.441L70.6645 166.521L71.1642 166.635L71.262 166.721L71.2692 166.69L71.8867 167.039L71.5245 166.714L72.1058 166.837L72.3321 166.884L73.1849 167.05C82.3686 168.678 92.9682 170.169 100.119 170.169C100.254 170.169 100.388 170.169 100.522 170.169H100.568L100.571 170.164L101.984 170.008L102.997 169.887L103.738 169.79L103.76 169.786L105.922 169.456L105.965 169.449L108.069 169.064L110.47 168.555L110.508 168.546L111.303 168.358L111.368 168.342L112.071 168.163L113.23 167.858L113.637 167.747L114.325 167.557L114.55 167.494L114.863 167.404L116.932 166.761H116.934L118.705 166.163L118.844 166.113L118.966 166.07L119.668 165.817L119.701 165.804H119.703L121.213 165.225L122.267 164.81L123.8 164.163L123.938 164.102L125.604 163.353L126.013 163.161L127.045 162.663L128.149 162.105L128.767 161.791L128.999 161.669L130.112 161.069L130.275 160.977L131.778 160.129L131.997 160.001L132.939 159.441L133.221 159.266L134.659 158.367L135.885 157.564L136.384 157.221L137.409 156.515L137.418 156.509L137.715 156.3L138.57 155.681L138.745 155.549L140.062 154.558H140.064L140.29 154.385L141.17 153.69L141.346 153.545L142.606 152.511L143.344 151.876L143.757 151.518L143.754 151.527L143.987 151.32L144.023 151.287L144.308 151.034L145.045 150.372L146.084 149.404L146.222 149.271L147.379 148.148L147.446 148.081L148.286 147.233L148.499 147.009L149.311 146.153L149.635 145.81L149.691 145.751L150.663 144.675L151.708 143.478L151.722 143.462L152.61 142.402L153.012 141.902L153.701 141.041V141.037L153.712 141.023L154.399 140.128L154.835 139.548L155.583 138.532L156.407 137.364L156.481 137.254L157.355 135.961V135.96L158.132 134.755L158.199 134.649L159.018 133.326V133.322L159.709 132.152L159.803 131.983L160.568 130.625L160.948 129.916L161.323 129.21V129.206V129.205V129.201L162.103 127.47L162.326 126.939L162.858 125.612L162.86 125.607V125.605L163.171 124.784V124.791L163.278 124.5L163.289 124.47L163.664 123.441L163.698 123.058L167.477 111.59L167.549 111.269L167.562 111.214V111.209L169.277 92.829L166.983 76.5501L167.042 76.5573ZM143.873 91.8398L142.807 93.4969L143.48 87.2727L143.488 87.1807L143.524 86.7041V86.7005L143.832 78.8986L143.826 78.8679L138.115 45.7343L138.278 45.9365L150.491 64.7516L153.754 71.7737L153.747 71.7809L153.759 71.7989L144.067 91.5329L143.873 91.838V91.8398ZM144.826 124.5L133.578 149.722L130.485 142.673L130.288 142.42L130.273 142.4L130.27 142.397L126.77 138.727L126.79 138.694H126.795L126.813 138.656V138.653L126.916 138.49L126.889 138.494L136.851 117.829L144.775 123.869L144.822 124.497L144.826 124.5ZM47.9606 153.338L52.9019 150.079L53.0884 150.462L70.5106 166.075L48.2412 153.506L47.9588 153.338H47.9606ZM37.2107 119.619L37.0224 119.246L36.7037 118.601L36.586 118.359L36.1858 117.525L36.146 117.442L30.4243 102.158L30.341 101.866L31.1323 99.203L36.7254 86.2366L36.8105 86.0795L41.0674 97.0368L40.9823 97.6144L40.975 97.665V97.674L43.3941 130.203L37.8046 120.78L37.7122 120.603L37.4026 120L37.207 119.616L37.2107 119.619ZM27.5055 61.95L31.3966 56.5454L27.377 78.0484C27.3299 78.0592 27.2538 78.0736 27.1524 78.0953C26.5187 78.2271 24.9108 78.5592 23.2885 78.8571C22.4773 79.0051 21.6607 79.1459 20.9618 79.2506C20.2629 79.3535 19.6762 79.4203 19.3358 79.4203H19.3304C19.2235 79.4203 19.1421 79.4131 19.095 79.4004C19.0914 79.4004 19.0896 79.4004 19.0859 79.3986L27.2393 62.3562L27.491 61.9735L27.5055 61.9518V61.95ZM31.8439 55.7294L32.2802 54.7312L32.5029 54.2348L32.617 53.9839L36.8503 46.1477V46.1441H36.8522L37.3664 45.3462L37.5167 45.1169L37.9114 44.5285L40.2598 41.2936L40.3974 41.1167L40.8157 40.5896L41.2267 40.0824L41.3969 39.8766L51.2198 30.8472L49.7966 33.0025L48.7899 37.3855V37.9703L48.482 38.2267L47.8139 38.7917L31.8475 55.7331L31.8439 55.7294ZM93.1855 21.8214L115.035 33.4123L137.402 45.2776L122.994 46.0051L113.677 47.1207L106.986 47.9222L106.999 47.8933L106.89 47.924L96.7072 27.9987V27.9951L93.1891 21.8214H93.1855ZM137.882 45.4653L137.894 45.5809L137.903 45.5736L138.858 51.1119L137.844 45.4455L137.882 45.4653ZM143.649 78.913L143.343 86.6951L143.306 87.1698L143.299 87.2565L142.602 93.7099L134.011 71.8007L133.967 71.7141L133.79 71.3657L131.066 66.2878L131.097 66.2625L131.059 66.2336L136.52 52.0614L137.203 48.5558L137.731 45.8444L143.649 78.913ZM108.6 159.111L116.878 151.571H116.88L116.94 151.504L117.41 150.995L117.581 150.809L117.964 150.385L118.209 150.11L118.526 149.753L118.824 149.41L119.087 149.106L119.422 148.713L119.645 148.451L120.001 148.023L120.195 147.789L120.561 147.341L120.735 147.126L121.108 146.659L121.262 146.466L121.645 145.976L121.772 145.814L122.176 145.287L122.257 145.18L122.699 144.594V144.592L126.657 138.882L130.123 142.518L130.132 142.528L130.319 142.767L133.447 149.895L108.592 159.111H108.6ZM126.551 138.732L122.56 144.487L122.118 145.072L122.037 145.177L121.633 145.702L121.508 145.863L121.124 146.352L120.97 146.545L120.597 147.011L120.423 147.224L120.058 147.671L119.864 147.904L119.507 148.33L119.284 148.592L118.949 148.986L118.687 149.287L118.388 149.63L118.071 149.987L117.827 150.262L117.443 150.686L117.273 150.87L116.802 151.379L116.746 151.439L108.335 159.1L109.163 156.712L109.159 151.919L109.136 151.805L109.118 151.717V151.71L107.043 146.361L104.915 142.958L105.245 142.875L107.548 142.299L114.827 140.689L121.779 139.443L122.122 139.389L122.25 139.369L126.549 138.73L126.551 138.732ZM69.8189 135.046L64.4267 113.836L82.3686 105.922L82.3161 106.046L82.5261 105.875L88.3474 113.215L88.6751 113.81L69.9637 135.07L69.8171 135.044L69.8189 135.046ZM27.5707 78.3372L36.7109 85.8882L36.662 85.9766L36.5624 86.1589L30.9621 99.1434L30.2849 101.42L29.9608 98.665L27.5689 78.3372H27.5707ZM27.5526 78.0881L29.5081 67.6272L31.6193 56.3324L31.623 56.336V56.3233V56.3215L31.6266 56.3233L35.5267 59.1683L35.5322 59.1719L41.415 62.3778L41.5291 62.4338L42.0922 62.7118L42.2208 62.775L42.7839 63.0493L42.8165 63.0656L50.519 66.6199L48.8731 68.5045L36.8087 85.7329L27.5544 78.0881H27.5526ZM48.7681 38.2176L47.6274 53.4261L47.6437 53.5651L47.7415 54.3341L47.7704 54.5507L47.8755 55.28L47.9099 55.5038L48.0312 56.2584L48.0602 56.4335L48.2068 57.2638L48.2231 57.3523V57.3559L49.3421 62.3309V62.3345L49.353 62.376L49.5902 63.2642L49.7115 63.6992L49.793 63.9898L50.5172 66.4268L48.3969 65.4484L42.8907 62.9067L42.8563 62.8905L42.2932 62.6161L42.1646 62.5529L41.6015 62.2749L41.4929 62.2208L35.6173 59.0184L31.69 56.1537L47.9298 38.9217L48.5907 38.3639L48.7627 38.2194L48.7681 38.2176ZM70.9831 58.2278L94.2031 51.6859L106.686 48.1695L90.1472 87.4478L82.5153 105.573L50.8124 66.6272L66.9055 59.9246L70.9831 58.226V58.2278ZM133.628 71.4487L133.804 71.7953L133.844 71.8747L142.522 94.0005L142.528 94.0222L117.792 97.2372H117.778L116.404 97.4827L105.983 99.546L105.203 99.7175L104.752 99.8167L84.536 105.063H84.5323L84.1883 105.165L82.948 105.535L130.92 66.4069L133.627 71.4523L133.628 71.4487ZM41.1633 97.6397L41.2303 97.1866L64.1732 113.787L47.1041 127.567L43.5933 130.401L41.1597 97.6776L41.1652 97.6361L41.1633 97.6397ZM41.2611 96.9863L41.3535 96.3743L41.3661 96.2967L50.7037 66.777L71.9193 92.8398L82.3976 105.712L64.3344 113.68L41.2629 96.9863H41.2611ZM82.7651 105.447L106.88 48.1731L130.802 66.2661L82.7651 105.447ZM82.6945 105.795L84.239 105.335L84.5812 105.234L104.79 99.99L105.237 99.8908L106.018 99.7211L116.436 97.6596L117.809 97.4177H117.82L142.439 94.2171L125.062 116.612L88.9033 113.558L88.8055 113.669L88.5013 113.117L82.6963 105.797L82.6945 105.795ZM88.9775 113.744L124.928 116.78L104.786 142.736L88.8942 113.836L88.9757 113.742L88.9775 113.744ZM136.344 52.0108L130.907 66.1199L107.075 48.0954L123.011 46.1874L137.625 45.4491L136.344 52.0126V52.0108ZM49.0162 68.6164L50.4484 66.9756L41.1869 96.2552L41.1724 96.3454L41.1217 96.6758L36.9264 85.8773L49.0144 68.6146L49.0162 68.6164ZM64.2692 113.942L69.6251 135.012L43.7272 130.526L64.2692 113.94V113.942ZM70.1756 135.108L88.7693 113.98L104.575 142.725L97.0567 139.765L70.1756 135.109V135.108ZM122.225 139.193L122.096 139.212L121.752 139.267L114.798 140.512L107.513 142.122L105.009 142.747L106.847 140.379L125.147 116.796L136.685 117.771L126.677 138.528L122.229 139.191L122.225 139.193ZM125.276 116.628L142.488 94.4482L136.752 117.598L125.276 116.628ZM92.9248 21.7276L96.5461 28.0835L105.067 44.7559L106.637 47.8283L106.201 47.6117L105.554 47.2922L74.9503 34.6452L92.9248 21.7276ZM74.7602 34.8023L74.7747 34.8203L74.8018 34.7788L105.48 47.4564L106.121 47.7723L106.592 48.007L70.9234 58.0563L50.8938 66.3979L58.3719 54.464L68.7434 41.3099L69.3554 40.6185L69.426 40.5391L71.9917 37.7212L72.1058 37.5985L72.7033 36.9613L74.7602 34.8059V34.8023ZM72.5729 36.8349L71.9754 37.4739L71.8595 37.5985L69.292 40.4181L69.2196 40.4994L68.6039 41.1961L58.2252 54.3611L50.6983 66.3744L49.974 63.9429L49.8925 63.6523L49.773 63.2172L49.5358 62.3291L49.525 62.2912L48.4078 57.3198L48.3915 57.2331L48.243 56.4028L48.2141 56.2295L48.0928 55.4767L48.0583 55.2547L47.9533 54.5272L47.9244 54.3124L47.8266 53.5452L47.8121 53.4261L48.9619 38.0913L66.5144 35.3492L74.5411 34.777L72.5747 36.8385L72.5729 36.8349ZM19.1095 79.5864C19.1728 79.5954 19.2471 79.599 19.334 79.599C19.7468 79.599 20.4566 79.5124 21.2949 79.3824C23.5673 79.0304 26.7794 78.3589 27.3751 78.2343L30.1509 101.84L20.1542 113.96C20.1162 112.498 19.9098 104.647 19.6834 96.7985C19.5585 92.4481 19.4281 88.0959 19.3177 84.8321C19.2634 83.2003 19.2127 81.841 19.171 80.8879C19.1511 80.4113 19.1312 80.0377 19.1149 79.7813C19.1095 79.7055 19.1058 79.6405 19.1004 79.5846C19.1022 79.5846 19.104 79.5846 19.1058 79.5846L19.1095 79.5864ZM43.682 130.719L43.7055 130.725L43.6928 130.705L62.2087 133.911L69.6722 135.203L69.703 135.328L52.9671 149.801L43.6802 130.719H43.682ZM71.1371 166.391L53.2368 150.35L53.0503 149.969L69.7537 135.524L74.1935 152.991L73.5434 155.843L71.1371 166.391ZM69.9076 135.391L69.9855 135.324L70.0362 135.266L97.0078 139.938L104.511 142.893L74.3528 152.874L69.9094 135.393L69.9076 135.391ZM104.732 143.01L104.763 143.065L104.768 143.057L106.885 146.44L108.947 151.76L108.964 151.841L108.984 151.939L108.987 156.683L108.08 159.298L74.6461 152.966L104.732 143.01ZM108.174 159.504H108.183L108.207 159.463L108.239 159.437L132.674 150.377L101.46 168.905L108.174 159.504ZM136.924 117.659L142.564 94.8995L144.76 123.632L136.924 117.659ZM153.892 71.6401L150.651 64.665L138.425 45.8318L138.307 45.6874L149.184 51.3519H149.186L149.262 51.3989L161.413 61.5077L159.238 66.3365L153.893 71.6401H153.892ZM143.987 36.6887L144.052 36.7464L144.373 37.0298L145.068 37.6617L145.483 38.048L146.359 38.8729L146.777 39.2719L147.154 39.6419L147.484 39.9686L147.504 39.9885L147.514 39.9993L148.624 41.1348L148.849 41.3658L149.215 41.7485L149.714 42.2883L149.718 42.2937L151.083 43.8208L151.797 44.644L151.809 44.6584L151.815 44.6638L152.412 45.3895L153.683 46.9582L153.692 46.969L153.729 47.0178L156.752 51.3718L157.527 52.6625L157.565 52.7293L157.752 53.0578L161.29 61.1738L149.37 51.2563L149.283 51.2021L149.278 51.1985H149.276L138.135 45.3931L142.144 42.189L142.155 42.1782L142.298 42.0392L144.183 39.4722L144.208 39.4072L144.235 39.335L144.241 39.3206L144.293 37.4378L144.268 37.3674L144.252 37.3205L144.248 37.3115L144.239 37.297L143.786 36.5136L143.991 36.6905L143.987 36.6887ZM125.375 24.5382L125.788 24.7295L127.373 25.4967L127.588 25.6032L128.794 26.2224L128.821 26.2368L128.923 26.291L128.973 26.3181L129.973 26.8596L130.994 27.4228L132.461 28.2767L133.918 29.1648L135.32 30.0656L135.513 30.1919L136.143 30.6107L136.708 30.9988L137.058 31.2443L138.414 32.2119L139.336 32.8906H139.339L139.377 32.9213L139.388 32.9303L140.109 33.4863L140.835 34.0495L141.909 34.916L141.945 34.9449L142.771 35.6327L142.803 35.6688L143.502 36.4089L144.08 37.3873L144.094 37.4252L144.109 37.4631L144.058 39.2827L144.036 39.3404L144.02 39.3838L142.157 41.92L142.026 42.0482L142.023 42.0518L138.041 45.2325L137.851 43.4923L137.849 43.4706L137.831 43.3334V43.3262L134.72 33.7354L134.677 33.6578L134.505 33.36L134.436 33.2444L134.275 32.9755L134.201 32.8545L134.027 32.5801L133.991 32.5224L133.983 32.5115L133.949 32.4809L124.816 24.28L125.383 24.5364L125.375 24.5382ZM114.778 20.5614L114.921 20.6029L115.078 20.6499L116.992 21.2474L118.915 21.9008L120.195 22.3756L120.775 22.594L121.095 22.7168L121.18 22.7493L121.291 22.7926L121.544 22.8919L124.161 24.1086L133.842 32.6289L133.871 32.674L134.045 32.9484L134.119 33.0657L134.28 33.3329L134.349 33.4466L134.521 33.7445L134.556 33.8058L137.654 43.3641L137.672 43.4941V43.514H137.675L137.849 45.1079L137.826 45.0772L137.833 45.1242L137.784 45.0718L137.746 44.857L137.719 45.0014L114.783 20.5578H114.785L114.778 20.5614ZM114.586 20.6228L132.54 39.7574L114.244 20.5145L114.586 20.621V20.6228ZM104.982 18.3754L105.485 18.4584L107.788 18.8682L108.145 18.9368L109.456 19.2076L109.469 19.2112L109.512 19.2202L110.401 19.4224L111.053 19.5722L111.122 19.5884L111.308 19.6336L111.365 19.648L113.918 20.4315L136.821 44.5194L103.137 18.1172L104.987 18.3772L104.982 18.3754ZM100.095 17.7797L101.114 17.8754L102.739 18.0613L102.777 18.0667L129.02 38.6382L136.877 44.7956L109.219 30.1233L93.1312 21.5886L97.5112 18.7346L99.11 17.693L100.095 17.7797ZM92.798 17.4692H94.2737H94.2755L95.9431 17.5125L96.126 17.5179L97.5872 17.5883H97.6089L98.8094 17.6696L97.14 18.7581L92.9972 21.4568L92.6351 20.5271L92.5753 20.3701L92.5626 20.3376L91.7587 18.1949L91.7515 18.1732L91.7279 18.1028L91.717 18.0685L91.6899 17.9873L91.603 17.48L92.7998 17.4656L92.798 17.4692ZM86.133 18.0775L86.314 18.0324L86.3629 18.0198L86.8971 17.8952L86.9224 17.8898L87.1379 17.8447L87.1958 17.8338L87.3823 17.7977L87.4022 17.7941H87.4059L89.164 17.5685H89.1857H89.1984L90.0639 17.5306L90.9548 17.4963H91.0272L91.4183 17.4891L91.5124 18.036L91.5161 18.0505L91.5432 18.1335L91.5541 18.1678L91.5776 18.2382L91.5849 18.2617L92.3888 20.408L92.4015 20.4405L92.463 20.5975L92.7781 21.4062L92.7183 21.3755L92.7346 21.4044L85.6169 18.2165L86.1293 18.0811L86.133 18.0775ZM85.3852 18.305L92.7727 21.6138L81.6045 29.6395L75.0988 34.3149L85.3852 18.3032V18.305ZM74.7928 19.9766L74.8688 19.9603L74.9811 19.935L85.1661 18.3122L74.7566 34.5135L71.2566 30.228L70.9904 24.6483L70.8129 20.9477L74.7928 19.9766ZM71.0791 30.2948L73.6792 33.4773L74.5864 34.5875L66.4927 35.1651L49.123 37.8783L57.8776 28.6828L57.9536 28.6178L58.5602 28.1178L58.6381 28.0546L64.5933 24.5671L70.6355 21.029L71.0791 30.2948ZM58.5348 27.9066L58.4461 27.9788L57.8395 28.4806L57.7599 28.5492L57.7563 28.5528L48.9673 37.7844V37.4071L49.965 33.0748L51.5547 30.6667L53.3328 28.9048L69.1489 21.6951L58.5367 27.9102L58.5348 27.9066ZM41.3824 37.5624L42.592 36.4811L42.7875 36.3078L43.8214 35.4251L45.0816 34.3907L45.2301 34.2698L46.3581 33.3834L46.3636 33.3798L47.2979 32.6758L48.138 32.0585L48.1887 32.0205L48.2159 32.0007L48.9528 31.4682L49.0017 31.4339L50.3778 30.488L50.519 30.3923L51.696 29.6197L51.7593 29.58L52.8222 28.9103L52.8439 28.8958L53.0594 28.9048L41.2629 39.7484L41.0855 39.965L40.6745 40.4741L40.2562 41.003L40.1186 41.1799L37.7665 44.422H37.7647L37.37 45.014L37.2197 45.2451L36.7055 46.043L36.7019 46.0502V46.0538L32.4613 53.9008L32.3454 54.159L32.1227 54.6554L31.7769 55.4478L32.3436 51.9928L32.3889 51.805L32.4269 51.6516L40.765 38.1364L41.3897 37.5606L41.3824 37.5624ZM29.4954 51.3231L29.8195 50.8537L30.6796 49.619L30.7176 49.5648L30.8516 49.3789L31.498 48.4998L31.9815 47.859L32.0286 47.7976L32.0992 47.7055L32.722 46.8914L32.7329 46.877L33.7179 45.6495L33.8265 45.5159L34.7138 44.4563L34.7282 44.44L35.7676 43.2486L35.9704 43.0175L36.7308 42.1836L36.8322 42.0734L36.8395 42.0662L37.9313 40.9145L38.0617 40.7792L39.0503 39.7791L39.8959 38.9578L40.2363 38.631L32.2458 51.5812L32.2422 51.5956L32.2006 51.7635L32.1553 51.9549V51.9585L31.4926 55.9894L30.5927 55.224L30.5836 55.215L29.4918 51.3213L29.4954 51.3231ZM16.5075 93.0889L16.5184 92.1755L16.522 91.9733L16.5691 90.578L16.656 88.9822L16.6868 88.484L16.7339 87.8522L16.7719 87.3901L16.9204 85.8412L16.9512 85.5398L17.0797 84.435V84.417L17.1069 84.2256L17.3242 82.6497L17.3513 82.4548L17.5704 81.0792L17.766 79.9925L17.8945 79.3264V79.3192L17.9126 79.2326L18.1643 77.9708V77.9635L18.5138 76.4129L18.5536 76.2396L18.8904 74.8803V74.8713L19.3068 73.3369L19.363 73.1347L19.6708 72.0787L19.7523 71.8098L20.2303 70.2952L20.2918 70.1021L20.7409 68.7789L21.2859 67.277L21.5122 66.6723L21.7005 66.1903L21.8617 65.786L22.4719 64.3003L22.6167 63.9555L22.8539 63.4068L23.111 62.8273L23.7629 61.4139L23.8679 61.19L24.4382 60.0167L25.1426 58.6339L25.1969 58.5274L25.8723 57.2674V57.2638L26.6346 55.91L26.6889 55.8143L27.4186 54.576V54.5723L27.998 53.6373L28.4235 52.9639L28.4543 52.9152L28.5322 52.7925L29.0681 51.9585L29.0772 51.9458L29.3578 51.5234L30.4225 55.3161L30.446 55.3377L30.4714 55.3612H30.4732L31.4238 56.1717L31.4184 56.1771L31.4292 56.1843L27.3534 61.8453L27.3371 61.8724L27.0782 62.2659L18.9049 79.3517C18.9049 79.3517 18.9012 79.3589 18.8994 79.3607V79.3661L18.8958 79.3697V79.3752V79.3788L18.8813 79.4293L18.7274 79.9402L16.5655 91.8849L16.5075 93.0889ZM19.6726 115.756L19.2344 114.225L19.1674 113.987L18.9845 113.312L18.827 112.695L18.3508 110.686L18.1136 109.612V109.608L18.1118 109.593L17.8167 108.102L17.7823 107.924L17.5306 106.492L17.5215 106.434L17.2879 104.92L17.2716 104.797L17.1014 103.53L17.0381 102.997L16.9095 101.783L16.8805 101.505L16.79 100.573V100.568L16.7791 100.452V100.427L16.7466 100.06L16.694 97.9195L16.6216 94.811V94.7858L16.7466 91.9138V91.9084L18.9031 79.9853L18.9411 79.8571C18.9628 80.2037 18.9882 80.7453 19.0171 81.4385C19.1692 85.1607 19.41 93.3543 19.6146 100.616C19.716 104.247 19.8084 107.646 19.8754 110.135C19.9369 112.415 19.9768 113.933 19.9822 114.175V114.202V114.207V114.222L20.1126 117.143L19.6726 115.756ZM22.9915 124.742L22.5588 123.737L22.2383 122.968L22.2003 122.876L22.1966 122.865L21.7585 121.793L21.7548 121.782L21.1845 120.284L21.1537 120.202L20.6467 118.787L20.5435 118.486L20.5381 118.468L20.5109 118.385L20.3226 117.462L20.1633 114.233L30.1817 102.086L30.2088 102.311L30.245 102.189L30.2505 102.21V102.214L35.9776 117.513L36.0192 117.601L36.4212 118.435L36.5389 118.677L36.8576 119.321L37.0459 119.695L37.2414 120.08L37.5529 120.684L37.647 120.867L43.3235 130.436L23.2161 125.242L22.9897 124.739L22.9915 124.742ZM28.916 135.636L28.103 134.366L28.0541 134.288L27.2737 133.017V133.014L27.2683 133.006L27.2593 132.992L26.4825 131.66L26.4264 131.562L25.7347 130.32V130.317L25.7311 130.309V130.306L25.1842 129.273L24.9561 128.84L24.3133 127.566L24.3079 127.557L23.7683 126.423L23.3174 125.459L30.6905 127.363L43.3198 130.625L43.3054 130.638L43.4321 130.66L43.4393 130.762L43.4846 130.725L52.824 149.915L47.8012 153.228L30.4207 137.839L30.1129 137.398L28.9196 135.636H28.916ZM70.3567 166.277L69.8605 166.156L69.5201 166.071L69.0294 165.943L68.6945 165.855L68.1893 165.716L67.8742 165.627L67.3256 165.467L67.0594 165.387L66.2483 165.136L65.2633 164.813L65.0369 164.736L64.0718 164.398L63.9614 164.356L63.0868 164.03L62.875 163.948L61.9371 163.577L61.9244 163.571L61.7089 163.483L61.1657 163.255L60.8869 163.136L60.3745 162.912L60.1065 162.795L59.5307 162.533L59.3406 162.447L58.5837 162.087L58.4135 162.003L57.8341 161.715L57.5752 161.584L57.0791 161.329L57.003 161.289L56.8111 161.188L56.3023 160.916L56.0687 160.789L55.3408 160.385L53.8706 159.522L53.0594 159.037L52.9996 159.001L51.6923 158.181L51.6398 158.147L51.1636 157.836L50.1153 157.141L48.7446 156.192L47.4156 155.224L47.2598 155.11L46.1083 154.233H46.1046V154.23L45.2826 153.578L44.3791 152.843L43.6095 152.21L43.577 152.182L42.3548 151.125L42.295 151.072L41.176 150.065L41.1543 150.045L41.147 150.038L39.9774 148.937L39.8325 148.8L38.8421 147.827L38.824 147.809L37.7176 146.679L37.6452 146.605L36.9427 145.864L36.6258 145.521L35.5666 144.344L35.4109 144.169L34.9419 143.633L34.5309 143.151L33.5296 141.944L33.4065 141.794L32.5464 140.713L31.6012 139.472L31.4745 139.304L30.8788 138.49L47.7397 153.417L47.7469 153.421L47.8139 153.461L48.1525 153.663L70.6065 166.338L70.3567 166.279V166.277ZM100.459 169.996C100.341 169.996 100.224 169.996 100.102 169.996H100.1C92.9718 169.996 82.3776 168.508 73.2012 166.88L72.3502 166.714L72.1257 166.667L71.5191 166.541L71.3 166.492L73.4963 156.861L74.3564 153.094L107.95 159.457L107.792 159.602L107.915 159.557L101.076 169.133L100.51 169.469L74.8453 153.262L74.7493 153.415L100.508 169.68L100.817 169.496L100.463 169.994L100.459 169.996ZM114.272 167.393L113.584 167.582L113.177 167.694L112.018 167.997L111.314 168.176L111.249 168.192L110.454 168.38L110.418 168.387L108.022 168.895L105.918 169.279L105.882 169.285L103.715 169.617L103.693 169.62L102.954 169.718L102.11 169.817V169.808L101.842 169.842L101.024 169.94L100.687 169.978L101.19 169.274L133.328 150.199L126.786 162.066L114.483 167.335L114.265 167.396L114.272 167.393ZM143.256 151.749L142.517 152.383L141.257 153.417L141.083 153.56L140.203 154.253L139.982 154.424H139.978L138.66 155.415L138.485 155.545L137.632 156.163L137.335 156.372L137.326 156.378L136.301 157.083L135.801 157.425L134.579 158.226L133.141 159.123L132.859 159.297L131.917 159.856L131.698 159.983L130.195 160.831L130.032 160.921L128.919 161.519L128.687 161.64L128.072 161.952L126.969 162.508L125.939 163.004L125.529 163.196L123.864 163.945L123.726 164.006L122.194 164.651L121.142 165.066L119.637 165.644L119.603 165.656L118.901 165.907L118.779 165.95L118.642 165.999L116.869 166.595L116.085 166.839L126.918 162.199L133.563 150.148L133.572 150.168L133.63 150.038L141.566 150.422L141.825 150.455L141.892 150.464L142.081 150.491L142.164 150.504L142.338 150.531L142.419 150.545L142.597 150.576L142.647 150.585L142.81 150.617L142.863 150.628L143.21 150.709L143.245 150.718L143.382 150.758L143.401 150.764L143.526 150.803L143.593 150.827L143.622 150.838L144.005 151.049L144 151.076L143.98 151.117L143.899 151.191L143.861 151.224L143.258 151.746L143.256 151.749ZM162.217 126.876L161.994 127.405L161.218 129.132L160.843 129.838L160.462 130.544L159.698 131.9L159.602 132.068L158.913 133.236L158.094 134.559L158.029 134.663L157.252 135.866L156.379 137.156L156.305 137.266L155.483 138.433L154.735 139.447L154.299 140.027L153.613 140.92L153.6 140.935V140.938L152.91 141.797L152.508 142.296L151.625 143.35L151.608 143.37L150.565 144.563L149.593 145.637L149.537 145.697L149.215 146.04L148.403 146.893L148.19 147.115L147.351 147.962L147.286 148.027L146.129 149.15L145.992 149.282L144.952 150.247L144.215 150.908L144.177 150.941L143.694 150.675L143.654 150.661L143.583 150.635L143.455 150.594H143.453L143.433 150.587L143.296 150.547L143.259 150.538H143.256L142.899 150.453L142.847 150.442L142.684 150.41L142.633 150.399L142.454 150.366L142.372 150.354L142.198 150.325L142.115 150.312L141.927 150.285L141.86 150.276L141.601 150.242H141.599H141.595L133.884 149.868L145.135 143.092L154.811 135.512L154.915 135.416L155.116 135.227L162.186 126.831L162.347 126.566L162.222 126.874L162.217 126.876ZM162.032 126.728L154.978 135.106L154.784 135.286L154.688 135.376L145.027 142.945L133.779 149.72L145.012 124.533L144.976 124.056L154.962 134.517L155.092 134.393L144.981 123.798L144.956 123.778L142.705 94.3345L142.709 94.3128L159.95 109.283L163.146 124.363L162.758 125.542L162.038 126.728H162.032ZM163.58 123.029L163.255 124.02L160.111 109.185L142.751 94.1106L142.841 93.9933L142.749 94.0005L142.763 93.8994L144.027 91.9354L144.219 91.6322L144.223 91.6249L153.875 71.974L155.279 74.0463L165.703 99.3564L163.582 123.026L163.58 123.029ZM167.444 111.187L167.434 111.236L167.363 111.548L163.83 122.271L165.885 99.3311L155.438 73.9615L153.979 71.8062L159.387 66.4412L161.513 61.7244L166.785 76.2811L166.812 76.3858L166.865 76.5916L169.155 92.8398L167.444 111.187Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.223 142.9C102.223 141.496 103.365 140.357 104.774 140.357C106.183 140.357 107.325 141.496 107.325 142.9C107.325 144.305 106.183 145.444 104.774 145.444C103.365 145.444 102.223 144.305 102.223 142.9Z",
    fill: "url(#paint2_radial_3437_366)",
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.1133 66.5918C48.1133 65.1874 49.2558 64.0483 50.6645 64.0483C52.0732 64.0483 53.2157 65.1874 53.2157 66.5918C53.2157 67.9962 52.0732 69.1353 50.6645 69.1353C49.2558 69.1353 48.1133 67.9962 48.1133 66.5918Z",
    fill: "url(#paint3_radial_3437_366)",
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.791 45.3521C134.791 43.9476 135.934 42.8086 137.342 42.8086C138.751 42.8086 139.893 43.9476 139.893 45.3521C139.893 46.7565 138.751 47.8955 137.342 47.8955C135.934 47.8955 134.791 46.7565 134.791 45.3521Z",
    fill: "url(#paint4_radial_3437_366)",
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.086 94.1362C140.086 92.7318 141.228 91.5928 142.637 91.5928C144.046 91.5928 145.188 92.7318 145.188 94.1362C145.188 95.5407 144.046 96.6797 142.637 96.6797C141.228 96.6797 140.086 95.5407 140.086 94.1362Z",
    fill: "url(#paint5_radial_3437_366)",
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.8262 135.495C66.8262 134.09 67.9687 132.951 69.3774 132.951C70.7861 132.951 71.9286 134.09 71.9286 135.495C71.9286 136.899 70.7861 138.038 69.3774 138.038C67.9687 138.038 66.8262 136.899 66.8262 135.495Z",
    fill: "url(#paint6_radial_3437_366)",
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.252 48.2983C104.252 46.8939 105.394 45.7549 106.803 45.7549C108.212 45.7549 109.354 46.8939 109.354 48.2983C109.354 49.7028 108.212 50.8418 106.803 50.8418C105.394 50.8418 104.252 49.7028 104.252 48.2983Z",
    fill: "url(#paint7_radial_3437_366)",
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.7969 18.1919C82.7969 16.7875 83.9394 15.6484 85.3481 15.6484C86.7568 15.6484 87.8993 16.7875 87.8993 18.1919C87.8993 19.5963 86.7568 20.7354 85.3481 20.7354C83.9394 20.7354 82.7969 19.5963 82.7969 18.1919Z",
    fill: "url(#paint8_radial_3437_366)",
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.6582 102.133C27.6582 100.728 28.8007 99.5894 30.2094 99.5894C31.6181 99.5894 32.7606 100.728 32.7606 102.133C32.7606 103.537 31.6181 104.676 30.2094 104.676C28.8007 104.676 27.6582 103.537 27.6582 102.133Z",
    fill: "url(#paint9_radial_3437_366)",
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.0137 105.749C79.0137 103.807 80.5926 102.232 82.5409 102.232C84.4891 102.232 86.068 103.807 86.068 105.749C86.068 107.691 84.4891 109.265 82.5409 109.265C80.5926 109.265 79.0137 107.691 79.0137 105.749Z",
    fill: "url(#paint10_radial_3437_366)",
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.326 160.817C109.111 160.632 109.597 159.847 109.411 159.064C109.225 158.281 108.438 157.797 107.652 157.982C106.867 158.167 106.381 158.953 106.567 159.735C106.753 160.518 107.541 161.003 108.326 160.817Z",
    fill: "url(#paint11_radial_3437_366)",
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.043 170.087C99.043 169.282 99.6966 168.63 100.504 168.63C101.312 168.63 101.965 169.282 101.965 170.087C101.965 170.892 101.312 171.543 100.504 171.543C99.6966 171.543 99.043 170.892 99.043 170.087Z",
    fill: "url(#paint12_radial_3437_366)",
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.7305 166.563C69.7305 165.758 70.3841 165.106 71.1917 165.106C71.9992 165.106 72.6529 165.758 72.6529 166.563C72.6529 167.368 71.9992 168.019 71.1917 168.019C70.3841 168.019 69.7305 167.368 69.7305 166.563Z",
    fill: "url(#paint13_radial_3437_366)",
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.2988 55.6941C30.2988 54.889 30.9525 54.2373 31.76 54.2373C32.5676 54.2373 33.2212 54.889 33.2212 55.6941C33.2212 56.4992 32.5676 57.1508 31.76 57.1508C30.9525 57.1508 30.2988 56.4992 30.2988 55.6941Z",
    fill: "url(#paint14_radial_3437_366)",
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.6887 131.622C44.4897 131.523 45.0589 130.796 44.9601 129.997C44.8614 129.199 44.132 128.631 43.3311 128.73C42.5301 128.828 41.9609 129.556 42.0597 130.354C42.1585 131.153 42.8878 131.72 43.6887 131.622Z",
    fill: "url(#paint15_radial_3437_366)",
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.751 151.199C134.552 151.1 135.121 150.373 135.023 149.575C134.924 148.776 134.195 148.209 133.394 148.307C132.593 148.406 132.023 149.133 132.122 149.931C132.221 150.73 132.95 151.297 133.751 151.199Z",
    fill: "url(#paint16_radial_3437_366)",
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.844 119.08C137.629 118.894 138.115 118.109 137.929 117.326C137.743 116.543 136.955 116.059 136.17 116.245C135.385 116.43 134.899 117.215 135.085 117.998C135.271 118.781 136.058 119.265 136.844 119.08Z",
    fill: "url(#paint17_radial_3437_366)",
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.734 123.867C142.734 123.062 143.388 122.411 144.196 122.411C145.003 122.411 145.657 123.062 145.657 123.867C145.657 124.672 145.003 125.324 144.196 125.324C143.388 125.324 142.734 124.672 142.734 123.867Z",
    fill: "url(#paint18_radial_3437_366)",
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.0373 154.494C75.7822 154.184 76.1345 153.332 75.8241 152.589C75.5137 151.846 74.6582 151.495 73.9133 151.804C73.1683 152.114 72.8161 152.967 73.1265 153.709C73.4368 154.452 74.2923 154.803 75.0373 154.494Z",
    fill: "url(#paint19_radial_3437_366)",
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.6875 149.647C51.6875 148.842 52.3412 148.19 53.1487 148.19C53.9563 148.19 54.6099 148.842 54.6099 149.647C54.6099 150.452 53.9563 151.103 53.1487 151.103C52.3412 151.103 51.6875 150.452 51.6875 149.647Z",
    fill: "url(#paint20_radial_3437_366)",
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.9199 113.65C62.9199 112.845 63.5736 112.193 64.3811 112.193C65.1887 112.193 65.8423 112.845 65.8423 113.65C65.8423 114.455 65.1887 115.107 64.3811 115.107C63.5736 115.107 62.9199 114.455 62.9199 113.65Z",
    fill: "url(#paint21_radial_3437_366)",
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.9355 113.876C86.9355 113.071 87.5892 112.419 88.3968 112.419C89.2043 112.419 89.858 113.071 89.858 113.876C89.858 114.681 89.2043 115.332 88.3968 115.332C87.5892 115.332 86.9355 114.681 86.9355 113.876Z",
    fill: "url(#paint22_radial_3437_366)",
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.693 117.046C123.693 116.241 124.347 115.589 125.155 115.589C125.962 115.589 126.616 116.241 126.616 117.046C126.616 117.851 125.962 118.502 125.155 118.502C124.347 118.502 123.693 117.851 123.693 117.046Z",
    fill: "url(#paint23_radial_3437_366)",
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.011 126.89C163.812 126.791 164.381 126.064 164.282 125.265C164.184 124.467 163.454 123.9 162.653 123.998C161.852 124.096 161.283 124.824 161.382 125.622C161.481 126.421 162.21 126.988 163.011 126.89Z",
    fill: "url(#paint24_radial_3437_366)",
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.395 135.9C156.175 135.694 156.64 134.897 156.433 134.119C156.227 133.341 155.427 132.878 154.647 133.084C153.867 133.29 153.402 134.087 153.608 134.865C153.815 135.643 154.615 136.106 155.395 135.9Z",
    fill: "url(#paint25_radial_3437_366)",
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.15 138.74C125.15 137.935 125.804 137.283 126.612 137.283C127.419 137.283 128.073 137.935 128.073 138.74C128.073 139.545 127.419 140.197 126.612 140.197C125.804 140.197 125.15 139.545 125.15 138.74Z",
    fill: "url(#paint26_radial_3437_366)",
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.361 71.7961C152.361 70.991 153.015 70.3394 153.823 70.3394C154.63 70.3394 155.284 70.991 155.284 71.7961C155.284 72.6012 154.63 73.2529 153.823 73.2529C153.015 73.2529 152.361 72.6012 152.361 71.7961Z",
    fill: "url(#paint27_radial_3437_366)",
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.4512 21.5959C91.4512 20.7908 92.1048 20.1392 92.9124 20.1392C93.7199 20.1392 94.3736 20.7908 94.3736 21.5959C94.3736 22.401 93.7199 23.0527 92.9124 23.0527C92.1048 23.0527 91.4512 22.401 91.4512 21.5959Z",
    fill: "url(#paint28_radial_3437_366)",
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.818 62.9C162.604 62.7145 163.089 61.9295 162.903 61.1466C162.717 60.3638 161.93 59.8795 161.144 60.065C160.359 60.2505 159.873 61.0355 160.06 61.8184C160.246 62.6013 161.033 63.0855 161.818 62.9Z",
    fill: "url(#paint29_radial_3437_366)",
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.388 22.3261C71.1889 22.2277 71.7581 21.5005 71.6594 20.702C71.5606 19.9035 70.8312 19.336 70.0303 19.4345C69.2294 19.533 68.6601 20.2601 68.7589 21.0586C68.8577 21.8571 69.587 22.4246 70.388 22.3261Z",
    fill: "url(#paint30_radial_3437_366)",
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.23 21.5898C115.031 21.4913 115.6 20.7642 115.501 19.9657C115.402 19.1672 114.673 18.5997 113.872 18.6982C113.071 18.7966 112.502 19.5238 112.601 20.3223C112.699 21.1208 113.429 21.6883 114.23 21.5898Z",
    fill: "url(#paint31_radial_3437_366)",
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.203 36.1457C142.203 35.3406 142.857 34.689 143.664 34.689C144.472 34.689 145.126 35.3406 145.126 36.1457C145.126 36.9508 144.472 37.6025 143.664 37.6025C142.857 37.6025 142.203 36.9508 142.203 36.1457Z",
    fill: "url(#paint32_radial_3437_366)",
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.625 17.6013C97.625 16.7962 98.2787 16.1445 99.0862 16.1445C99.8938 16.1445 100.547 16.7962 100.547 17.6013C100.547 18.4064 99.8938 19.0581 99.0862 19.0581C98.2787 19.0581 97.625 18.4064 97.625 17.6013Z",
    fill: "url(#paint33_radial_3437_366)",
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.3802 39.4589C50.1811 39.3605 50.7503 38.6333 50.6515 37.8348C50.5528 37.0363 49.8234 36.4688 49.0225 36.5673C48.2216 36.6658 47.6523 37.3929 47.7511 38.1914C47.8499 38.9899 48.5792 39.5574 49.3802 39.4589Z",
    fill: "url(#paint34_radial_3437_366)",
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.7111 30.1501C54.456 29.8407 54.8083 28.9878 54.4979 28.2451C54.1875 27.5024 53.332 27.1513 52.5871 27.4607C51.8422 27.7701 51.4899 28.623 51.8003 29.3657C52.1107 30.1084 52.9662 30.4595 53.7111 30.1501Z",
    fill: "url(#paint35_radial_3437_366)",
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.1516 53.6328C29.9526 53.5343 30.5218 52.8072 30.423 52.0087C30.3243 51.2102 29.5949 50.6427 28.794 50.7411C27.993 50.8396 27.4238 51.5667 27.5226 52.3652C27.6214 53.1637 28.3507 53.7312 29.1516 53.6328Z",
    fill: "url(#paint36_radial_3437_366)",
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5625 117.046C18.5625 116.241 19.2162 115.589 20.0237 115.589C20.8313 115.589 21.4849 116.241 21.4849 117.046C21.4849 117.851 20.8313 118.502 20.0237 118.502C19.2162 118.502 18.5625 117.851 18.5625 117.046Z",
    fill: "url(#paint37_radial_3437_366)",
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.6504 96.9104C39.6504 96.1053 40.304 95.4536 41.1116 95.4536C41.9192 95.4536 42.5728 96.1053 42.5728 96.9104C42.5728 97.7155 41.9192 98.3671 41.1116 98.3671C40.304 98.3671 39.6504 97.7155 39.6504 96.9104Z",
    fill: "url(#paint38_radial_3437_366)",
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.1094 87.3319C37.8416 86.9936 38.16 86.1276 37.8206 85.3976C37.4812 84.6677 36.6126 84.3503 35.8804 84.6886C35.1482 85.027 34.8298 85.893 35.1692 86.6229C35.5086 87.3529 36.3773 87.6703 37.1094 87.3319Z",
    fill: "url(#paint39_radial_3437_366)",
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8652 93.8493C17.6504 93.6638 18.1362 92.8787 17.9501 92.0959C17.764 91.313 16.9766 90.8287 16.1914 91.0142C15.4061 91.1997 14.9204 91.9847 15.1064 92.7676C15.2925 93.5505 16.0799 94.0348 16.8652 93.8493Z",
    fill: "url(#paint40_radial_3437_366)",
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5176 79.4441C17.5176 78.639 18.1712 77.9873 18.9788 77.9873C19.7863 77.9873 20.44 78.639 20.44 79.4441C20.44 80.2492 19.7863 80.9008 18.9788 80.9008C18.1712 80.9008 17.5176 80.2492 17.5176 79.4441Z",
    fill: "url(#paint41_radial_3437_366)",
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.8341 79.4348C28.6349 79.3349 29.2028 78.6068 29.1027 77.8085C29.0025 77.0102 28.2721 76.4439 27.4714 76.5438C26.6706 76.6437 26.1027 77.3718 26.2029 78.1701C26.303 78.9684 27.0334 79.5346 27.8341 79.4348Z",
    fill: "url(#paint42_radial_3437_366)",
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.4902 126.74C24.2754 126.554 24.7612 125.769 24.5751 124.986C24.389 124.204 23.6016 123.719 22.8164 123.905C22.0311 124.09 21.5454 124.875 21.7314 125.658C21.9175 126.441 22.7049 126.925 23.4902 126.74Z",
    fill: "url(#paint43_radial_3437_366)",
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9746 138.112C28.9746 137.307 29.6283 136.655 30.4358 136.655C31.2434 136.655 31.897 137.307 31.897 138.112C31.897 138.917 31.2434 139.569 30.4358 139.569C29.6283 139.569 28.9746 138.917 28.9746 138.112Z",
    fill: "url(#paint44_radial_3437_366)",
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.134 68.0408C131.934 67.9373 132.498 67.2066 132.395 66.4088C132.291 65.6109 131.558 65.048 130.758 65.1515C129.957 65.255 129.393 65.9857 129.497 66.7835C129.6 67.5814 130.333 68.1443 131.134 68.0408Z",
    fill: "url(#paint45_radial_3437_366)",
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.3723 35.9983C76.1066 35.6644 76.4303 34.8004 76.0953 34.0684C75.7604 33.3364 74.8937 33.0137 74.1595 33.3476C73.4253 33.6815 73.1016 34.5455 73.4365 35.2775C73.7714 36.0095 74.6381 36.3322 75.3723 35.9983Z",
    fill: "url(#paint46_radial_3437_366)",
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.492 152.519C145.277 152.333 145.763 151.548 145.577 150.765C145.391 149.982 144.604 149.498 143.818 149.684C143.033 149.869 142.547 150.654 142.733 151.437C142.919 152.22 143.707 152.704 144.492 152.519Z",
    fill: "url(#paint47_radial_3437_366)",
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.046 163.585C127.846 163.477 128.405 162.742 128.296 161.945C128.187 161.148 127.451 160.59 126.651 160.699C125.851 160.807 125.292 161.542 125.401 162.339C125.51 163.136 126.246 163.694 127.046 163.585Z",
    fill: "url(#paint48_radial_3437_366)",
    style: {}
  })), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M137.403 54.9462C142.843 54.9462 147.253 50.5497 147.253 45.1262C147.253 39.7027 142.843 35.3062 137.403 35.3062C131.963 35.3062 127.553 39.7027 127.553 45.1262C127.553 50.5497 131.963 54.9462 137.403 54.9462Z",
    fill: "url(#paint49_radial_3437_366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    opacity: 0.7,
    d: "M97.6012 108.244C98.928 99.8734 93.1974 92.0156 84.8015 90.6929C76.4057 89.3702 68.524 95.0833 67.1972 103.454C65.8705 111.824 71.6011 119.682 79.9969 121.004C88.3927 122.327 96.2745 116.614 97.6012 108.244Z",
    fill: "url(#paint50_radial_3437_366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M142.487 104.036C147.927 104.036 152.337 99.639 152.337 94.2156C152.337 88.7921 147.927 84.3955 142.487 84.3955C137.047 84.3955 132.637 88.7921 132.637 94.2156C132.637 99.639 137.047 104.036 142.487 104.036Z",
    fill: "url(#paint51_radial_3437_366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M109.906 56.2552C114.315 54.4943 116.458 49.5031 114.691 45.1071C112.925 40.7111 107.919 38.575 103.509 40.336C99.0999 42.0969 96.9573 47.0881 98.7236 51.484C100.49 55.88 105.496 58.0161 109.906 56.2552Z",
    fill: "url(#paint52_radial_3437_366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M50.5186 74.9473C55.2686 74.9473 59.1193 71.1084 59.1193 66.3728C59.1193 61.6373 55.2686 57.7983 50.5186 57.7983C45.7686 57.7983 41.918 61.6373 41.918 66.3728C41.918 71.1084 45.7686 74.9473 50.5186 74.9473Z",
    fill: "url(#paint53_radial_3437_366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M30.3014 114.95C37.4264 114.95 43.2023 109.191 43.2023 102.088C43.2023 94.9845 37.4264 89.2261 30.3014 89.2261C23.1764 89.2261 17.4004 94.9845 17.4004 102.088C17.4004 109.191 23.1764 114.95 30.3014 114.95Z",
    fill: "url(#paint54_radial_3437_366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M69.3775 148.387C76.5025 148.387 82.2785 142.628 82.2785 135.525C82.2785 128.421 76.5025 122.663 69.3775 122.663C62.2525 122.663 56.4766 128.421 56.4766 135.525C56.4766 142.628 62.2525 148.387 69.3775 148.387Z",
    fill: "url(#paint55_radial_3437_366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M104.737 155.793C111.862 155.793 117.638 150.035 117.638 142.932C117.638 135.828 111.862 130.07 104.737 130.07C97.6119 130.07 91.8359 135.828 91.8359 142.932C91.8359 150.035 97.6119 155.793 104.737 155.793Z",
    fill: "url(#paint56_radial_3437_366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M125.111 123.363C128.611 123.363 131.448 120.534 131.448 117.045C131.448 113.556 128.611 110.727 125.111 110.727C121.611 110.727 118.773 113.556 118.773 117.045C118.773 120.534 121.611 123.363 125.111 123.363Z",
    fill: "url(#paint57_radial_3437_366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M136.505 124.153C140.005 124.153 142.843 121.324 142.843 117.835C142.843 114.345 140.005 111.517 136.505 111.517C133.005 111.517 130.168 114.345 130.168 117.835C130.168 121.324 133.005 124.153 136.505 124.153Z",
    fill: "url(#paint58_radial_3437_366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M88.3959 120.193C91.8959 120.193 94.7332 117.365 94.7332 113.875C94.7332 110.386 91.8959 107.557 88.3959 107.557C84.8959 107.557 82.0586 110.386 82.0586 113.875C82.0586 117.365 84.8959 120.193 88.3959 120.193Z",
    fill: "url(#paint59_radial_3437_366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M64.3803 119.968C67.8803 119.968 70.7176 117.139 70.7176 113.65C70.7176 110.161 67.8803 107.332 64.3803 107.332C60.8803 107.332 58.043 110.161 58.043 113.65C58.043 117.139 60.8803 119.968 64.3803 119.968Z",
    fill: "url(#paint60_radial_3437_366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M144.197 130.185C147.697 130.185 150.534 127.356 150.534 123.867C150.534 120.378 147.697 117.549 144.197 117.549C140.697 117.549 137.859 120.378 137.859 123.867C137.859 127.356 140.697 130.185 144.197 130.185Z",
    fill: "url(#paint61_radial_3437_366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M126.613 148.231C131.863 148.231 136.119 143.988 136.119 138.754C136.119 133.52 131.863 129.277 126.613 129.277C121.363 129.277 117.107 133.52 117.107 138.754C117.107 143.988 121.363 148.231 126.613 148.231Z",
    fill: "url(#paint62_radial_3437_366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M133.576 159.279C138.826 159.279 143.082 155.036 143.082 149.802C143.082 144.568 138.826 140.325 133.576 140.325C128.326 140.325 124.07 144.568 124.07 149.802C124.07 155.036 128.326 159.279 133.576 159.279Z",
    fill: "url(#paint63_radial_3437_366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M144.195 160.581C149.445 160.581 153.701 156.338 153.701 151.104C153.701 145.869 149.445 141.626 144.195 141.626C138.945 141.626 134.689 145.869 134.689 151.104C134.689 156.338 138.945 160.581 144.195 160.581Z",
    fill: "url(#paint64_radial_3437_366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M155.022 143.966C160.272 143.966 164.528 139.723 164.528 134.489C164.528 129.255 160.272 125.012 155.022 125.012C149.772 125.012 145.516 129.255 145.516 134.489C145.516 139.723 149.772 143.966 155.022 143.966Z",
    fill: "url(#paint65_radial_3437_366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M162.833 131.756C166.333 131.756 169.171 128.927 169.171 125.438C169.171 121.948 166.333 119.12 162.833 119.12C159.333 119.12 156.496 121.948 156.496 125.438C156.496 128.927 159.333 131.756 162.833 131.756Z",
    fill: "url(#paint66_radial_3437_366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M126.731 171.85C131.981 171.85 136.237 167.607 136.237 162.373C136.237 157.139 131.981 152.896 126.731 152.896C121.481 152.896 117.225 157.139 117.225 162.373C117.225 167.607 121.481 171.85 126.731 171.85Z",
    fill: "url(#paint67_radial_3437_366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M107.988 168.777C113.238 168.777 117.494 164.534 117.494 159.3C117.494 154.066 113.238 149.823 107.988 149.823C102.738 149.823 98.4824 154.066 98.4824 159.3C98.4824 164.534 102.738 168.777 107.988 168.777Z",
    fill: "url(#paint68_radial_3437_366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M100.19 179.655C105.44 179.655 109.696 175.412 109.696 170.178C109.696 164.944 105.44 160.701 100.19 160.701C94.9396 160.701 90.6836 164.944 90.6836 170.178C90.6836 175.412 94.9396 179.655 100.19 179.655Z",
    fill: "url(#paint69_radial_3437_366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M74.4689 162.633C79.7189 162.633 83.9748 158.39 83.9748 153.156C83.9748 147.922 79.7189 143.679 74.4689 143.679C69.2189 143.679 64.9629 147.922 64.9629 153.156C64.9629 158.39 69.2189 162.633 74.4689 162.633Z",
    fill: "url(#paint70_radial_3437_366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M71.1915 176.04C76.4415 176.04 80.6975 171.797 80.6975 166.563C80.6975 161.328 76.4415 157.085 71.1915 157.085C65.9415 157.085 61.6855 161.328 61.6855 166.563C61.6855 171.797 65.9415 176.04 71.1915 176.04Z",
    fill: "url(#paint71_radial_3437_366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M53.1486 159.279C58.3986 159.279 62.6545 155.036 62.6545 149.802C62.6545 144.568 58.3986 140.325 53.1486 140.325C47.8986 140.325 43.6426 144.568 43.6426 149.802C43.6426 155.036 47.8986 159.279 53.1486 159.279Z",
    fill: "url(#paint72_radial_3437_366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M30.34 147.515C35.59 147.515 39.8459 143.272 39.8459 138.038C39.8459 132.804 35.59 128.561 30.34 128.561C25.09 128.561 20.834 132.804 20.834 138.038C20.834 143.272 25.09 147.515 30.34 147.515Z",
    fill: "url(#paint73_radial_3437_366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M43.3947 139.881C48.6447 139.881 52.9006 135.638 52.9006 130.404C52.9006 125.17 48.6447 120.927 43.3947 120.927C38.1446 120.927 33.8887 125.17 33.8887 130.404C33.8887 135.638 38.1446 139.881 43.3947 139.881Z",
    fill: "url(#paint74_radial_3437_366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M23.1505 134.935C28.4005 134.935 32.6565 130.692 32.6565 125.458C32.6565 120.223 28.4005 115.98 23.1505 115.98C17.9005 115.98 13.6445 120.223 13.6445 125.458C13.6445 130.692 17.9005 134.935 23.1505 134.935Z",
    fill: "url(#paint75_radial_3437_366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M20.0255 126.62C25.2755 126.62 29.5315 122.377 29.5315 117.143C29.5315 111.909 25.2755 107.666 20.0255 107.666C14.7755 107.666 10.5195 111.909 10.5195 117.143C10.5195 122.377 14.7755 126.62 20.0255 126.62Z",
    fill: "url(#paint76_radial_3437_366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M41.2592 103.229C44.7592 103.229 47.5965 100.4 47.5965 96.9108C47.5965 93.4215 44.7592 90.5928 41.2592 90.5928C37.7592 90.5928 34.9219 93.4215 34.9219 96.9108C34.9219 100.4 37.7592 103.229 41.2592 103.229Z",
    fill: "url(#paint77_radial_3437_366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M36.5014 92.3978C40.0014 92.3978 42.8387 89.5691 42.8387 86.0798C42.8387 82.5904 40.0014 79.7617 36.5014 79.7617C33.0014 79.7617 30.1641 82.5904 30.1641 86.0798C30.1641 89.5691 33.0014 92.3978 36.5014 92.3978Z",
    fill: "url(#paint78_radial_3437_366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M27.6576 84.3055C31.1576 84.3055 33.995 81.4768 33.995 77.9875C33.995 74.4981 31.1576 71.6694 27.6576 71.6694C24.1576 71.6694 21.3203 74.4981 21.3203 77.9875C21.3203 81.4768 24.1576 84.3055 27.6576 84.3055Z",
    fill: "url(#paint79_radial_3437_366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M19.1017 88.8955C24.3517 88.8955 28.6077 84.6525 28.6077 79.4185C28.6077 74.1844 24.3517 69.9414 19.1017 69.9414C13.8517 69.9414 9.5957 74.1844 9.5957 79.4185C9.5957 84.6525 13.8517 88.8955 19.1017 88.8955Z",
    fill: "url(#paint80_radial_3437_366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M16.3165 101.875C21.5665 101.875 25.8225 97.632 25.8225 92.398C25.8225 87.1639 21.5665 82.9209 16.3165 82.9209C11.0665 82.9209 6.81055 87.1639 6.81055 92.398C6.81055 97.632 11.0665 101.875 16.3165 101.875Z",
    fill: "url(#paint81_radial_3437_366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M28.976 58.5023C32.476 58.5023 35.3133 55.6736 35.3133 52.1843C35.3133 48.6949 32.476 45.8662 28.976 45.8662C25.476 45.8662 22.6387 48.6949 22.6387 52.1843C22.6387 55.6736 25.476 58.5023 28.976 58.5023Z",
    fill: "url(#paint82_radial_3437_366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M31.6947 62.1019C35.1947 62.1019 38.0321 59.2732 38.0321 55.7839C38.0321 52.2945 35.1947 49.4658 31.6947 49.4658C28.1947 49.4658 25.3574 52.2945 25.3574 55.7839C25.3574 59.2732 28.1947 62.1019 31.6947 62.1019Z",
    fill: "url(#paint83_radial_3437_366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M49.2026 44.3285C52.7026 44.3285 55.5399 41.4998 55.5399 38.0104C55.5399 34.5211 52.7026 31.6924 49.2026 31.6924C45.7025 31.6924 42.8652 34.5211 42.8652 38.0104C42.8652 41.4998 45.7025 44.3285 49.2026 44.3285Z",
    fill: "url(#paint84_radial_3437_366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M53.2182 35.1278C56.7182 35.1278 59.5555 32.2991 59.5555 28.8097C59.5555 25.3204 56.7182 22.4917 53.2182 22.4917C49.7182 22.4917 46.8809 25.3204 46.8809 28.8097C46.8809 32.2991 49.7182 35.1278 53.2182 35.1278Z",
    fill: "url(#paint85_radial_3437_366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M61.1446 68.7766C78.6955 62.673 91.9888 55.0543 90.8361 51.7596C89.6833 48.4649 74.521 50.742 56.9701 56.8455C39.4192 62.9491 26.1259 70.5678 27.2787 73.8625C28.4314 77.1572 43.5937 74.8801 61.1446 68.7766Z",
    fill: "url(#paint86_radial_3437_366)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.303 56.1631C116.325 51.9535 127.735 45.8178 126.788 42.4586C125.841 39.0994 112.895 39.7888 97.8733 43.9984C82.8515 48.208 71.4416 54.3438 72.3887 57.7029C73.3358 61.0621 86.2812 60.3727 101.303 56.1631Z",
    fill: "url(#paint87_radial_3437_366)",
    style: {
      mixBlendMode: "color-dodge"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M68.5166 119.086C71.4209 115.667 64.1166 104.741 52.202 94.6813C40.2874 84.6219 28.2743 79.2389 25.37 82.6579C22.4657 86.077 29.77 97.0033 41.6846 107.063C53.5992 117.122 65.6123 122.505 68.5166 119.086Z",
    fill: "url(#paint88_radial_3437_366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M130.877 161.053C144.323 153.141 153.371 143.599 151.087 139.741C148.803 135.882 136.051 139.168 122.605 147.08C109.16 154.992 100.112 164.534 102.396 168.392C104.68 172.25 117.432 168.964 130.877 161.053Z",
    fill: "url(#paint89_radial_3437_366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M128.735 164.022C129.682 159.642 118.076 153.434 102.814 150.155C87.5509 146.876 74.4107 147.769 73.464 152.149C72.5174 156.529 84.1229 162.737 99.3856 166.016C114.648 169.295 127.789 168.402 128.735 164.022Z",
    fill: "url(#paint90_radial_3437_366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M156.355 119.585C156.603 116.949 144.203 113.633 128.658 112.179C113.113 110.725 100.311 111.683 100.063 114.32C99.8144 116.956 112.215 120.272 127.76 121.726C143.304 123.18 156.107 122.222 156.355 119.585Z",
    fill: "url(#paint91_radial_3437_366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M44.4866 135.73C48.619 133.969 46.9952 120.939 40.8596 106.625C34.724 92.3122 26.4001 82.1363 22.2676 83.897C18.1352 85.6576 19.759 98.6881 25.8946 113.001C32.0302 127.315 40.3541 137.49 44.4866 135.73Z",
    fill: "url(#paint92_radial_3437_366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M81.3274 172.093C85.5956 170.69 85.0941 157.569 80.2073 142.786C75.3204 128.002 67.8988 117.155 63.6306 118.557C59.3624 119.959 59.8639 133.081 64.7508 147.864C69.6376 162.647 77.0592 173.495 81.3274 172.093Z",
    fill: "url(#paint93_radial_3437_366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M51.5712 76.3495C58.5239 65.5485 61.6316 55.1748 58.5126 53.1793C55.3937 51.1838 47.229 58.3221 40.2764 69.1232C33.3237 79.9242 30.2159 90.2979 33.3349 92.2934C36.4539 94.2889 44.6186 87.1506 51.5712 76.3495Z",
    fill: "url(#paint94_radial_3437_366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M32.3 62.985C37.1382 55.4688 39.3008 48.25 37.1303 46.8614C34.9598 45.4727 29.2781 50.44 24.44 57.9562C19.6018 65.4724 17.4392 72.6912 19.6097 74.0798C21.7802 75.4685 27.4619 70.5012 32.3 62.985Z",
    fill: "url(#paint95_radial_3437_366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M55.3983 41.7767C64.1271 39.7693 70.7332 36.1109 70.1535 33.6056C69.5738 31.1002 62.0277 30.6966 53.299 32.704C44.5702 34.7115 37.9641 38.3699 38.5438 40.8752C39.1235 43.3806 46.6695 43.7842 55.3983 41.7767Z",
    fill: "url(#paint96_radial_3437_366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M124.167 38.1633C124.819 36.9643 115.18 30.4979 102.638 23.7202C90.0964 16.9424 79.4007 12.42 78.7488 13.619C78.0968 14.818 87.7356 21.2845 100.278 28.0622C112.82 34.8399 123.515 39.3623 124.167 38.1633Z",
    fill: "url(#paint97_radial_3437_366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M135.496 42.3367C136.382 41.4629 130.584 34.1902 122.546 26.0926C114.508 17.995 107.274 12.1389 106.389 13.0126C105.503 13.8864 111.301 21.1591 119.339 29.2567C127.376 37.3544 134.61 43.2104 135.496 42.3367Z",
    fill: "url(#paint98_radial_3437_366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M19.4501 106.566C23.9821 106.566 27.656 98.048 27.656 87.54C27.656 77.032 23.9821 68.5137 19.4501 68.5137C14.9181 68.5137 11.2441 77.032 11.2441 87.54C11.2441 98.048 14.9181 106.566 19.4501 106.566Z",
    fill: "url(#paint99_radial_3437_366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M63.2615 164.191C65.9343 160.542 61.2007 152.561 52.6889 146.363C44.177 140.166 35.11 138.1 32.4372 141.749C29.7644 145.398 34.4979 153.38 43.0098 159.577C51.5217 165.774 60.5887 167.84 63.2615 164.191Z",
    fill: "url(#paint100_radial_3437_366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M82.7188 171.315C83.8273 168.894 77.8199 163.789 69.3008 159.911C60.7817 156.033 52.977 154.852 51.8685 157.273C50.76 159.693 56.7674 164.799 65.2865 168.677C73.8056 172.554 81.6103 173.736 82.7188 171.315Z",
    fill: "url(#paint101_radial_3437_366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M29.929 138.772C32.3283 137.606 30.9476 129.857 26.8452 121.464C22.7428 113.071 17.4721 107.212 15.0728 108.378C12.6735 109.543 14.0542 117.292 18.1566 125.685C22.259 134.078 27.5297 139.937 29.929 138.772Z",
    fill: "url(#paint102_radial_3437_366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M90.9269 97.986C94.6147 89.4038 95.6154 81.5972 93.162 80.5494C90.7087 79.5016 85.7303 85.6094 82.0425 94.1916C78.3548 102.774 77.3541 110.58 79.8074 111.628C82.2608 112.676 87.2392 106.568 90.9269 97.986Z",
    fill: "url(#paint103_radial_3437_366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M92.9551 107.907C102.069 105.761 108.96 101.922 108.347 99.3321C107.733 96.7425 99.8474 96.3831 90.7332 98.5293C81.619 100.676 74.7278 104.515 75.3414 107.104C75.955 109.694 83.8409 110.053 92.9551 107.907Z",
    fill: "url(#paint104_radial_3437_366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M112.246 146.001C121.36 143.855 128.251 140.015 127.638 137.426C127.024 134.836 119.138 134.477 110.024 136.623C100.91 138.769 94.0189 142.609 94.6324 145.198C95.246 147.788 103.132 148.147 112.246 146.001Z",
    fill: "url(#paint105_radial_3437_366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M43.4887 42.2797C51.6605 34.783 56.8292 27.1285 55.0335 25.1829C53.2377 23.2374 45.1574 27.7374 36.9857 35.2341C28.814 42.7308 23.6452 50.3853 25.441 52.3309C27.2367 54.2764 35.317 49.7764 43.4887 42.2797Z",
    fill: "url(#paint106_radial_3437_366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M70.2104 27.349C73.7104 27.349 76.5477 24.5203 76.5477 21.0309C76.5477 17.5416 73.7104 14.7129 70.2104 14.7129C66.7104 14.7129 63.873 17.5416 63.873 21.0309C63.873 24.5203 66.7104 27.349 70.2104 27.349Z",
    fill: "url(#paint107_radial_3437_366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M92.8256 27.9139C96.3256 27.9139 99.1629 25.0852 99.1629 21.5959C99.1629 18.1065 96.3256 15.2778 92.8256 15.2778C89.3256 15.2778 86.4883 18.1065 86.4883 21.5959C86.4883 25.0852 89.3256 27.9139 92.8256 27.9139Z",
    fill: "url(#paint108_radial_3437_366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M99.1635 24.0116C102.663 24.0116 105.501 21.1829 105.501 17.6935C105.501 14.2042 102.663 11.3755 99.1635 11.3755C95.6635 11.3755 92.8262 14.2042 92.8262 17.6935C92.8262 21.1829 95.6635 24.0116 99.1635 24.0116Z",
    fill: "url(#paint109_radial_3437_366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M114.052 26.4574C117.552 26.4574 120.389 23.6287 120.389 20.1393C120.389 16.65 117.552 13.8213 114.052 13.8213C110.552 13.8213 107.715 16.65 107.715 20.1393C107.715 23.6287 110.552 26.4574 114.052 26.4574Z",
    fill: "url(#paint110_radial_3437_366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M74.7455 40.8299C78.2455 40.8299 81.0828 38.0012 81.0828 34.5119C81.0828 31.0225 78.2455 28.1938 74.7455 28.1938C71.2455 28.1938 68.4082 31.0225 68.4082 34.5119C68.4082 38.0012 71.2455 40.8299 74.7455 40.8299Z",
    fill: "url(#paint111_radial_3437_366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M143.648 42.4417C147.148 42.4417 149.985 39.6131 149.985 36.1237C149.985 32.6343 147.148 29.8057 143.648 29.8057C140.148 29.8057 137.311 32.6343 137.311 36.1237C137.311 39.6131 140.148 42.4417 143.648 42.4417Z",
    fill: "url(#paint112_radial_3437_366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    opacity: 0.85,
    d: "M163.796 63.7897C162.919 64.7536 159.609 63.1868 156.404 60.2877C153.2 57.3904 151.313 54.2585 152.189 53.2945C153.066 52.3306 156.375 53.8974 159.58 56.7965C162.785 59.6938 164.672 62.8257 163.796 63.7897Z",
    fill: "url(#paint113_radial_3437_366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    opacity: 0.6,
    d: "M155.357 73.4986C156.488 72.8475 155.651 69.2912 153.488 65.5554C151.324 61.8195 148.654 59.3187 147.523 59.9697C146.391 60.6207 147.228 64.177 149.392 67.9129C151.555 71.6488 154.226 74.1496 155.357 73.4986Z",
    fill: "url(#paint114_radial_3437_366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M161.48 67.8622C164.98 67.8622 167.817 65.0335 167.817 61.5441C167.817 58.0548 164.98 55.2261 161.48 55.2261C157.98 55.2261 155.143 58.0548 155.143 61.5441C155.143 65.0335 157.98 67.8622 161.48 67.8622Z",
    fill: "url(#paint115_radial_3437_366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M130.949 72.7435C134.449 72.7435 137.286 69.9148 137.286 66.4255C137.286 62.9361 134.449 60.1074 130.949 60.1074C127.449 60.1074 124.611 62.9361 124.611 66.4255C124.611 69.9148 127.449 72.7435 130.949 72.7435Z",
    fill: "url(#paint116_radial_3437_366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M153.757 78.2943C157.257 78.2943 160.095 75.4656 160.095 71.9762C160.095 68.4869 157.257 65.6582 153.757 65.6582C150.257 65.6582 147.42 68.4869 147.42 71.9762C147.42 75.4656 150.257 78.2943 153.757 78.2943Z",
    fill: "url(#paint117_radial_3437_366)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M85.3116 26.795C90.0616 26.795 93.9122 22.956 93.9122 18.2205C93.9122 13.4849 90.0616 9.646 85.3116 9.646C80.5616 9.646 76.7109 13.4849 76.7109 18.2205C76.7109 22.956 80.5616 26.795 85.3116 26.795Z",
    fill: "url(#paint118_radial_3437_366)"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.8344 76.4228) rotate(7.51798) scale(63.0516 93.618)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#407BFF",
    style: (_ref2 = {
      stopColor: "#407BFF"
    }, _defineProperty(_ref2, "stopColor", "color(display-p3 0.2510 0.4824 1.0000)"), _defineProperty(_ref2, "stopOpacity", 1), _ref2)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(138.31 50.5628) rotate(-14.9564) scale(36.8849 52.6063)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#407BFF",
    style: (_ref3 = {
      stopColor: "#407BFF"
    }, _defineProperty(_ref3, "stopColor", "color(display-p3 0.2510 0.4824 1.0000)"), _defineProperty(_ref3, "stopOpacity", 1), _ref3)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(104.774 142.9) rotate(180) scale(2.55123 2.54346)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4E6",
    style: (_ref4 = {
      stopColor: "#FFF4E6"
    }, _defineProperty(_ref4, "stopColor", "color(display-p3 1.0000 0.9569 0.9020)"), _defineProperty(_ref4, "stopOpacity", 1), _ref4)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FBF0DD",
    style: (_ref5 = {
      stopColor: "#FBF0DD"
    }, _defineProperty(_ref5, "stopColor", "color(display-p3 0.9843 0.9412 0.8667)"), _defineProperty(_ref5, "stopOpacity", 1), _ref5)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F0E7C7",
    style: (_ref6 = {
      stopColor: "#F0E7C7"
    }, _defineProperty(_ref6, "stopColor", "color(display-p3 0.9412 0.9059 0.7804)"), _defineProperty(_ref6, "stopOpacity", 1), _ref6)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E4DDAB",
    style: (_ref7 = {
      stopColor: "#E4DDAB"
    }, _defineProperty(_ref7, "stopColor", "color(display-p3 0.8941 0.8667 0.6706)"), _defineProperty(_ref7, "stopOpacity", 1), _ref7)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#ECE8C6",
    stopOpacity: 0.4489,
    style: (_ref8 = {
      stopColor: "#ECE8C6"
    }, _defineProperty(_ref8, "stopColor", "color(display-p3 0.9255 0.9098 0.7765)"), _defineProperty(_ref8, "stopOpacity", 0.4489), _ref8)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F4F1DE",
    stopOpacity: 0.1444,
    style: (_ref9 = {
      stopColor: "#F4F1DE"
    }, _defineProperty(_ref9, "stopColor", "color(display-p3 0.9569 0.9451 0.8706)"), _defineProperty(_ref9, "stopOpacity", 0.1444), _ref9)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FAF9F0",
    stopOpacity: 0.0324,
    style: (_ref10 = {
      stopColor: "#FAF9F0"
    }, _defineProperty(_ref10, "stopColor", "color(display-p3 0.9804 0.9765 0.9412)"), _defineProperty(_ref10, "stopOpacity", 0.0324), _ref10)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#FDFDFA",
    stopOpacity: 0.01,
    style: (_ref11 = {
      stopColor: "#FDFDFA"
    }, _defineProperty(_ref11, "stopColor", "color(display-p3 0.9922 0.9922 0.9804)"), _defineProperty(_ref11, "stopOpacity", 0.01), _ref11)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.6663 66.5918) rotate(180) scale(2.55122 2.54346)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4E6",
    style: (_ref12 = {
      stopColor: "#FFF4E6"
    }, _defineProperty(_ref12, "stopColor", "color(display-p3 1.0000 0.9569 0.9020)"), _defineProperty(_ref12, "stopOpacity", 1), _ref12)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FBF0DD",
    style: (_ref13 = {
      stopColor: "#FBF0DD"
    }, _defineProperty(_ref13, "stopColor", "color(display-p3 0.9843 0.9412 0.8667)"), _defineProperty(_ref13, "stopOpacity", 1), _ref13)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F0E7C7",
    style: (_ref14 = {
      stopColor: "#F0E7C7"
    }, _defineProperty(_ref14, "stopColor", "color(display-p3 0.9412 0.9059 0.7804)"), _defineProperty(_ref14, "stopOpacity", 1), _ref14)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E4DDAB",
    style: (_ref15 = {
      stopColor: "#E4DDAB"
    }, _defineProperty(_ref15, "stopColor", "color(display-p3 0.8941 0.8667 0.6706)"), _defineProperty(_ref15, "stopOpacity", 1), _ref15)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#ECE8C6",
    stopOpacity: 0.4489,
    style: (_ref16 = {
      stopColor: "#ECE8C6"
    }, _defineProperty(_ref16, "stopColor", "color(display-p3 0.9255 0.9098 0.7765)"), _defineProperty(_ref16, "stopOpacity", 0.4489), _ref16)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F4F1DE",
    stopOpacity: 0.1444,
    style: (_ref17 = {
      stopColor: "#F4F1DE"
    }, _defineProperty(_ref17, "stopColor", "color(display-p3 0.9569 0.9451 0.8706)"), _defineProperty(_ref17, "stopOpacity", 0.1444), _ref17)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FAF9F0",
    stopOpacity: 0.0324,
    style: (_ref18 = {
      stopColor: "#FAF9F0"
    }, _defineProperty(_ref18, "stopColor", "color(display-p3 0.9804 0.9765 0.9412)"), _defineProperty(_ref18, "stopOpacity", 0.0324), _ref18)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#FDFDFA",
    stopOpacity: 0.01,
    style: (_ref19 = {
      stopColor: "#FDFDFA"
    }, _defineProperty(_ref19, "stopColor", "color(display-p3 0.9922 0.9922 0.9804)"), _defineProperty(_ref19, "stopOpacity", 0.01), _ref19)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(137.344 45.3521) rotate(180) scale(2.55123 2.54346)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4E6",
    style: (_ref20 = {
      stopColor: "#FFF4E6"
    }, _defineProperty(_ref20, "stopColor", "color(display-p3 1.0000 0.9569 0.9020)"), _defineProperty(_ref20, "stopOpacity", 1), _ref20)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FBF0DD",
    style: (_ref21 = {
      stopColor: "#FBF0DD"
    }, _defineProperty(_ref21, "stopColor", "color(display-p3 0.9843 0.9412 0.8667)"), _defineProperty(_ref21, "stopOpacity", 1), _ref21)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F0E7C7",
    style: (_ref22 = {
      stopColor: "#F0E7C7"
    }, _defineProperty(_ref22, "stopColor", "color(display-p3 0.9412 0.9059 0.7804)"), _defineProperty(_ref22, "stopOpacity", 1), _ref22)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E4DDAB",
    style: (_ref23 = {
      stopColor: "#E4DDAB"
    }, _defineProperty(_ref23, "stopColor", "color(display-p3 0.8941 0.8667 0.6706)"), _defineProperty(_ref23, "stopOpacity", 1), _ref23)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#ECE8C6",
    stopOpacity: 0.4489,
    style: (_ref24 = {
      stopColor: "#ECE8C6"
    }, _defineProperty(_ref24, "stopColor", "color(display-p3 0.9255 0.9098 0.7765)"), _defineProperty(_ref24, "stopOpacity", 0.4489), _ref24)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F4F1DE",
    stopOpacity: 0.1444,
    style: (_ref25 = {
      stopColor: "#F4F1DE"
    }, _defineProperty(_ref25, "stopColor", "color(display-p3 0.9569 0.9451 0.8706)"), _defineProperty(_ref25, "stopOpacity", 0.1444), _ref25)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FAF9F0",
    stopOpacity: 0.0324,
    style: (_ref26 = {
      stopColor: "#FAF9F0"
    }, _defineProperty(_ref26, "stopColor", "color(display-p3 0.9804 0.9765 0.9412)"), _defineProperty(_ref26, "stopOpacity", 0.0324), _ref26)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#FDFDFA",
    stopOpacity: 0.01,
    style: (_ref27 = {
      stopColor: "#FDFDFA"
    }, _defineProperty(_ref27, "stopColor", "color(display-p3 0.9922 0.9922 0.9804)"), _defineProperty(_ref27, "stopOpacity", 0.01), _ref27)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(142.637 94.1344) rotate(180) scale(2.55122 2.54346)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4E6",
    style: (_ref28 = {
      stopColor: "#FFF4E6"
    }, _defineProperty(_ref28, "stopColor", "color(display-p3 1.0000 0.9569 0.9020)"), _defineProperty(_ref28, "stopOpacity", 1), _ref28)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FBF0DD",
    style: (_ref29 = {
      stopColor: "#FBF0DD"
    }, _defineProperty(_ref29, "stopColor", "color(display-p3 0.9843 0.9412 0.8667)"), _defineProperty(_ref29, "stopOpacity", 1), _ref29)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F0E7C7",
    style: (_ref30 = {
      stopColor: "#F0E7C7"
    }, _defineProperty(_ref30, "stopColor", "color(display-p3 0.9412 0.9059 0.7804)"), _defineProperty(_ref30, "stopOpacity", 1), _ref30)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E4DDAB",
    style: (_ref31 = {
      stopColor: "#E4DDAB"
    }, _defineProperty(_ref31, "stopColor", "color(display-p3 0.8941 0.8667 0.6706)"), _defineProperty(_ref31, "stopOpacity", 1), _ref31)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#ECE8C6",
    stopOpacity: 0.4489,
    style: (_ref32 = {
      stopColor: "#ECE8C6"
    }, _defineProperty(_ref32, "stopColor", "color(display-p3 0.9255 0.9098 0.7765)"), _defineProperty(_ref32, "stopOpacity", 0.4489), _ref32)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F4F1DE",
    stopOpacity: 0.1444,
    style: (_ref33 = {
      stopColor: "#F4F1DE"
    }, _defineProperty(_ref33, "stopColor", "color(display-p3 0.9569 0.9451 0.8706)"), _defineProperty(_ref33, "stopOpacity", 0.1444), _ref33)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FAF9F0",
    stopOpacity: 0.0324,
    style: (_ref34 = {
      stopColor: "#FAF9F0"
    }, _defineProperty(_ref34, "stopColor", "color(display-p3 0.9804 0.9765 0.9412)"), _defineProperty(_ref34, "stopOpacity", 0.0324), _ref34)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#FDFDFA",
    stopOpacity: 0.01,
    style: (_ref35 = {
      stopColor: "#FDFDFA"
    }, _defineProperty(_ref35, "stopColor", "color(display-p3 0.9922 0.9922 0.9804)"), _defineProperty(_ref35, "stopOpacity", 0.01), _ref35)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(69.3774 135.493) rotate(180) scale(2.55123 2.54346)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4E6",
    style: (_ref36 = {
      stopColor: "#FFF4E6"
    }, _defineProperty(_ref36, "stopColor", "color(display-p3 1.0000 0.9569 0.9020)"), _defineProperty(_ref36, "stopOpacity", 1), _ref36)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FBF0DD",
    style: (_ref37 = {
      stopColor: "#FBF0DD"
    }, _defineProperty(_ref37, "stopColor", "color(display-p3 0.9843 0.9412 0.8667)"), _defineProperty(_ref37, "stopOpacity", 1), _ref37)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F0E7C7",
    style: (_ref38 = {
      stopColor: "#F0E7C7"
    }, _defineProperty(_ref38, "stopColor", "color(display-p3 0.9412 0.9059 0.7804)"), _defineProperty(_ref38, "stopOpacity", 1), _ref38)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E4DDAB",
    style: (_ref39 = {
      stopColor: "#E4DDAB"
    }, _defineProperty(_ref39, "stopColor", "color(display-p3 0.8941 0.8667 0.6706)"), _defineProperty(_ref39, "stopOpacity", 1), _ref39)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#ECE8C6",
    stopOpacity: 0.4489,
    style: (_ref40 = {
      stopColor: "#ECE8C6"
    }, _defineProperty(_ref40, "stopColor", "color(display-p3 0.9255 0.9098 0.7765)"), _defineProperty(_ref40, "stopOpacity", 0.4489), _ref40)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F4F1DE",
    stopOpacity: 0.1444,
    style: (_ref41 = {
      stopColor: "#F4F1DE"
    }, _defineProperty(_ref41, "stopColor", "color(display-p3 0.9569 0.9451 0.8706)"), _defineProperty(_ref41, "stopOpacity", 0.1444), _ref41)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FAF9F0",
    stopOpacity: 0.0324,
    style: (_ref42 = {
      stopColor: "#FAF9F0"
    }, _defineProperty(_ref42, "stopColor", "color(display-p3 0.9804 0.9765 0.9412)"), _defineProperty(_ref42, "stopOpacity", 0.0324), _ref42)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#FDFDFA",
    stopOpacity: 0.01,
    style: (_ref43 = {
      stopColor: "#FDFDFA"
    }, _defineProperty(_ref43, "stopColor", "color(display-p3 0.9922 0.9922 0.9804)"), _defineProperty(_ref43, "stopOpacity", 0.01), _ref43)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(106.803 48.2965) rotate(180) scale(2.55122 2.54346)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4E6",
    style: (_ref44 = {
      stopColor: "#FFF4E6"
    }, _defineProperty(_ref44, "stopColor", "color(display-p3 1.0000 0.9569 0.9020)"), _defineProperty(_ref44, "stopOpacity", 1), _ref44)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FBF0DD",
    style: (_ref45 = {
      stopColor: "#FBF0DD"
    }, _defineProperty(_ref45, "stopColor", "color(display-p3 0.9843 0.9412 0.8667)"), _defineProperty(_ref45, "stopOpacity", 1), _ref45)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F0E7C7",
    style: (_ref46 = {
      stopColor: "#F0E7C7"
    }, _defineProperty(_ref46, "stopColor", "color(display-p3 0.9412 0.9059 0.7804)"), _defineProperty(_ref46, "stopOpacity", 1), _ref46)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E4DDAB",
    style: (_ref47 = {
      stopColor: "#E4DDAB"
    }, _defineProperty(_ref47, "stopColor", "color(display-p3 0.8941 0.8667 0.6706)"), _defineProperty(_ref47, "stopOpacity", 1), _ref47)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#ECE8C6",
    stopOpacity: 0.4489,
    style: (_ref48 = {
      stopColor: "#ECE8C6"
    }, _defineProperty(_ref48, "stopColor", "color(display-p3 0.9255 0.9098 0.7765)"), _defineProperty(_ref48, "stopOpacity", 0.4489), _ref48)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F4F1DE",
    stopOpacity: 0.1444,
    style: (_ref49 = {
      stopColor: "#F4F1DE"
    }, _defineProperty(_ref49, "stopColor", "color(display-p3 0.9569 0.9451 0.8706)"), _defineProperty(_ref49, "stopOpacity", 0.1444), _ref49)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FAF9F0",
    stopOpacity: 0.0324,
    style: (_ref50 = {
      stopColor: "#FAF9F0"
    }, _defineProperty(_ref50, "stopColor", "color(display-p3 0.9804 0.9765 0.9412)"), _defineProperty(_ref50, "stopOpacity", 0.0324), _ref50)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#FDFDFA",
    stopOpacity: 0.01,
    style: (_ref51 = {
      stopColor: "#FDFDFA"
    }, _defineProperty(_ref51, "stopColor", "color(display-p3 0.9922 0.9922 0.9804)"), _defineProperty(_ref51, "stopOpacity", 0.01), _ref51)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(85.3499 18.1919) rotate(180) scale(2.55122 2.54346)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4E6",
    style: (_ref52 = {
      stopColor: "#FFF4E6"
    }, _defineProperty(_ref52, "stopColor", "color(display-p3 1.0000 0.9569 0.9020)"), _defineProperty(_ref52, "stopOpacity", 1), _ref52)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FBF0DD",
    style: (_ref53 = {
      stopColor: "#FBF0DD"
    }, _defineProperty(_ref53, "stopColor", "color(display-p3 0.9843 0.9412 0.8667)"), _defineProperty(_ref53, "stopOpacity", 1), _ref53)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F0E7C7",
    style: (_ref54 = {
      stopColor: "#F0E7C7"
    }, _defineProperty(_ref54, "stopColor", "color(display-p3 0.9412 0.9059 0.7804)"), _defineProperty(_ref54, "stopOpacity", 1), _ref54)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E4DDAB",
    style: (_ref55 = {
      stopColor: "#E4DDAB"
    }, _defineProperty(_ref55, "stopColor", "color(display-p3 0.8941 0.8667 0.6706)"), _defineProperty(_ref55, "stopOpacity", 1), _ref55)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#ECE8C6",
    stopOpacity: 0.4489,
    style: (_ref56 = {
      stopColor: "#ECE8C6"
    }, _defineProperty(_ref56, "stopColor", "color(display-p3 0.9255 0.9098 0.7765)"), _defineProperty(_ref56, "stopOpacity", 0.4489), _ref56)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F4F1DE",
    stopOpacity: 0.1444,
    style: (_ref57 = {
      stopColor: "#F4F1DE"
    }, _defineProperty(_ref57, "stopColor", "color(display-p3 0.9569 0.9451 0.8706)"), _defineProperty(_ref57, "stopOpacity", 0.1444), _ref57)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FAF9F0",
    stopOpacity: 0.0324,
    style: (_ref58 = {
      stopColor: "#FAF9F0"
    }, _defineProperty(_ref58, "stopColor", "color(display-p3 0.9804 0.9765 0.9412)"), _defineProperty(_ref58, "stopOpacity", 0.0324), _ref58)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#FDFDFA",
    stopOpacity: 0.01,
    style: (_ref59 = {
      stopColor: "#FDFDFA"
    }, _defineProperty(_ref59, "stopColor", "color(display-p3 0.9922 0.9922 0.9804)"), _defineProperty(_ref59, "stopOpacity", 0.01), _ref59)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.2112 102.133) rotate(180) scale(0.0905331 0.0902577)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4E6",
    style: (_ref60 = {
      stopColor: "#FFF4E6"
    }, _defineProperty(_ref60, "stopColor", "color(display-p3 1.0000 0.9569 0.9020)"), _defineProperty(_ref60, "stopOpacity", 1), _ref60)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FBF0DD",
    style: (_ref61 = {
      stopColor: "#FBF0DD"
    }, _defineProperty(_ref61, "stopColor", "color(display-p3 0.9843 0.9412 0.8667)"), _defineProperty(_ref61, "stopOpacity", 1), _ref61)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F0E7C7",
    style: (_ref62 = {
      stopColor: "#F0E7C7"
    }, _defineProperty(_ref62, "stopColor", "color(display-p3 0.9412 0.9059 0.7804)"), _defineProperty(_ref62, "stopOpacity", 1), _ref62)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E4DDAB",
    style: (_ref63 = {
      stopColor: "#E4DDAB"
    }, _defineProperty(_ref63, "stopColor", "color(display-p3 0.8941 0.8667 0.6706)"), _defineProperty(_ref63, "stopOpacity", 1), _ref63)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#ECE8C6",
    stopOpacity: 0.4489,
    style: (_ref64 = {
      stopColor: "#ECE8C6"
    }, _defineProperty(_ref64, "stopColor", "color(display-p3 0.9255 0.9098 0.7765)"), _defineProperty(_ref64, "stopOpacity", 0.4489), _ref64)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F4F1DE",
    stopOpacity: 0.1444,
    style: (_ref65 = {
      stopColor: "#F4F1DE"
    }, _defineProperty(_ref65, "stopColor", "color(display-p3 0.9569 0.9451 0.8706)"), _defineProperty(_ref65, "stopOpacity", 0.1444), _ref65)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FAF9F0",
    stopOpacity: 0.0324,
    style: (_ref66 = {
      stopColor: "#FAF9F0"
    }, _defineProperty(_ref66, "stopColor", "color(display-p3 0.9804 0.9765 0.9412)"), _defineProperty(_ref66, "stopOpacity", 0.0324), _ref66)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#FDFDFA",
    stopOpacity: 0.01,
    style: (_ref67 = {
      stopColor: "#FDFDFA"
    }, _defineProperty(_ref67, "stopColor", "color(display-p3 0.9922 0.9922 0.9804)"), _defineProperty(_ref67, "stopOpacity", 0.01), _ref67)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(82.5408 105.749) rotate(180) scale(3.52717 3.51644)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4E6",
    style: (_ref68 = {
      stopColor: "#FFF4E6"
    }, _defineProperty(_ref68, "stopColor", "color(display-p3 1.0000 0.9569 0.9020)"), _defineProperty(_ref68, "stopOpacity", 1), _ref68)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FBF0DD",
    style: (_ref69 = {
      stopColor: "#FBF0DD"
    }, _defineProperty(_ref69, "stopColor", "color(display-p3 0.9843 0.9412 0.8667)"), _defineProperty(_ref69, "stopOpacity", 1), _ref69)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F0E7C7",
    style: (_ref70 = {
      stopColor: "#F0E7C7"
    }, _defineProperty(_ref70, "stopColor", "color(display-p3 0.9412 0.9059 0.7804)"), _defineProperty(_ref70, "stopOpacity", 1), _ref70)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E4DDAB",
    style: (_ref71 = {
      stopColor: "#E4DDAB"
    }, _defineProperty(_ref71, "stopColor", "color(display-p3 0.8941 0.8667 0.6706)"), _defineProperty(_ref71, "stopOpacity", 1), _ref71)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#ECE8C6",
    stopOpacity: 0.4489,
    style: (_ref72 = {
      stopColor: "#ECE8C6"
    }, _defineProperty(_ref72, "stopColor", "color(display-p3 0.9255 0.9098 0.7765)"), _defineProperty(_ref72, "stopOpacity", 0.4489), _ref72)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F4F1DE",
    stopOpacity: 0.1444,
    style: (_ref73 = {
      stopColor: "#F4F1DE"
    }, _defineProperty(_ref73, "stopColor", "color(display-p3 0.9569 0.9451 0.8706)"), _defineProperty(_ref73, "stopOpacity", 0.1444), _ref73)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FAF9F0",
    stopOpacity: 0.0324,
    style: (_ref74 = {
      stopColor: "#FAF9F0"
    }, _defineProperty(_ref74, "stopColor", "color(display-p3 0.9804 0.9765 0.9412)"), _defineProperty(_ref74, "stopOpacity", 0.0324), _ref74)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#FDFDFA",
    stopOpacity: 0.01,
    style: (_ref75 = {
      stopColor: "#FDFDFA"
    }, _defineProperty(_ref75, "stopColor", "color(display-p3 0.9922 0.9922 0.9804)"), _defineProperty(_ref75, "stopOpacity", 0.01), _ref75)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(107.996 159.418) rotate(180) scale(1.46121 1.45676)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4E6",
    style: (_ref76 = {
      stopColor: "#FFF4E6"
    }, _defineProperty(_ref76, "stopColor", "color(display-p3 1.0000 0.9569 0.9020)"), _defineProperty(_ref76, "stopOpacity", 1), _ref76)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FBF0DD",
    style: (_ref77 = {
      stopColor: "#FBF0DD"
    }, _defineProperty(_ref77, "stopColor", "color(display-p3 0.9843 0.9412 0.8667)"), _defineProperty(_ref77, "stopOpacity", 1), _ref77)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F0E7C7",
    style: (_ref78 = {
      stopColor: "#F0E7C7"
    }, _defineProperty(_ref78, "stopColor", "color(display-p3 0.9412 0.9059 0.7804)"), _defineProperty(_ref78, "stopOpacity", 1), _ref78)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E4DDAB",
    style: (_ref79 = {
      stopColor: "#E4DDAB"
    }, _defineProperty(_ref79, "stopColor", "color(display-p3 0.8941 0.8667 0.6706)"), _defineProperty(_ref79, "stopOpacity", 1), _ref79)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#ECE8C6",
    stopOpacity: 0.4489,
    style: (_ref80 = {
      stopColor: "#ECE8C6"
    }, _defineProperty(_ref80, "stopColor", "color(display-p3 0.9255 0.9098 0.7765)"), _defineProperty(_ref80, "stopOpacity", 0.4489), _ref80)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F4F1DE",
    stopOpacity: 0.1444,
    style: (_ref81 = {
      stopColor: "#F4F1DE"
    }, _defineProperty(_ref81, "stopColor", "color(display-p3 0.9569 0.9451 0.8706)"), _defineProperty(_ref81, "stopOpacity", 0.1444), _ref81)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FAF9F0",
    stopOpacity: 0.0324,
    style: (_ref82 = {
      stopColor: "#FAF9F0"
    }, _defineProperty(_ref82, "stopColor", "color(display-p3 0.9804 0.9765 0.9412)"), _defineProperty(_ref82, "stopOpacity", 0.0324), _ref82)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#FDFDFA",
    stopOpacity: 0.01,
    style: (_ref83 = {
      stopColor: "#FDFDFA"
    }, _defineProperty(_ref83, "stopColor", "color(display-p3 0.9922 0.9922 0.9804)"), _defineProperty(_ref83, "stopOpacity", 0.01), _ref83)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(100.506 170.087) rotate(180) scale(1.46121 1.45676)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4E6",
    style: (_ref84 = {
      stopColor: "#FFF4E6"
    }, _defineProperty(_ref84, "stopColor", "color(display-p3 1.0000 0.9569 0.9020)"), _defineProperty(_ref84, "stopOpacity", 1), _ref84)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FBF0DD",
    style: (_ref85 = {
      stopColor: "#FBF0DD"
    }, _defineProperty(_ref85, "stopColor", "color(display-p3 0.9843 0.9412 0.8667)"), _defineProperty(_ref85, "stopOpacity", 1), _ref85)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F0E7C7",
    style: (_ref86 = {
      stopColor: "#F0E7C7"
    }, _defineProperty(_ref86, "stopColor", "color(display-p3 0.9412 0.9059 0.7804)"), _defineProperty(_ref86, "stopOpacity", 1), _ref86)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E4DDAB",
    style: (_ref87 = {
      stopColor: "#E4DDAB"
    }, _defineProperty(_ref87, "stopColor", "color(display-p3 0.8941 0.8667 0.6706)"), _defineProperty(_ref87, "stopOpacity", 1), _ref87)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#ECE8C6",
    stopOpacity: 0.4489,
    style: (_ref88 = {
      stopColor: "#ECE8C6"
    }, _defineProperty(_ref88, "stopColor", "color(display-p3 0.9255 0.9098 0.7765)"), _defineProperty(_ref88, "stopOpacity", 0.4489), _ref88)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F4F1DE",
    stopOpacity: 0.1444,
    style: (_ref89 = {
      stopColor: "#F4F1DE"
    }, _defineProperty(_ref89, "stopColor", "color(display-p3 0.9569 0.9451 0.8706)"), _defineProperty(_ref89, "stopOpacity", 0.1444), _ref89)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FAF9F0",
    stopOpacity: 0.0324,
    style: (_ref90 = {
      stopColor: "#FAF9F0"
    }, _defineProperty(_ref90, "stopColor", "color(display-p3 0.9804 0.9765 0.9412)"), _defineProperty(_ref90, "stopOpacity", 0.0324), _ref90)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#FDFDFA",
    stopOpacity: 0.01,
    style: (_ref91 = {
      stopColor: "#FDFDFA"
    }, _defineProperty(_ref91, "stopColor", "color(display-p3 0.9922 0.9922 0.9804)"), _defineProperty(_ref91, "stopOpacity", 0.01), _ref91)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(71.1917 166.561) rotate(180) scale(1.4612 1.45676)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4E6",
    style: (_ref92 = {
      stopColor: "#FFF4E6"
    }, _defineProperty(_ref92, "stopColor", "color(display-p3 1.0000 0.9569 0.9020)"), _defineProperty(_ref92, "stopOpacity", 1), _ref92)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FBF0DD",
    style: (_ref93 = {
      stopColor: "#FBF0DD"
    }, _defineProperty(_ref93, "stopColor", "color(display-p3 0.9843 0.9412 0.8667)"), _defineProperty(_ref93, "stopOpacity", 1), _ref93)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F0E7C7",
    style: (_ref94 = {
      stopColor: "#F0E7C7"
    }, _defineProperty(_ref94, "stopColor", "color(display-p3 0.9412 0.9059 0.7804)"), _defineProperty(_ref94, "stopOpacity", 1), _ref94)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E4DDAB",
    style: (_ref95 = {
      stopColor: "#E4DDAB"
    }, _defineProperty(_ref95, "stopColor", "color(display-p3 0.8941 0.8667 0.6706)"), _defineProperty(_ref95, "stopOpacity", 1), _ref95)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#ECE8C6",
    stopOpacity: 0.4489,
    style: (_ref96 = {
      stopColor: "#ECE8C6"
    }, _defineProperty(_ref96, "stopColor", "color(display-p3 0.9255 0.9098 0.7765)"), _defineProperty(_ref96, "stopOpacity", 0.4489), _ref96)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F4F1DE",
    stopOpacity: 0.1444,
    style: (_ref97 = {
      stopColor: "#F4F1DE"
    }, _defineProperty(_ref97, "stopColor", "color(display-p3 0.9569 0.9451 0.8706)"), _defineProperty(_ref97, "stopOpacity", 0.1444), _ref97)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FAF9F0",
    stopOpacity: 0.0324,
    style: (_ref98 = {
      stopColor: "#FAF9F0"
    }, _defineProperty(_ref98, "stopColor", "color(display-p3 0.9804 0.9765 0.9412)"), _defineProperty(_ref98, "stopOpacity", 0.0324), _ref98)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#FDFDFA",
    stopOpacity: 0.01,
    style: (_ref99 = {
      stopColor: "#FDFDFA"
    }, _defineProperty(_ref99, "stopColor", "color(display-p3 0.9922 0.9922 0.9804)"), _defineProperty(_ref99, "stopOpacity", 0.01), _ref99)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.76 55.6941) rotate(180) scale(1.4612 1.45676)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4E6",
    style: (_ref100 = {
      stopColor: "#FFF4E6"
    }, _defineProperty(_ref100, "stopColor", "color(display-p3 1.0000 0.9569 0.9020)"), _defineProperty(_ref100, "stopOpacity", 1), _ref100)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FBF0DD",
    style: (_ref101 = {
      stopColor: "#FBF0DD"
    }, _defineProperty(_ref101, "stopColor", "color(display-p3 0.9843 0.9412 0.8667)"), _defineProperty(_ref101, "stopOpacity", 1), _ref101)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F0E7C7",
    style: (_ref102 = {
      stopColor: "#F0E7C7"
    }, _defineProperty(_ref102, "stopColor", "color(display-p3 0.9412 0.9059 0.7804)"), _defineProperty(_ref102, "stopOpacity", 1), _ref102)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E4DDAB",
    style: (_ref103 = {
      stopColor: "#E4DDAB"
    }, _defineProperty(_ref103, "stopColor", "color(display-p3 0.8941 0.8667 0.6706)"), _defineProperty(_ref103, "stopOpacity", 1), _ref103)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#ECE8C6",
    stopOpacity: 0.4489,
    style: (_ref104 = {
      stopColor: "#ECE8C6"
    }, _defineProperty(_ref104, "stopColor", "color(display-p3 0.9255 0.9098 0.7765)"), _defineProperty(_ref104, "stopOpacity", 0.4489), _ref104)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F4F1DE",
    stopOpacity: 0.1444,
    style: (_ref105 = {
      stopColor: "#F4F1DE"
    }, _defineProperty(_ref105, "stopColor", "color(display-p3 0.9569 0.9451 0.8706)"), _defineProperty(_ref105, "stopOpacity", 0.1444), _ref105)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FAF9F0",
    stopOpacity: 0.0324,
    style: (_ref106 = {
      stopColor: "#FAF9F0"
    }, _defineProperty(_ref106, "stopColor", "color(display-p3 0.9804 0.9765 0.9412)"), _defineProperty(_ref106, "stopOpacity", 0.0324), _ref106)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#FDFDFA",
    stopOpacity: 0.01,
    style: (_ref107 = {
      stopColor: "#FDFDFA"
    }, _defineProperty(_ref107, "stopColor", "color(display-p3 0.9922 0.9922 0.9804)"), _defineProperty(_ref107, "stopOpacity", 0.01), _ref107)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.4907 130.124) rotate(180) scale(1.4612 1.45676)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4E6",
    style: (_ref108 = {
      stopColor: "#FFF4E6"
    }, _defineProperty(_ref108, "stopColor", "color(display-p3 1.0000 0.9569 0.9020)"), _defineProperty(_ref108, "stopOpacity", 1), _ref108)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FBF0DD",
    style: (_ref109 = {
      stopColor: "#FBF0DD"
    }, _defineProperty(_ref109, "stopColor", "color(display-p3 0.9843 0.9412 0.8667)"), _defineProperty(_ref109, "stopOpacity", 1), _ref109)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F0E7C7",
    style: (_ref110 = {
      stopColor: "#F0E7C7"
    }, _defineProperty(_ref110, "stopColor", "color(display-p3 0.9412 0.9059 0.7804)"), _defineProperty(_ref110, "stopOpacity", 1), _ref110)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E4DDAB",
    style: (_ref111 = {
      stopColor: "#E4DDAB"
    }, _defineProperty(_ref111, "stopColor", "color(display-p3 0.8941 0.8667 0.6706)"), _defineProperty(_ref111, "stopOpacity", 1), _ref111)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#ECE8C6",
    stopOpacity: 0.4489,
    style: (_ref112 = {
      stopColor: "#ECE8C6"
    }, _defineProperty(_ref112, "stopColor", "color(display-p3 0.9255 0.9098 0.7765)"), _defineProperty(_ref112, "stopOpacity", 0.4489), _ref112)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F4F1DE",
    stopOpacity: 0.1444,
    style: (_ref113 = {
      stopColor: "#F4F1DE"
    }, _defineProperty(_ref113, "stopColor", "color(display-p3 0.9569 0.9451 0.8706)"), _defineProperty(_ref113, "stopOpacity", 0.1444), _ref113)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FAF9F0",
    stopOpacity: 0.0324,
    style: (_ref114 = {
      stopColor: "#FAF9F0"
    }, _defineProperty(_ref114, "stopColor", "color(display-p3 0.9804 0.9765 0.9412)"), _defineProperty(_ref114, "stopOpacity", 0.0324), _ref114)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#FDFDFA",
    stopOpacity: 0.01,
    style: (_ref115 = {
      stopColor: "#FDFDFA"
    }, _defineProperty(_ref115, "stopColor", "color(display-p3 0.9922 0.9922 0.9804)"), _defineProperty(_ref115, "stopOpacity", 0.01), _ref115)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(133.553 149.696) rotate(180) scale(1.46121 1.45676)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4E6",
    style: (_ref116 = {
      stopColor: "#FFF4E6"
    }, _defineProperty(_ref116, "stopColor", "color(display-p3 1.0000 0.9569 0.9020)"), _defineProperty(_ref116, "stopOpacity", 1), _ref116)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FBF0DD",
    style: (_ref117 = {
      stopColor: "#FBF0DD"
    }, _defineProperty(_ref117, "stopColor", "color(display-p3 0.9843 0.9412 0.8667)"), _defineProperty(_ref117, "stopOpacity", 1), _ref117)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F0E7C7",
    style: (_ref118 = {
      stopColor: "#F0E7C7"
    }, _defineProperty(_ref118, "stopColor", "color(display-p3 0.9412 0.9059 0.7804)"), _defineProperty(_ref118, "stopOpacity", 1), _ref118)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E4DDAB",
    style: (_ref119 = {
      stopColor: "#E4DDAB"
    }, _defineProperty(_ref119, "stopColor", "color(display-p3 0.8941 0.8667 0.6706)"), _defineProperty(_ref119, "stopOpacity", 1), _ref119)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#ECE8C6",
    stopOpacity: 0.4489,
    style: (_ref120 = {
      stopColor: "#ECE8C6"
    }, _defineProperty(_ref120, "stopColor", "color(display-p3 0.9255 0.9098 0.7765)"), _defineProperty(_ref120, "stopOpacity", 0.4489), _ref120)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F4F1DE",
    stopOpacity: 0.1444,
    style: (_ref121 = {
      stopColor: "#F4F1DE"
    }, _defineProperty(_ref121, "stopColor", "color(display-p3 0.9569 0.9451 0.8706)"), _defineProperty(_ref121, "stopOpacity", 0.1444), _ref121)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FAF9F0",
    stopOpacity: 0.0324,
    style: (_ref122 = {
      stopColor: "#FAF9F0"
    }, _defineProperty(_ref122, "stopColor", "color(display-p3 0.9804 0.9765 0.9412)"), _defineProperty(_ref122, "stopOpacity", 0.0324), _ref122)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#FDFDFA",
    stopOpacity: 0.01,
    style: (_ref123 = {
      stopColor: "#FDFDFA"
    }, _defineProperty(_ref123, "stopColor", "color(display-p3 0.9922 0.9922 0.9804)"), _defineProperty(_ref123, "stopOpacity", 0.01), _ref123)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(136.513 117.681) rotate(180) scale(1.46121 1.45676)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4E6",
    style: (_ref124 = {
      stopColor: "#FFF4E6"
    }, _defineProperty(_ref124, "stopColor", "color(display-p3 1.0000 0.9569 0.9020)"), _defineProperty(_ref124, "stopOpacity", 1), _ref124)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FBF0DD",
    style: (_ref125 = {
      stopColor: "#FBF0DD"
    }, _defineProperty(_ref125, "stopColor", "color(display-p3 0.9843 0.9412 0.8667)"), _defineProperty(_ref125, "stopOpacity", 1), _ref125)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F0E7C7",
    style: (_ref126 = {
      stopColor: "#F0E7C7"
    }, _defineProperty(_ref126, "stopColor", "color(display-p3 0.9412 0.9059 0.7804)"), _defineProperty(_ref126, "stopOpacity", 1), _ref126)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E4DDAB",
    style: (_ref127 = {
      stopColor: "#E4DDAB"
    }, _defineProperty(_ref127, "stopColor", "color(display-p3 0.8941 0.8667 0.6706)"), _defineProperty(_ref127, "stopOpacity", 1), _ref127)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#ECE8C6",
    stopOpacity: 0.4489,
    style: (_ref128 = {
      stopColor: "#ECE8C6"
    }, _defineProperty(_ref128, "stopColor", "color(display-p3 0.9255 0.9098 0.7765)"), _defineProperty(_ref128, "stopOpacity", 0.4489), _ref128)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F4F1DE",
    stopOpacity: 0.1444,
    style: (_ref129 = {
      stopColor: "#F4F1DE"
    }, _defineProperty(_ref129, "stopColor", "color(display-p3 0.9569 0.9451 0.8706)"), _defineProperty(_ref129, "stopOpacity", 0.1444), _ref129)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FAF9F0",
    stopOpacity: 0.0324,
    style: (_ref130 = {
      stopColor: "#FAF9F0"
    }, _defineProperty(_ref130, "stopColor", "color(display-p3 0.9804 0.9765 0.9412)"), _defineProperty(_ref130, "stopOpacity", 0.0324), _ref130)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#FDFDFA",
    stopOpacity: 0.01,
    style: (_ref131 = {
      stopColor: "#FDFDFA"
    }, _defineProperty(_ref131, "stopColor", "color(display-p3 0.9922 0.9922 0.9804)"), _defineProperty(_ref131, "stopOpacity", 0.01), _ref131)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(144.197 123.866) rotate(180) scale(1.4612 1.45676)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4E6",
    style: (_ref132 = {
      stopColor: "#FFF4E6"
    }, _defineProperty(_ref132, "stopColor", "color(display-p3 1.0000 0.9569 0.9020)"), _defineProperty(_ref132, "stopOpacity", 1), _ref132)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FBF0DD",
    style: (_ref133 = {
      stopColor: "#FBF0DD"
    }, _defineProperty(_ref133, "stopColor", "color(display-p3 0.9843 0.9412 0.8667)"), _defineProperty(_ref133, "stopOpacity", 1), _ref133)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F0E7C7",
    style: (_ref134 = {
      stopColor: "#F0E7C7"
    }, _defineProperty(_ref134, "stopColor", "color(display-p3 0.9412 0.9059 0.7804)"), _defineProperty(_ref134, "stopOpacity", 1), _ref134)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E4DDAB",
    style: (_ref135 = {
      stopColor: "#E4DDAB"
    }, _defineProperty(_ref135, "stopColor", "color(display-p3 0.8941 0.8667 0.6706)"), _defineProperty(_ref135, "stopOpacity", 1), _ref135)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#ECE8C6",
    stopOpacity: 0.4489,
    style: (_ref136 = {
      stopColor: "#ECE8C6"
    }, _defineProperty(_ref136, "stopColor", "color(display-p3 0.9255 0.9098 0.7765)"), _defineProperty(_ref136, "stopOpacity", 0.4489), _ref136)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F4F1DE",
    stopOpacity: 0.1444,
    style: (_ref137 = {
      stopColor: "#F4F1DE"
    }, _defineProperty(_ref137, "stopColor", "color(display-p3 0.9569 0.9451 0.8706)"), _defineProperty(_ref137, "stopOpacity", 0.1444), _ref137)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FAF9F0",
    stopOpacity: 0.0324,
    style: (_ref138 = {
      stopColor: "#FAF9F0"
    }, _defineProperty(_ref138, "stopColor", "color(display-p3 0.9804 0.9765 0.9412)"), _defineProperty(_ref138, "stopOpacity", 0.0324), _ref138)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#FDFDFA",
    stopOpacity: 0.01,
    style: (_ref139 = {
      stopColor: "#FDFDFA"
    }, _defineProperty(_ref139, "stopColor", "color(display-p3 0.9922 0.9922 0.9804)"), _defineProperty(_ref139, "stopOpacity", 0.01), _ref139)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.5019 153.223) rotate(180) scale(1.46121 1.45676)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4E6",
    style: (_ref140 = {
      stopColor: "#FFF4E6"
    }, _defineProperty(_ref140, "stopColor", "color(display-p3 1.0000 0.9569 0.9020)"), _defineProperty(_ref140, "stopOpacity", 1), _ref140)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FBF0DD",
    style: (_ref141 = {
      stopColor: "#FBF0DD"
    }, _defineProperty(_ref141, "stopColor", "color(display-p3 0.9843 0.9412 0.8667)"), _defineProperty(_ref141, "stopOpacity", 1), _ref141)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F0E7C7",
    style: (_ref142 = {
      stopColor: "#F0E7C7"
    }, _defineProperty(_ref142, "stopColor", "color(display-p3 0.9412 0.9059 0.7804)"), _defineProperty(_ref142, "stopOpacity", 1), _ref142)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E4DDAB",
    style: (_ref143 = {
      stopColor: "#E4DDAB"
    }, _defineProperty(_ref143, "stopColor", "color(display-p3 0.8941 0.8667 0.6706)"), _defineProperty(_ref143, "stopOpacity", 1), _ref143)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#ECE8C6",
    stopOpacity: 0.4489,
    style: (_ref144 = {
      stopColor: "#ECE8C6"
    }, _defineProperty(_ref144, "stopColor", "color(display-p3 0.9255 0.9098 0.7765)"), _defineProperty(_ref144, "stopOpacity", 0.4489), _ref144)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F4F1DE",
    stopOpacity: 0.1444,
    style: (_ref145 = {
      stopColor: "#F4F1DE"
    }, _defineProperty(_ref145, "stopColor", "color(display-p3 0.9569 0.9451 0.8706)"), _defineProperty(_ref145, "stopOpacity", 0.1444), _ref145)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FAF9F0",
    stopOpacity: 0.0324,
    style: (_ref146 = {
      stopColor: "#FAF9F0"
    }, _defineProperty(_ref146, "stopColor", "color(display-p3 0.9804 0.9765 0.9412)"), _defineProperty(_ref146, "stopOpacity", 0.0324), _ref146)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#FDFDFA",
    stopOpacity: 0.01,
    style: (_ref147 = {
      stopColor: "#FDFDFA"
    }, _defineProperty(_ref147, "stopColor", "color(display-p3 0.9922 0.9922 0.9804)"), _defineProperty(_ref147, "stopOpacity", 0.01), _ref147)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.1487 149.647) rotate(180) scale(1.46121 1.45676)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4E6",
    style: (_ref148 = {
      stopColor: "#FFF4E6"
    }, _defineProperty(_ref148, "stopColor", "color(display-p3 1.0000 0.9569 0.9020)"), _defineProperty(_ref148, "stopOpacity", 1), _ref148)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FBF0DD",
    style: (_ref149 = {
      stopColor: "#FBF0DD"
    }, _defineProperty(_ref149, "stopColor", "color(display-p3 0.9843 0.9412 0.8667)"), _defineProperty(_ref149, "stopOpacity", 1), _ref149)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F0E7C7",
    style: (_ref150 = {
      stopColor: "#F0E7C7"
    }, _defineProperty(_ref150, "stopColor", "color(display-p3 0.9412 0.9059 0.7804)"), _defineProperty(_ref150, "stopOpacity", 1), _ref150)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E4DDAB",
    style: (_ref151 = {
      stopColor: "#E4DDAB"
    }, _defineProperty(_ref151, "stopColor", "color(display-p3 0.8941 0.8667 0.6706)"), _defineProperty(_ref151, "stopOpacity", 1), _ref151)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#ECE8C6",
    stopOpacity: 0.4489,
    style: (_ref152 = {
      stopColor: "#ECE8C6"
    }, _defineProperty(_ref152, "stopColor", "color(display-p3 0.9255 0.9098 0.7765)"), _defineProperty(_ref152, "stopOpacity", 0.4489), _ref152)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F4F1DE",
    stopOpacity: 0.1444,
    style: (_ref153 = {
      stopColor: "#F4F1DE"
    }, _defineProperty(_ref153, "stopColor", "color(display-p3 0.9569 0.9451 0.8706)"), _defineProperty(_ref153, "stopOpacity", 0.1444), _ref153)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FAF9F0",
    stopOpacity: 0.0324,
    style: (_ref154 = {
      stopColor: "#FAF9F0"
    }, _defineProperty(_ref154, "stopColor", "color(display-p3 0.9804 0.9765 0.9412)"), _defineProperty(_ref154, "stopOpacity", 0.0324), _ref154)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#FDFDFA",
    stopOpacity: 0.01,
    style: (_ref155 = {
      stopColor: "#FDFDFA"
    }, _defineProperty(_ref155, "stopColor", "color(display-p3 0.9922 0.9922 0.9804)"), _defineProperty(_ref155, "stopOpacity", 0.01), _ref155)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.3811 113.65) rotate(180) scale(1.46121 1.45676)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4E6",
    style: (_ref156 = {
      stopColor: "#FFF4E6"
    }, _defineProperty(_ref156, "stopColor", "color(display-p3 1.0000 0.9569 0.9020)"), _defineProperty(_ref156, "stopOpacity", 1), _ref156)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FBF0DD",
    style: (_ref157 = {
      stopColor: "#FBF0DD"
    }, _defineProperty(_ref157, "stopColor", "color(display-p3 0.9843 0.9412 0.8667)"), _defineProperty(_ref157, "stopOpacity", 1), _ref157)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F0E7C7",
    style: (_ref158 = {
      stopColor: "#F0E7C7"
    }, _defineProperty(_ref158, "stopColor", "color(display-p3 0.9412 0.9059 0.7804)"), _defineProperty(_ref158, "stopOpacity", 1), _ref158)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E4DDAB",
    style: (_ref159 = {
      stopColor: "#E4DDAB"
    }, _defineProperty(_ref159, "stopColor", "color(display-p3 0.8941 0.8667 0.6706)"), _defineProperty(_ref159, "stopOpacity", 1), _ref159)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#ECE8C6",
    stopOpacity: 0.4489,
    style: (_ref160 = {
      stopColor: "#ECE8C6"
    }, _defineProperty(_ref160, "stopColor", "color(display-p3 0.9255 0.9098 0.7765)"), _defineProperty(_ref160, "stopOpacity", 0.4489), _ref160)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F4F1DE",
    stopOpacity: 0.1444,
    style: (_ref161 = {
      stopColor: "#F4F1DE"
    }, _defineProperty(_ref161, "stopColor", "color(display-p3 0.9569 0.9451 0.8706)"), _defineProperty(_ref161, "stopOpacity", 0.1444), _ref161)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FAF9F0",
    stopOpacity: 0.0324,
    style: (_ref162 = {
      stopColor: "#FAF9F0"
    }, _defineProperty(_ref162, "stopColor", "color(display-p3 0.9804 0.9765 0.9412)"), _defineProperty(_ref162, "stopOpacity", 0.0324), _ref162)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#FDFDFA",
    stopOpacity: 0.01,
    style: (_ref163 = {
      stopColor: "#FDFDFA"
    }, _defineProperty(_ref163, "stopColor", "color(display-p3 0.9922 0.9922 0.9804)"), _defineProperty(_ref163, "stopOpacity", 0.01), _ref163)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(88.3968 113.874) rotate(180) scale(1.46121 1.45676)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4E6",
    style: (_ref164 = {
      stopColor: "#FFF4E6"
    }, _defineProperty(_ref164, "stopColor", "color(display-p3 1.0000 0.9569 0.9020)"), _defineProperty(_ref164, "stopOpacity", 1), _ref164)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FBF0DD",
    style: (_ref165 = {
      stopColor: "#FBF0DD"
    }, _defineProperty(_ref165, "stopColor", "color(display-p3 0.9843 0.9412 0.8667)"), _defineProperty(_ref165, "stopOpacity", 1), _ref165)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F0E7C7",
    style: (_ref166 = {
      stopColor: "#F0E7C7"
    }, _defineProperty(_ref166, "stopColor", "color(display-p3 0.9412 0.9059 0.7804)"), _defineProperty(_ref166, "stopOpacity", 1), _ref166)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E4DDAB",
    style: (_ref167 = {
      stopColor: "#E4DDAB"
    }, _defineProperty(_ref167, "stopColor", "color(display-p3 0.8941 0.8667 0.6706)"), _defineProperty(_ref167, "stopOpacity", 1), _ref167)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#ECE8C6",
    stopOpacity: 0.4489,
    style: (_ref168 = {
      stopColor: "#ECE8C6"
    }, _defineProperty(_ref168, "stopColor", "color(display-p3 0.9255 0.9098 0.7765)"), _defineProperty(_ref168, "stopOpacity", 0.4489), _ref168)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F4F1DE",
    stopOpacity: 0.1444,
    style: (_ref169 = {
      stopColor: "#F4F1DE"
    }, _defineProperty(_ref169, "stopColor", "color(display-p3 0.9569 0.9451 0.8706)"), _defineProperty(_ref169, "stopOpacity", 0.1444), _ref169)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FAF9F0",
    stopOpacity: 0.0324,
    style: (_ref170 = {
      stopColor: "#FAF9F0"
    }, _defineProperty(_ref170, "stopColor", "color(display-p3 0.9804 0.9765 0.9412)"), _defineProperty(_ref170, "stopOpacity", 0.0324), _ref170)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#FDFDFA",
    stopOpacity: 0.01,
    style: (_ref171 = {
      stopColor: "#FDFDFA"
    }, _defineProperty(_ref171, "stopColor", "color(display-p3 0.9922 0.9922 0.9804)"), _defineProperty(_ref171, "stopOpacity", 0.01), _ref171)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(125.155 117.046) rotate(180) scale(1.46121 1.45676)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4E6",
    style: (_ref172 = {
      stopColor: "#FFF4E6"
    }, _defineProperty(_ref172, "stopColor", "color(display-p3 1.0000 0.9569 0.9020)"), _defineProperty(_ref172, "stopOpacity", 1), _ref172)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FBF0DD",
    style: (_ref173 = {
      stopColor: "#FBF0DD"
    }, _defineProperty(_ref173, "stopColor", "color(display-p3 0.9843 0.9412 0.8667)"), _defineProperty(_ref173, "stopOpacity", 1), _ref173)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F0E7C7",
    style: (_ref174 = {
      stopColor: "#F0E7C7"
    }, _defineProperty(_ref174, "stopColor", "color(display-p3 0.9412 0.9059 0.7804)"), _defineProperty(_ref174, "stopOpacity", 1), _ref174)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E4DDAB",
    style: (_ref175 = {
      stopColor: "#E4DDAB"
    }, _defineProperty(_ref175, "stopColor", "color(display-p3 0.8941 0.8667 0.6706)"), _defineProperty(_ref175, "stopOpacity", 1), _ref175)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#ECE8C6",
    stopOpacity: 0.4489,
    style: (_ref176 = {
      stopColor: "#ECE8C6"
    }, _defineProperty(_ref176, "stopColor", "color(display-p3 0.9255 0.9098 0.7765)"), _defineProperty(_ref176, "stopOpacity", 0.4489), _ref176)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F4F1DE",
    stopOpacity: 0.1444,
    style: (_ref177 = {
      stopColor: "#F4F1DE"
    }, _defineProperty(_ref177, "stopColor", "color(display-p3 0.9569 0.9451 0.8706)"), _defineProperty(_ref177, "stopOpacity", 0.1444), _ref177)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FAF9F0",
    stopOpacity: 0.0324,
    style: (_ref178 = {
      stopColor: "#FAF9F0"
    }, _defineProperty(_ref178, "stopColor", "color(display-p3 0.9804 0.9765 0.9412)"), _defineProperty(_ref178, "stopOpacity", 0.0324), _ref178)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#FDFDFA",
    stopOpacity: 0.01,
    style: (_ref179 = {
      stopColor: "#FDFDFA"
    }, _defineProperty(_ref179, "stopColor", "color(display-p3 0.9922 0.9922 0.9804)"), _defineProperty(_ref179, "stopOpacity", 0.01), _ref179)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(162.812 125.389) rotate(-180) scale(1.4612 1.45676)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4E6",
    style: (_ref180 = {
      stopColor: "#FFF4E6"
    }, _defineProperty(_ref180, "stopColor", "color(display-p3 1.0000 0.9569 0.9020)"), _defineProperty(_ref180, "stopOpacity", 1), _ref180)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FBF0DD",
    style: (_ref181 = {
      stopColor: "#FBF0DD"
    }, _defineProperty(_ref181, "stopColor", "color(display-p3 0.9843 0.9412 0.8667)"), _defineProperty(_ref181, "stopOpacity", 1), _ref181)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F0E7C7",
    style: (_ref182 = {
      stopColor: "#F0E7C7"
    }, _defineProperty(_ref182, "stopColor", "color(display-p3 0.9412 0.9059 0.7804)"), _defineProperty(_ref182, "stopOpacity", 1), _ref182)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E4DDAB",
    style: (_ref183 = {
      stopColor: "#E4DDAB"
    }, _defineProperty(_ref183, "stopColor", "color(display-p3 0.8941 0.8667 0.6706)"), _defineProperty(_ref183, "stopOpacity", 1), _ref183)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#ECE8C6",
    stopOpacity: 0.4489,
    style: (_ref184 = {
      stopColor: "#ECE8C6"
    }, _defineProperty(_ref184, "stopColor", "color(display-p3 0.9255 0.9098 0.7765)"), _defineProperty(_ref184, "stopOpacity", 0.4489), _ref184)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F4F1DE",
    stopOpacity: 0.1444,
    style: (_ref185 = {
      stopColor: "#F4F1DE"
    }, _defineProperty(_ref185, "stopColor", "color(display-p3 0.9569 0.9451 0.8706)"), _defineProperty(_ref185, "stopOpacity", 0.1444), _ref185)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FAF9F0",
    stopOpacity: 0.0324,
    style: (_ref186 = {
      stopColor: "#FAF9F0"
    }, _defineProperty(_ref186, "stopColor", "color(display-p3 0.9804 0.9765 0.9412)"), _defineProperty(_ref186, "stopOpacity", 0.0324), _ref186)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#FDFDFA",
    stopOpacity: 0.01,
    style: (_ref187 = {
      stopColor: "#FDFDFA"
    }, _defineProperty(_ref187, "stopColor", "color(display-p3 0.9922 0.9922 0.9804)"), _defineProperty(_ref187, "stopOpacity", 0.01), _ref187)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(155.015 134.473) rotate(-180) scale(1.46121 1.45676)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4E6",
    style: (_ref188 = {
      stopColor: "#FFF4E6"
    }, _defineProperty(_ref188, "stopColor", "color(display-p3 1.0000 0.9569 0.9020)"), _defineProperty(_ref188, "stopOpacity", 1), _ref188)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FBF0DD",
    style: (_ref189 = {
      stopColor: "#FBF0DD"
    }, _defineProperty(_ref189, "stopColor", "color(display-p3 0.9843 0.9412 0.8667)"), _defineProperty(_ref189, "stopOpacity", 1), _ref189)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F0E7C7",
    style: (_ref190 = {
      stopColor: "#F0E7C7"
    }, _defineProperty(_ref190, "stopColor", "color(display-p3 0.9412 0.9059 0.7804)"), _defineProperty(_ref190, "stopOpacity", 1), _ref190)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E4DDAB",
    style: (_ref191 = {
      stopColor: "#E4DDAB"
    }, _defineProperty(_ref191, "stopColor", "color(display-p3 0.8941 0.8667 0.6706)"), _defineProperty(_ref191, "stopOpacity", 1), _ref191)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#ECE8C6",
    stopOpacity: 0.4489,
    style: (_ref192 = {
      stopColor: "#ECE8C6"
    }, _defineProperty(_ref192, "stopColor", "color(display-p3 0.9255 0.9098 0.7765)"), _defineProperty(_ref192, "stopOpacity", 0.4489), _ref192)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F4F1DE",
    stopOpacity: 0.1444,
    style: (_ref193 = {
      stopColor: "#F4F1DE"
    }, _defineProperty(_ref193, "stopColor", "color(display-p3 0.9569 0.9451 0.8706)"), _defineProperty(_ref193, "stopOpacity", 0.1444), _ref193)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FAF9F0",
    stopOpacity: 0.0324,
    style: (_ref194 = {
      stopColor: "#FAF9F0"
    }, _defineProperty(_ref194, "stopColor", "color(display-p3 0.9804 0.9765 0.9412)"), _defineProperty(_ref194, "stopOpacity", 0.0324), _ref194)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#FDFDFA",
    stopOpacity: 0.01,
    style: (_ref195 = {
      stopColor: "#FDFDFA"
    }, _defineProperty(_ref195, "stopColor", "color(display-p3 0.9922 0.9922 0.9804)"), _defineProperty(_ref195, "stopOpacity", 0.01), _ref195)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(126.613 138.74) rotate(180) scale(1.46121 1.45676)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4E6",
    style: (_ref196 = {
      stopColor: "#FFF4E6"
    }, _defineProperty(_ref196, "stopColor", "color(display-p3 1.0000 0.9569 0.9020)"), _defineProperty(_ref196, "stopOpacity", 1), _ref196)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FBF0DD",
    style: (_ref197 = {
      stopColor: "#FBF0DD"
    }, _defineProperty(_ref197, "stopColor", "color(display-p3 0.9843 0.9412 0.8667)"), _defineProperty(_ref197, "stopOpacity", 1), _ref197)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F0E7C7",
    style: (_ref198 = {
      stopColor: "#F0E7C7"
    }, _defineProperty(_ref198, "stopColor", "color(display-p3 0.9412 0.9059 0.7804)"), _defineProperty(_ref198, "stopOpacity", 1), _ref198)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E4DDAB",
    style: (_ref199 = {
      stopColor: "#E4DDAB"
    }, _defineProperty(_ref199, "stopColor", "color(display-p3 0.8941 0.8667 0.6706)"), _defineProperty(_ref199, "stopOpacity", 1), _ref199)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#ECE8C6",
    stopOpacity: 0.4489,
    style: (_ref200 = {
      stopColor: "#ECE8C6"
    }, _defineProperty(_ref200, "stopColor", "color(display-p3 0.9255 0.9098 0.7765)"), _defineProperty(_ref200, "stopOpacity", 0.4489), _ref200)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F4F1DE",
    stopOpacity: 0.1444,
    style: (_ref201 = {
      stopColor: "#F4F1DE"
    }, _defineProperty(_ref201, "stopColor", "color(display-p3 0.9569 0.9451 0.8706)"), _defineProperty(_ref201, "stopOpacity", 0.1444), _ref201)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FAF9F0",
    stopOpacity: 0.0324,
    style: (_ref202 = {
      stopColor: "#FAF9F0"
    }, _defineProperty(_ref202, "stopColor", "color(display-p3 0.9804 0.9765 0.9412)"), _defineProperty(_ref202, "stopOpacity", 0.0324), _ref202)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#FDFDFA",
    stopOpacity: 0.01,
    style: (_ref203 = {
      stopColor: "#FDFDFA"
    }, _defineProperty(_ref203, "stopColor", "color(display-p3 0.9922 0.9922 0.9804)"), _defineProperty(_ref203, "stopOpacity", 0.01), _ref203)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(153.823 71.7961) rotate(180) scale(1.46121 1.45676)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4E6",
    style: (_ref204 = {
      stopColor: "#FFF4E6"
    }, _defineProperty(_ref204, "stopColor", "color(display-p3 1.0000 0.9569 0.9020)"), _defineProperty(_ref204, "stopOpacity", 1), _ref204)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FBF0DD",
    style: (_ref205 = {
      stopColor: "#FBF0DD"
    }, _defineProperty(_ref205, "stopColor", "color(display-p3 0.9843 0.9412 0.8667)"), _defineProperty(_ref205, "stopOpacity", 1), _ref205)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F0E7C7",
    style: (_ref206 = {
      stopColor: "#F0E7C7"
    }, _defineProperty(_ref206, "stopColor", "color(display-p3 0.9412 0.9059 0.7804)"), _defineProperty(_ref206, "stopOpacity", 1), _ref206)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E4DDAB",
    style: (_ref207 = {
      stopColor: "#E4DDAB"
    }, _defineProperty(_ref207, "stopColor", "color(display-p3 0.8941 0.8667 0.6706)"), _defineProperty(_ref207, "stopOpacity", 1), _ref207)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#ECE8C6",
    stopOpacity: 0.4489,
    style: (_ref208 = {
      stopColor: "#ECE8C6"
    }, _defineProperty(_ref208, "stopColor", "color(display-p3 0.9255 0.9098 0.7765)"), _defineProperty(_ref208, "stopOpacity", 0.4489), _ref208)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F4F1DE",
    stopOpacity: 0.1444,
    style: (_ref209 = {
      stopColor: "#F4F1DE"
    }, _defineProperty(_ref209, "stopColor", "color(display-p3 0.9569 0.9451 0.8706)"), _defineProperty(_ref209, "stopOpacity", 0.1444), _ref209)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FAF9F0",
    stopOpacity: 0.0324,
    style: (_ref210 = {
      stopColor: "#FAF9F0"
    }, _defineProperty(_ref210, "stopColor", "color(display-p3 0.9804 0.9765 0.9412)"), _defineProperty(_ref210, "stopOpacity", 0.0324), _ref210)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#FDFDFA",
    stopOpacity: 0.01,
    style: (_ref211 = {
      stopColor: "#FDFDFA"
    }, _defineProperty(_ref211, "stopColor", "color(display-p3 0.9922 0.9922 0.9804)"), _defineProperty(_ref211, "stopOpacity", 0.01), _ref211)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(92.9124 21.5959) rotate(180) scale(1.46121 1.45676)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4E6",
    style: (_ref212 = {
      stopColor: "#FFF4E6"
    }, _defineProperty(_ref212, "stopColor", "color(display-p3 1.0000 0.9569 0.9020)"), _defineProperty(_ref212, "stopOpacity", 1), _ref212)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FBF0DD",
    style: (_ref213 = {
      stopColor: "#FBF0DD"
    }, _defineProperty(_ref213, "stopColor", "color(display-p3 0.9843 0.9412 0.8667)"), _defineProperty(_ref213, "stopOpacity", 1), _ref213)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F0E7C7",
    style: (_ref214 = {
      stopColor: "#F0E7C7"
    }, _defineProperty(_ref214, "stopColor", "color(display-p3 0.9412 0.9059 0.7804)"), _defineProperty(_ref214, "stopOpacity", 1), _ref214)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E4DDAB",
    style: (_ref215 = {
      stopColor: "#E4DDAB"
    }, _defineProperty(_ref215, "stopColor", "color(display-p3 0.8941 0.8667 0.6706)"), _defineProperty(_ref215, "stopOpacity", 1), _ref215)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#ECE8C6",
    stopOpacity: 0.4489,
    style: (_ref216 = {
      stopColor: "#ECE8C6"
    }, _defineProperty(_ref216, "stopColor", "color(display-p3 0.9255 0.9098 0.7765)"), _defineProperty(_ref216, "stopOpacity", 0.4489), _ref216)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F4F1DE",
    stopOpacity: 0.1444,
    style: (_ref217 = {
      stopColor: "#F4F1DE"
    }, _defineProperty(_ref217, "stopColor", "color(display-p3 0.9569 0.9451 0.8706)"), _defineProperty(_ref217, "stopOpacity", 0.1444), _ref217)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FAF9F0",
    stopOpacity: 0.0324,
    style: (_ref218 = {
      stopColor: "#FAF9F0"
    }, _defineProperty(_ref218, "stopColor", "color(display-p3 0.9804 0.9765 0.9412)"), _defineProperty(_ref218, "stopOpacity", 0.0324), _ref218)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#FDFDFA",
    stopOpacity: 0.01,
    style: (_ref219 = {
      stopColor: "#FDFDFA"
    }, _defineProperty(_ref219, "stopColor", "color(display-p3 0.9922 0.9922 0.9804)"), _defineProperty(_ref219, "stopOpacity", 0.01), _ref219)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(161.489 61.5026) rotate(180) scale(1.46121 1.45676)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC",
    style: (_ref220 = {
      stopColor: "#CCCCCC"
    }, _defineProperty(_ref220, "stopColor", "color(display-p3 0.8000 0.8000 0.8000)"), _defineProperty(_ref220, "stopOpacity", 1), _ref220)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#D4D2C9",
    style: (_ref221 = {
      stopColor: "#D4D2C9"
    }, _defineProperty(_ref221, "stopColor", "color(display-p3 0.8314 0.8235 0.7882)"), _defineProperty(_ref221, "stopOpacity", 1), _ref221)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#EAE5C2",
    style: (_ref222 = {
      stopColor: "#EAE5C2"
    }, _defineProperty(_ref222, "stopColor", "color(display-p3 0.9176 0.8980 0.7608)"), _defineProperty(_ref222, "stopOpacity", 1), _ref222)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFF6BD",
    style: (_ref223 = {
      stopColor: "#FFF6BD"
    }, _defineProperty(_ref223, "stopColor", "color(display-p3 1.0000 0.9647 0.7412)"), _defineProperty(_ref223, "stopOpacity", 1), _ref223)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FFF6C1",
    stopOpacity: 0.8649,
    style: (_ref224 = {
      stopColor: "#FFF6C1"
    }, _defineProperty(_ref224, "stopColor", "color(display-p3 1.0000 0.9647 0.7569)"), _defineProperty(_ref224, "stopOpacity", 0.8649), _ref224)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FFF9D7",
    stopOpacity: 0.36,
    style: (_ref225 = {
      stopColor: "#FFF9D7"
    }, _defineProperty(_ref225, "stopColor", "color(display-p3 1.0000 0.9765 0.8431)"), _defineProperty(_ref225, "stopOpacity", 0.36), _ref225)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FFFBE8",
    stopOpacity: 0.1156,
    style: (_ref226 = {
      stopColor: "#FFFBE8"
    }, _defineProperty(_ref226, "stopColor", "color(display-p3 1.0000 0.9843 0.9098)"), _defineProperty(_ref226, "stopOpacity", 0.1156), _ref226)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FFFDF4",
    stopOpacity: 0.0256,
    style: (_ref227 = {
      stopColor: "#FFFDF4"
    }, _defineProperty(_ref227, "stopColor", "color(display-p3 1.0000 0.9922 0.9569)"), _defineProperty(_ref227, "stopOpacity", 0.0256), _ref227)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#FFFEFC",
    stopOpacity: 0.01,
    style: (_ref228 = {
      stopColor: "#FFFEFC"
    }, _defineProperty(_ref228, "stopColor", "color(display-p3 1.0000 0.9961 0.9882)"), _defineProperty(_ref228, "stopOpacity", 0.01), _ref228)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(70.185 20.8288) rotate(-180) scale(0.090533 0.0902577)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC",
    style: (_ref229 = {
      stopColor: "#CCCCCC"
    }, _defineProperty(_ref229, "stopColor", "color(display-p3 0.8000 0.8000 0.8000)"), _defineProperty(_ref229, "stopOpacity", 1), _ref229)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#D4D2C9",
    style: (_ref230 = {
      stopColor: "#D4D2C9"
    }, _defineProperty(_ref230, "stopColor", "color(display-p3 0.8314 0.8235 0.7882)"), _defineProperty(_ref230, "stopOpacity", 1), _ref230)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#EAE5C2",
    style: (_ref231 = {
      stopColor: "#EAE5C2"
    }, _defineProperty(_ref231, "stopColor", "color(display-p3 0.9176 0.8980 0.7608)"), _defineProperty(_ref231, "stopOpacity", 1), _ref231)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFF6BD",
    style: (_ref232 = {
      stopColor: "#FFF6BD"
    }, _defineProperty(_ref232, "stopColor", "color(display-p3 1.0000 0.9647 0.7412)"), _defineProperty(_ref232, "stopOpacity", 1), _ref232)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FFF6C1",
    stopOpacity: 0.8649,
    style: (_ref233 = {
      stopColor: "#FFF6C1"
    }, _defineProperty(_ref233, "stopColor", "color(display-p3 1.0000 0.9647 0.7569)"), _defineProperty(_ref233, "stopOpacity", 0.8649), _ref233)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FFF9D7",
    stopOpacity: 0.36,
    style: (_ref234 = {
      stopColor: "#FFF9D7"
    }, _defineProperty(_ref234, "stopColor", "color(display-p3 1.0000 0.9765 0.8431)"), _defineProperty(_ref234, "stopOpacity", 0.36), _ref234)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FFFBE8",
    stopOpacity: 0.1156,
    style: (_ref235 = {
      stopColor: "#FFFBE8"
    }, _defineProperty(_ref235, "stopColor", "color(display-p3 1.0000 0.9843 0.9098)"), _defineProperty(_ref235, "stopOpacity", 0.1156), _ref235)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FFFDF4",
    stopOpacity: 0.0256,
    style: (_ref236 = {
      stopColor: "#FFFDF4"
    }, _defineProperty(_ref236, "stopColor", "color(display-p3 1.0000 0.9922 0.9569)"), _defineProperty(_ref236, "stopOpacity", 0.0256), _ref236)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#FFFEFC",
    stopOpacity: 0.01,
    style: (_ref237 = {
      stopColor: "#FFFEFC"
    }, _defineProperty(_ref237, "stopColor", "color(display-p3 1.0000 0.9961 0.9882)"), _defineProperty(_ref237, "stopOpacity", 0.01), _ref237)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(114.027 20.0897) rotate(180) scale(0.0905332 0.0902577)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC",
    style: (_ref238 = {
      stopColor: "#CCCCCC"
    }, _defineProperty(_ref238, "stopColor", "color(display-p3 0.8000 0.8000 0.8000)"), _defineProperty(_ref238, "stopOpacity", 1), _ref238)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#D4D2C9",
    style: (_ref239 = {
      stopColor: "#D4D2C9"
    }, _defineProperty(_ref239, "stopColor", "color(display-p3 0.8314 0.8235 0.7882)"), _defineProperty(_ref239, "stopOpacity", 1), _ref239)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#EAE5C2",
    style: (_ref240 = {
      stopColor: "#EAE5C2"
    }, _defineProperty(_ref240, "stopColor", "color(display-p3 0.9176 0.8980 0.7608)"), _defineProperty(_ref240, "stopOpacity", 1), _ref240)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFF6BD",
    style: (_ref241 = {
      stopColor: "#FFF6BD"
    }, _defineProperty(_ref241, "stopColor", "color(display-p3 1.0000 0.9647 0.7412)"), _defineProperty(_ref241, "stopOpacity", 1), _ref241)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FFF6C1",
    stopOpacity: 0.8649,
    style: (_ref242 = {
      stopColor: "#FFF6C1"
    }, _defineProperty(_ref242, "stopColor", "color(display-p3 1.0000 0.9647 0.7569)"), _defineProperty(_ref242, "stopOpacity", 0.8649), _ref242)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FFF9D7",
    stopOpacity: 0.36,
    style: (_ref243 = {
      stopColor: "#FFF9D7"
    }, _defineProperty(_ref243, "stopColor", "color(display-p3 1.0000 0.9765 0.8431)"), _defineProperty(_ref243, "stopOpacity", 0.36), _ref243)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FFFBE8",
    stopOpacity: 0.1156,
    style: (_ref244 = {
      stopColor: "#FFFBE8"
    }, _defineProperty(_ref244, "stopColor", "color(display-p3 1.0000 0.9843 0.9098)"), _defineProperty(_ref244, "stopOpacity", 0.1156), _ref244)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FFFDF4",
    stopOpacity: 0.0256,
    style: (_ref245 = {
      stopColor: "#FFFDF4"
    }, _defineProperty(_ref245, "stopColor", "color(display-p3 1.0000 0.9922 0.9569)"), _defineProperty(_ref245, "stopOpacity", 0.0256), _ref245)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#FFFEFC",
    stopOpacity: 0.01,
    style: (_ref246 = {
      stopColor: "#FFFEFC"
    }, _defineProperty(_ref246, "stopColor", "color(display-p3 1.0000 0.9961 0.9882)"), _defineProperty(_ref246, "stopOpacity", 0.01), _ref246)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(143.664 36.1457) rotate(180) scale(1.4612 1.45676)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC",
    style: (_ref247 = {
      stopColor: "#CCCCCC"
    }, _defineProperty(_ref247, "stopColor", "color(display-p3 0.8000 0.8000 0.8000)"), _defineProperty(_ref247, "stopOpacity", 1), _ref247)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#D4D2C9",
    style: (_ref248 = {
      stopColor: "#D4D2C9"
    }, _defineProperty(_ref248, "stopColor", "color(display-p3 0.8314 0.8235 0.7882)"), _defineProperty(_ref248, "stopOpacity", 1), _ref248)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#EAE5C2",
    style: (_ref249 = {
      stopColor: "#EAE5C2"
    }, _defineProperty(_ref249, "stopColor", "color(display-p3 0.9176 0.8980 0.7608)"), _defineProperty(_ref249, "stopOpacity", 1), _ref249)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFF6BD",
    style: (_ref250 = {
      stopColor: "#FFF6BD"
    }, _defineProperty(_ref250, "stopColor", "color(display-p3 1.0000 0.9647 0.7412)"), _defineProperty(_ref250, "stopOpacity", 1), _ref250)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FFF6C1",
    stopOpacity: 0.8649,
    style: (_ref251 = {
      stopColor: "#FFF6C1"
    }, _defineProperty(_ref251, "stopColor", "color(display-p3 1.0000 0.9647 0.7569)"), _defineProperty(_ref251, "stopOpacity", 0.8649), _ref251)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FFF9D7",
    stopOpacity: 0.36,
    style: (_ref252 = {
      stopColor: "#FFF9D7"
    }, _defineProperty(_ref252, "stopColor", "color(display-p3 1.0000 0.9765 0.8431)"), _defineProperty(_ref252, "stopOpacity", 0.36), _ref252)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FFFBE8",
    stopOpacity: 0.1156,
    style: (_ref253 = {
      stopColor: "#FFFBE8"
    }, _defineProperty(_ref253, "stopColor", "color(display-p3 1.0000 0.9843 0.9098)"), _defineProperty(_ref253, "stopOpacity", 0.1156), _ref253)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FFFDF4",
    stopOpacity: 0.0256,
    style: (_ref254 = {
      stopColor: "#FFFDF4"
    }, _defineProperty(_ref254, "stopColor", "color(display-p3 1.0000 0.9922 0.9569)"), _defineProperty(_ref254, "stopOpacity", 0.0256), _ref254)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#FFFEFC",
    stopOpacity: 0.01,
    style: (_ref255 = {
      stopColor: "#FFFEFC"
    }, _defineProperty(_ref255, "stopColor", "color(display-p3 1.0000 0.9961 0.9882)"), _defineProperty(_ref255, "stopOpacity", 0.01), _ref255)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(99.0862 17.5995) rotate(180) scale(1.46121 1.45676)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC",
    style: (_ref256 = {
      stopColor: "#CCCCCC"
    }, _defineProperty(_ref256, "stopColor", "color(display-p3 0.8000 0.8000 0.8000)"), _defineProperty(_ref256, "stopOpacity", 1), _ref256)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#D4D2C9",
    style: (_ref257 = {
      stopColor: "#D4D2C9"
    }, _defineProperty(_ref257, "stopColor", "color(display-p3 0.8314 0.8235 0.7882)"), _defineProperty(_ref257, "stopOpacity", 1), _ref257)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#EAE5C2",
    style: (_ref258 = {
      stopColor: "#EAE5C2"
    }, _defineProperty(_ref258, "stopColor", "color(display-p3 0.9176 0.8980 0.7608)"), _defineProperty(_ref258, "stopOpacity", 1), _ref258)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFF6BD",
    style: (_ref259 = {
      stopColor: "#FFF6BD"
    }, _defineProperty(_ref259, "stopColor", "color(display-p3 1.0000 0.9647 0.7412)"), _defineProperty(_ref259, "stopOpacity", 1), _ref259)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FFF6C1",
    stopOpacity: 0.8649,
    style: (_ref260 = {
      stopColor: "#FFF6C1"
    }, _defineProperty(_ref260, "stopColor", "color(display-p3 1.0000 0.9647 0.7569)"), _defineProperty(_ref260, "stopOpacity", 0.8649), _ref260)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FFF9D7",
    stopOpacity: 0.36,
    style: (_ref261 = {
      stopColor: "#FFF9D7"
    }, _defineProperty(_ref261, "stopColor", "color(display-p3 1.0000 0.9765 0.8431)"), _defineProperty(_ref261, "stopOpacity", 0.36), _ref261)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FFFBE8",
    stopOpacity: 0.1156,
    style: (_ref262 = {
      stopColor: "#FFFBE8"
    }, _defineProperty(_ref262, "stopColor", "color(display-p3 1.0000 0.9843 0.9098)"), _defineProperty(_ref262, "stopOpacity", 0.1156), _ref262)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FFFDF4",
    stopOpacity: 0.0256,
    style: (_ref263 = {
      stopColor: "#FFFDF4"
    }, _defineProperty(_ref263, "stopColor", "color(display-p3 1.0000 0.9922 0.9569)"), _defineProperty(_ref263, "stopOpacity", 0.0256), _ref263)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#FFFEFC",
    stopOpacity: 0.01,
    style: (_ref264 = {
      stopColor: "#FFFEFC"
    }, _defineProperty(_ref264, "stopColor", "color(display-p3 1.0000 0.9961 0.9882)"), _defineProperty(_ref264, "stopOpacity", 0.01), _ref264)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.1801 37.9609) rotate(180) scale(0.0905332 0.0902576)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC",
    style: (_ref265 = {
      stopColor: "#CCCCCC"
    }, _defineProperty(_ref265, "stopColor", "color(display-p3 0.8000 0.8000 0.8000)"), _defineProperty(_ref265, "stopOpacity", 1), _ref265)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#D4D2C9",
    style: (_ref266 = {
      stopColor: "#D4D2C9"
    }, _defineProperty(_ref266, "stopColor", "color(display-p3 0.8314 0.8235 0.7882)"), _defineProperty(_ref266, "stopOpacity", 1), _ref266)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#EAE5C2",
    style: (_ref267 = {
      stopColor: "#EAE5C2"
    }, _defineProperty(_ref267, "stopColor", "color(display-p3 0.9176 0.8980 0.7608)"), _defineProperty(_ref267, "stopOpacity", 1), _ref267)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFF6BD",
    style: (_ref268 = {
      stopColor: "#FFF6BD"
    }, _defineProperty(_ref268, "stopColor", "color(display-p3 1.0000 0.9647 0.7412)"), _defineProperty(_ref268, "stopOpacity", 1), _ref268)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FFF6C1",
    stopOpacity: 0.8649,
    style: (_ref269 = {
      stopColor: "#FFF6C1"
    }, _defineProperty(_ref269, "stopColor", "color(display-p3 1.0000 0.9647 0.7569)"), _defineProperty(_ref269, "stopOpacity", 0.8649), _ref269)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FFF9D7",
    stopOpacity: 0.36,
    style: (_ref270 = {
      stopColor: "#FFF9D7"
    }, _defineProperty(_ref270, "stopColor", "color(display-p3 1.0000 0.9765 0.8431)"), _defineProperty(_ref270, "stopOpacity", 0.36), _ref270)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FFFBE8",
    stopOpacity: 0.1156,
    style: (_ref271 = {
      stopColor: "#FFFBE8"
    }, _defineProperty(_ref271, "stopColor", "color(display-p3 1.0000 0.9843 0.9098)"), _defineProperty(_ref271, "stopOpacity", 0.1156), _ref271)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FFFDF4",
    stopOpacity: 0.0256,
    style: (_ref272 = {
      stopColor: "#FFFDF4"
    }, _defineProperty(_ref272, "stopColor", "color(display-p3 1.0000 0.9922 0.9569)"), _defineProperty(_ref272, "stopOpacity", 0.0256), _ref272)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#FFFEFC",
    stopOpacity: 0.01,
    style: (_ref273 = {
      stopColor: "#FFFEFC"
    }, _defineProperty(_ref273, "stopColor", "color(display-p3 1.0000 0.9961 0.9882)"), _defineProperty(_ref273, "stopOpacity", 0.01), _ref273)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.1792 28.8773) rotate(180) scale(1.46121 1.45676)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC",
    style: (_ref274 = {
      stopColor: "#CCCCCC"
    }, _defineProperty(_ref274, "stopColor", "color(display-p3 0.8000 0.8000 0.8000)"), _defineProperty(_ref274, "stopOpacity", 1), _ref274)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#D4D2C9",
    style: (_ref275 = {
      stopColor: "#D4D2C9"
    }, _defineProperty(_ref275, "stopColor", "color(display-p3 0.8314 0.8235 0.7882)"), _defineProperty(_ref275, "stopOpacity", 1), _ref275)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#EAE5C2",
    style: (_ref276 = {
      stopColor: "#EAE5C2"
    }, _defineProperty(_ref276, "stopColor", "color(display-p3 0.9176 0.8980 0.7608)"), _defineProperty(_ref276, "stopOpacity", 1), _ref276)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFF6BD",
    style: (_ref277 = {
      stopColor: "#FFF6BD"
    }, _defineProperty(_ref277, "stopColor", "color(display-p3 1.0000 0.9647 0.7412)"), _defineProperty(_ref277, "stopOpacity", 1), _ref277)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FFF6C1",
    stopOpacity: 0.8649,
    style: (_ref278 = {
      stopColor: "#FFF6C1"
    }, _defineProperty(_ref278, "stopColor", "color(display-p3 1.0000 0.9647 0.7569)"), _defineProperty(_ref278, "stopOpacity", 0.8649), _ref278)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FFF9D7",
    stopOpacity: 0.36,
    style: (_ref279 = {
      stopColor: "#FFF9D7"
    }, _defineProperty(_ref279, "stopColor", "color(display-p3 1.0000 0.9765 0.8431)"), _defineProperty(_ref279, "stopOpacity", 0.36), _ref279)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FFFBE8",
    stopOpacity: 0.1156,
    style: (_ref280 = {
      stopColor: "#FFFBE8"
    }, _defineProperty(_ref280, "stopColor", "color(display-p3 1.0000 0.9843 0.9098)"), _defineProperty(_ref280, "stopOpacity", 0.1156), _ref280)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FFFDF4",
    stopOpacity: 0.0256,
    style: (_ref281 = {
      stopColor: "#FFFDF4"
    }, _defineProperty(_ref281, "stopColor", "color(display-p3 1.0000 0.9922 0.9569)"), _defineProperty(_ref281, "stopOpacity", 0.0256), _ref281)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#FFFEFC",
    stopOpacity: 0.01,
    style: (_ref282 = {
      stopColor: "#FFFEFC"
    }, _defineProperty(_ref282, "stopColor", "color(display-p3 1.0000 0.9961 0.9882)"), _defineProperty(_ref282, "stopOpacity", 0.01), _ref282)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.9499 52.1361) rotate(-180) scale(0.0905332 0.0902578)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC",
    style: (_ref283 = {
      stopColor: "#CCCCCC"
    }, _defineProperty(_ref283, "stopColor", "color(display-p3 0.8000 0.8000 0.8000)"), _defineProperty(_ref283, "stopOpacity", 1), _ref283)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#D4D2C9",
    style: (_ref284 = {
      stopColor: "#D4D2C9"
    }, _defineProperty(_ref284, "stopColor", "color(display-p3 0.8314 0.8235 0.7882)"), _defineProperty(_ref284, "stopOpacity", 1), _ref284)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#EAE5C2",
    style: (_ref285 = {
      stopColor: "#EAE5C2"
    }, _defineProperty(_ref285, "stopColor", "color(display-p3 0.9176 0.8980 0.7608)"), _defineProperty(_ref285, "stopOpacity", 1), _ref285)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFF6BD",
    style: (_ref286 = {
      stopColor: "#FFF6BD"
    }, _defineProperty(_ref286, "stopColor", "color(display-p3 1.0000 0.9647 0.7412)"), _defineProperty(_ref286, "stopOpacity", 1), _ref286)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FFF6C1",
    stopOpacity: 0.8649,
    style: (_ref287 = {
      stopColor: "#FFF6C1"
    }, _defineProperty(_ref287, "stopColor", "color(display-p3 1.0000 0.9647 0.7569)"), _defineProperty(_ref287, "stopOpacity", 0.8649), _ref287)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FFF9D7",
    stopOpacity: 0.36,
    style: (_ref288 = {
      stopColor: "#FFF9D7"
    }, _defineProperty(_ref288, "stopColor", "color(display-p3 1.0000 0.9765 0.8431)"), _defineProperty(_ref288, "stopOpacity", 0.36), _ref288)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FFFBE8",
    stopOpacity: 0.1156,
    style: (_ref289 = {
      stopColor: "#FFFBE8"
    }, _defineProperty(_ref289, "stopColor", "color(display-p3 1.0000 0.9843 0.9098)"), _defineProperty(_ref289, "stopOpacity", 0.1156), _ref289)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FFFDF4",
    stopOpacity: 0.0256,
    style: (_ref290 = {
      stopColor: "#FFFDF4"
    }, _defineProperty(_ref290, "stopColor", "color(display-p3 1.0000 0.9922 0.9569)"), _defineProperty(_ref290, "stopOpacity", 0.0256), _ref290)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#FFFEFC",
    stopOpacity: 0.01,
    style: (_ref291 = {
      stopColor: "#FFFEFC"
    }, _defineProperty(_ref291, "stopColor", "color(display-p3 1.0000 0.9961 0.9882)"), _defineProperty(_ref291, "stopOpacity", 0.01), _ref291)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.0255 117.046) rotate(180) scale(1.4612 1.45676)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC",
    style: (_ref292 = {
      stopColor: "#CCCCCC"
    }, _defineProperty(_ref292, "stopColor", "color(display-p3 0.8000 0.8000 0.8000)"), _defineProperty(_ref292, "stopOpacity", 1), _ref292)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#D4D2C9",
    style: (_ref293 = {
      stopColor: "#D4D2C9"
    }, _defineProperty(_ref293, "stopColor", "color(display-p3 0.8314 0.8235 0.7882)"), _defineProperty(_ref293, "stopOpacity", 1), _ref293)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#EAE5C2",
    style: (_ref294 = {
      stopColor: "#EAE5C2"
    }, _defineProperty(_ref294, "stopColor", "color(display-p3 0.9176 0.8980 0.7608)"), _defineProperty(_ref294, "stopOpacity", 1), _ref294)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFF6BD",
    style: (_ref295 = {
      stopColor: "#FFF6BD"
    }, _defineProperty(_ref295, "stopColor", "color(display-p3 1.0000 0.9647 0.7412)"), _defineProperty(_ref295, "stopOpacity", 1), _ref295)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FFF6C1",
    stopOpacity: 0.8649,
    style: (_ref296 = {
      stopColor: "#FFF6C1"
    }, _defineProperty(_ref296, "stopColor", "color(display-p3 1.0000 0.9647 0.7569)"), _defineProperty(_ref296, "stopOpacity", 0.8649), _ref296)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FFF9D7",
    stopOpacity: 0.36,
    style: (_ref297 = {
      stopColor: "#FFF9D7"
    }, _defineProperty(_ref297, "stopColor", "color(display-p3 1.0000 0.9765 0.8431)"), _defineProperty(_ref297, "stopOpacity", 0.36), _ref297)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FFFBE8",
    stopOpacity: 0.1156,
    style: (_ref298 = {
      stopColor: "#FFFBE8"
    }, _defineProperty(_ref298, "stopColor", "color(display-p3 1.0000 0.9843 0.9098)"), _defineProperty(_ref298, "stopOpacity", 0.1156), _ref298)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FFFDF4",
    stopOpacity: 0.0256,
    style: (_ref299 = {
      stopColor: "#FFFDF4"
    }, _defineProperty(_ref299, "stopColor", "color(display-p3 1.0000 0.9922 0.9569)"), _defineProperty(_ref299, "stopOpacity", 0.0256), _ref299)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#FFFEFC",
    stopOpacity: 0.01,
    style: (_ref300 = {
      stopColor: "#FFFEFC"
    }, _defineProperty(_ref300, "stopColor", "color(display-p3 1.0000 0.9961 0.9882)"), _defineProperty(_ref300, "stopOpacity", 0.01), _ref300)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.1134 96.9104) rotate(180) scale(1.46121 1.45676)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC",
    style: (_ref301 = {
      stopColor: "#CCCCCC"
    }, _defineProperty(_ref301, "stopColor", "color(display-p3 0.8000 0.8000 0.8000)"), _defineProperty(_ref301, "stopOpacity", 1), _ref301)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#D4D2C9",
    style: (_ref302 = {
      stopColor: "#D4D2C9"
    }, _defineProperty(_ref302, "stopColor", "color(display-p3 0.8314 0.8235 0.7882)"), _defineProperty(_ref302, "stopOpacity", 1), _ref302)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#EAE5C2",
    style: (_ref303 = {
      stopColor: "#EAE5C2"
    }, _defineProperty(_ref303, "stopColor", "color(display-p3 0.9176 0.8980 0.7608)"), _defineProperty(_ref303, "stopOpacity", 1), _ref303)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFF6BD",
    style: (_ref304 = {
      stopColor: "#FFF6BD"
    }, _defineProperty(_ref304, "stopColor", "color(display-p3 1.0000 0.9647 0.7412)"), _defineProperty(_ref304, "stopOpacity", 1), _ref304)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FFF6C1",
    stopOpacity: 0.8649,
    style: (_ref305 = {
      stopColor: "#FFF6C1"
    }, _defineProperty(_ref305, "stopColor", "color(display-p3 1.0000 0.9647 0.7569)"), _defineProperty(_ref305, "stopOpacity", 0.8649), _ref305)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FFF9D7",
    stopOpacity: 0.36,
    style: (_ref306 = {
      stopColor: "#FFF9D7"
    }, _defineProperty(_ref306, "stopColor", "color(display-p3 1.0000 0.9765 0.8431)"), _defineProperty(_ref306, "stopOpacity", 0.36), _ref306)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FFFBE8",
    stopOpacity: 0.1156,
    style: (_ref307 = {
      stopColor: "#FFFBE8"
    }, _defineProperty(_ref307, "stopColor", "color(display-p3 1.0000 0.9843 0.9098)"), _defineProperty(_ref307, "stopOpacity", 0.1156), _ref307)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FFFDF4",
    stopOpacity: 0.0256,
    style: (_ref308 = {
      stopColor: "#FFFDF4"
    }, _defineProperty(_ref308, "stopColor", "color(display-p3 1.0000 0.9922 0.9569)"), _defineProperty(_ref308, "stopOpacity", 0.0256), _ref308)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#FFFEFC",
    stopOpacity: 0.01,
    style: (_ref309 = {
      stopColor: "#FFFEFC"
    }, _defineProperty(_ref309, "stopColor", "color(display-p3 1.0000 0.9961 0.9882)"), _defineProperty(_ref309, "stopOpacity", 0.01), _ref309)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.4582 85.9198) rotate(180) scale(1.46121 1.45676)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC",
    style: (_ref310 = {
      stopColor: "#CCCCCC"
    }, _defineProperty(_ref310, "stopColor", "color(display-p3 0.8000 0.8000 0.8000)"), _defineProperty(_ref310, "stopOpacity", 1), _ref310)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#D4D2C9",
    style: (_ref311 = {
      stopColor: "#D4D2C9"
    }, _defineProperty(_ref311, "stopColor", "color(display-p3 0.8314 0.8235 0.7882)"), _defineProperty(_ref311, "stopOpacity", 1), _ref311)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#EAE5C2",
    style: (_ref312 = {
      stopColor: "#EAE5C2"
    }, _defineProperty(_ref312, "stopColor", "color(display-p3 0.9176 0.8980 0.7608)"), _defineProperty(_ref312, "stopOpacity", 1), _ref312)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFF6BD",
    style: (_ref313 = {
      stopColor: "#FFF6BD"
    }, _defineProperty(_ref313, "stopColor", "color(display-p3 1.0000 0.9647 0.7412)"), _defineProperty(_ref313, "stopOpacity", 1), _ref313)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FFF6C1",
    stopOpacity: 0.8649,
    style: (_ref314 = {
      stopColor: "#FFF6C1"
    }, _defineProperty(_ref314, "stopColor", "color(display-p3 1.0000 0.9647 0.7569)"), _defineProperty(_ref314, "stopOpacity", 0.8649), _ref314)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FFF9D7",
    stopOpacity: 0.36,
    style: (_ref315 = {
      stopColor: "#FFF9D7"
    }, _defineProperty(_ref315, "stopColor", "color(display-p3 1.0000 0.9765 0.8431)"), _defineProperty(_ref315, "stopOpacity", 0.36), _ref315)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FFFBE8",
    stopOpacity: 0.1156,
    style: (_ref316 = {
      stopColor: "#FFFBE8"
    }, _defineProperty(_ref316, "stopColor", "color(display-p3 1.0000 0.9843 0.9098)"), _defineProperty(_ref316, "stopOpacity", 0.1156), _ref316)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FFFDF4",
    stopOpacity: 0.0256,
    style: (_ref317 = {
      stopColor: "#FFFDF4"
    }, _defineProperty(_ref317, "stopColor", "color(display-p3 1.0000 0.9922 0.9569)"), _defineProperty(_ref317, "stopOpacity", 0.0256), _ref317)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#FFFEFC",
    stopOpacity: 0.01,
    style: (_ref318 = {
      stopColor: "#FFFEFC"
    }, _defineProperty(_ref318, "stopColor", "color(display-p3 1.0000 0.9961 0.9882)"), _defineProperty(_ref318, "stopOpacity", 0.01), _ref318)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.5358 92.449) rotate(-180) scale(1.46121 1.45676)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC",
    style: (_ref319 = {
      stopColor: "#CCCCCC"
    }, _defineProperty(_ref319, "stopColor", "color(display-p3 0.8000 0.8000 0.8000)"), _defineProperty(_ref319, "stopOpacity", 1), _ref319)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#D4D2C9",
    style: (_ref320 = {
      stopColor: "#D4D2C9"
    }, _defineProperty(_ref320, "stopColor", "color(display-p3 0.8314 0.8235 0.7882)"), _defineProperty(_ref320, "stopOpacity", 1), _ref320)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#EAE5C2",
    style: (_ref321 = {
      stopColor: "#EAE5C2"
    }, _defineProperty(_ref321, "stopColor", "color(display-p3 0.9176 0.8980 0.7608)"), _defineProperty(_ref321, "stopOpacity", 1), _ref321)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFF6BD",
    style: (_ref322 = {
      stopColor: "#FFF6BD"
    }, _defineProperty(_ref322, "stopColor", "color(display-p3 1.0000 0.9647 0.7412)"), _defineProperty(_ref322, "stopOpacity", 1), _ref322)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FFF6C1",
    stopOpacity: 0.8649,
    style: (_ref323 = {
      stopColor: "#FFF6C1"
    }, _defineProperty(_ref323, "stopColor", "color(display-p3 1.0000 0.9647 0.7569)"), _defineProperty(_ref323, "stopOpacity", 0.8649), _ref323)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FFF9D7",
    stopOpacity: 0.36,
    style: (_ref324 = {
      stopColor: "#FFF9D7"
    }, _defineProperty(_ref324, "stopColor", "color(display-p3 1.0000 0.9765 0.8431)"), _defineProperty(_ref324, "stopOpacity", 0.36), _ref324)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FFFBE8",
    stopOpacity: 0.1156,
    style: (_ref325 = {
      stopColor: "#FFFBE8"
    }, _defineProperty(_ref325, "stopColor", "color(display-p3 1.0000 0.9843 0.9098)"), _defineProperty(_ref325, "stopOpacity", 0.1156), _ref325)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FFFDF4",
    stopOpacity: 0.0256,
    style: (_ref326 = {
      stopColor: "#FFFDF4"
    }, _defineProperty(_ref326, "stopColor", "color(display-p3 1.0000 0.9922 0.9569)"), _defineProperty(_ref326, "stopOpacity", 0.0256), _ref326)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#FFFEFC",
    stopOpacity: 0.01,
    style: (_ref327 = {
      stopColor: "#FFFEFC"
    }, _defineProperty(_ref327, "stopColor", "color(display-p3 1.0000 0.9961 0.9882)"), _defineProperty(_ref327, "stopOpacity", 0.01), _ref327)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.9806 79.4441) rotate(180) scale(1.4612 1.45676)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC",
    style: (_ref328 = {
      stopColor: "#CCCCCC"
    }, _defineProperty(_ref328, "stopColor", "color(display-p3 0.8000 0.8000 0.8000)"), _defineProperty(_ref328, "stopOpacity", 1), _ref328)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#D4D2C9",
    style: (_ref329 = {
      stopColor: "#D4D2C9"
    }, _defineProperty(_ref329, "stopColor", "color(display-p3 0.8314 0.8235 0.7882)"), _defineProperty(_ref329, "stopOpacity", 1), _ref329)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#EAE5C2",
    style: (_ref330 = {
      stopColor: "#EAE5C2"
    }, _defineProperty(_ref330, "stopColor", "color(display-p3 0.9176 0.8980 0.7608)"), _defineProperty(_ref330, "stopOpacity", 1), _ref330)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFF6BD",
    style: (_ref331 = {
      stopColor: "#FFF6BD"
    }, _defineProperty(_ref331, "stopColor", "color(display-p3 1.0000 0.9647 0.7412)"), _defineProperty(_ref331, "stopOpacity", 1), _ref331)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FFF6C1",
    stopOpacity: 0.8649,
    style: (_ref332 = {
      stopColor: "#FFF6C1"
    }, _defineProperty(_ref332, "stopColor", "color(display-p3 1.0000 0.9647 0.7569)"), _defineProperty(_ref332, "stopOpacity", 0.8649), _ref332)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FFF9D7",
    stopOpacity: 0.36,
    style: (_ref333 = {
      stopColor: "#FFF9D7"
    }, _defineProperty(_ref333, "stopColor", "color(display-p3 1.0000 0.9765 0.8431)"), _defineProperty(_ref333, "stopOpacity", 0.36), _ref333)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FFFBE8",
    stopOpacity: 0.1156,
    style: (_ref334 = {
      stopColor: "#FFFBE8"
    }, _defineProperty(_ref334, "stopColor", "color(display-p3 1.0000 0.9843 0.9098)"), _defineProperty(_ref334, "stopOpacity", 0.1156), _ref334)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FFFDF4",
    stopOpacity: 0.0256,
    style: (_ref335 = {
      stopColor: "#FFFDF4"
    }, _defineProperty(_ref335, "stopColor", "color(display-p3 1.0000 0.9922 0.9569)"), _defineProperty(_ref335, "stopOpacity", 0.0256), _ref335)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#FFFEFC",
    stopOpacity: 0.01,
    style: (_ref336 = {
      stopColor: "#FFFEFC"
    }, _defineProperty(_ref336, "stopColor", "color(display-p3 1.0000 0.9961 0.9882)"), _defineProperty(_ref336, "stopOpacity", 0.01), _ref336)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.634 77.9422) rotate(-180) scale(1.4612 1.45676)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC",
    style: (_ref337 = {
      stopColor: "#CCCCCC"
    }, _defineProperty(_ref337, "stopColor", "color(display-p3 0.8000 0.8000 0.8000)"), _defineProperty(_ref337, "stopOpacity", 1), _ref337)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#D4D2C9",
    style: (_ref338 = {
      stopColor: "#D4D2C9"
    }, _defineProperty(_ref338, "stopColor", "color(display-p3 0.8314 0.8235 0.7882)"), _defineProperty(_ref338, "stopOpacity", 1), _ref338)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#EAE5C2",
    style: (_ref339 = {
      stopColor: "#EAE5C2"
    }, _defineProperty(_ref339, "stopColor", "color(display-p3 0.9176 0.8980 0.7608)"), _defineProperty(_ref339, "stopOpacity", 1), _ref339)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFF6BD",
    style: (_ref340 = {
      stopColor: "#FFF6BD"
    }, _defineProperty(_ref340, "stopColor", "color(display-p3 1.0000 0.9647 0.7412)"), _defineProperty(_ref340, "stopOpacity", 1), _ref340)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FFF6C1",
    stopOpacity: 0.8649,
    style: (_ref341 = {
      stopColor: "#FFF6C1"
    }, _defineProperty(_ref341, "stopColor", "color(display-p3 1.0000 0.9647 0.7569)"), _defineProperty(_ref341, "stopOpacity", 0.8649), _ref341)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FFF9D7",
    stopOpacity: 0.36,
    style: (_ref342 = {
      stopColor: "#FFF9D7"
    }, _defineProperty(_ref342, "stopColor", "color(display-p3 1.0000 0.9765 0.8431)"), _defineProperty(_ref342, "stopOpacity", 0.36), _ref342)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FFFBE8",
    stopOpacity: 0.1156,
    style: (_ref343 = {
      stopColor: "#FFFBE8"
    }, _defineProperty(_ref343, "stopColor", "color(display-p3 1.0000 0.9843 0.9098)"), _defineProperty(_ref343, "stopOpacity", 0.1156), _ref343)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FFFDF4",
    stopOpacity: 0.0256,
    style: (_ref344 = {
      stopColor: "#FFFDF4"
    }, _defineProperty(_ref344, "stopColor", "color(display-p3 1.0000 0.9922 0.9569)"), _defineProperty(_ref344, "stopOpacity", 0.0256), _ref344)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#FFFEFC",
    stopOpacity: 0.01,
    style: (_ref345 = {
      stopColor: "#FFFEFC"
    }, _defineProperty(_ref345, "stopColor", "color(display-p3 1.0000 0.9961 0.9882)"), _defineProperty(_ref345, "stopOpacity", 0.01), _ref345)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.1605 125.341) rotate(180) scale(0.0905331 0.0902575)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC",
    style: (_ref346 = {
      stopColor: "#CCCCCC"
    }, _defineProperty(_ref346, "stopColor", "color(display-p3 0.8000 0.8000 0.8000)"), _defineProperty(_ref346, "stopOpacity", 1), _ref346)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#D4D2C9",
    style: (_ref347 = {
      stopColor: "#D4D2C9"
    }, _defineProperty(_ref347, "stopColor", "color(display-p3 0.8314 0.8235 0.7882)"), _defineProperty(_ref347, "stopOpacity", 1), _ref347)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#EAE5C2",
    style: (_ref348 = {
      stopColor: "#EAE5C2"
    }, _defineProperty(_ref348, "stopColor", "color(display-p3 0.9176 0.8980 0.7608)"), _defineProperty(_ref348, "stopOpacity", 1), _ref348)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFF6BD",
    style: (_ref349 = {
      stopColor: "#FFF6BD"
    }, _defineProperty(_ref349, "stopColor", "color(display-p3 1.0000 0.9647 0.7412)"), _defineProperty(_ref349, "stopOpacity", 1), _ref349)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FFF6C1",
    stopOpacity: 0.8649,
    style: (_ref350 = {
      stopColor: "#FFF6C1"
    }, _defineProperty(_ref350, "stopColor", "color(display-p3 1.0000 0.9647 0.7569)"), _defineProperty(_ref350, "stopOpacity", 0.8649), _ref350)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FFF9D7",
    stopOpacity: 0.36,
    style: (_ref351 = {
      stopColor: "#FFF9D7"
    }, _defineProperty(_ref351, "stopColor", "color(display-p3 1.0000 0.9765 0.8431)"), _defineProperty(_ref351, "stopOpacity", 0.36), _ref351)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FFFBE8",
    stopOpacity: 0.1156,
    style: (_ref352 = {
      stopColor: "#FFFBE8"
    }, _defineProperty(_ref352, "stopColor", "color(display-p3 1.0000 0.9843 0.9098)"), _defineProperty(_ref352, "stopOpacity", 0.1156), _ref352)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FFFDF4",
    stopOpacity: 0.0256,
    style: (_ref353 = {
      stopColor: "#FFFDF4"
    }, _defineProperty(_ref353, "stopColor", "color(display-p3 1.0000 0.9922 0.9569)"), _defineProperty(_ref353, "stopOpacity", 0.0256), _ref353)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#FFFEFC",
    stopOpacity: 0.01,
    style: (_ref354 = {
      stopColor: "#FFFEFC"
    }, _defineProperty(_ref354, "stopColor", "color(display-p3 1.0000 0.9961 0.9882)"), _defineProperty(_ref354, "stopOpacity", 0.01), _ref354)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.4358 138.112) rotate(180) scale(1.4612 1.45676)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC",
    style: (_ref355 = {
      stopColor: "#CCCCCC"
    }, _defineProperty(_ref355, "stopColor", "color(display-p3 0.8000 0.8000 0.8000)"), _defineProperty(_ref355, "stopOpacity", 1), _ref355)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#D4D2C9",
    style: (_ref356 = {
      stopColor: "#D4D2C9"
    }, _defineProperty(_ref356, "stopColor", "color(display-p3 0.8314 0.8235 0.7882)"), _defineProperty(_ref356, "stopOpacity", 1), _ref356)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#EAE5C2",
    style: (_ref357 = {
      stopColor: "#EAE5C2"
    }, _defineProperty(_ref357, "stopColor", "color(display-p3 0.9176 0.8980 0.7608)"), _defineProperty(_ref357, "stopOpacity", 1), _ref357)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFF6BD",
    style: (_ref358 = {
      stopColor: "#FFF6BD"
    }, _defineProperty(_ref358, "stopColor", "color(display-p3 1.0000 0.9647 0.7412)"), _defineProperty(_ref358, "stopOpacity", 1), _ref358)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FFF6C1",
    stopOpacity: 0.8649,
    style: (_ref359 = {
      stopColor: "#FFF6C1"
    }, _defineProperty(_ref359, "stopColor", "color(display-p3 1.0000 0.9647 0.7569)"), _defineProperty(_ref359, "stopOpacity", 0.8649), _ref359)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FFF9D7",
    stopOpacity: 0.36,
    style: (_ref360 = {
      stopColor: "#FFF9D7"
    }, _defineProperty(_ref360, "stopColor", "color(display-p3 1.0000 0.9765 0.8431)"), _defineProperty(_ref360, "stopOpacity", 0.36), _ref360)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FFFBE8",
    stopOpacity: 0.1156,
    style: (_ref361 = {
      stopColor: "#FFFBE8"
    }, _defineProperty(_ref361, "stopColor", "color(display-p3 1.0000 0.9843 0.9098)"), _defineProperty(_ref361, "stopOpacity", 0.1156), _ref361)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FFFDF4",
    stopOpacity: 0.0256,
    style: (_ref362 = {
      stopColor: "#FFFDF4"
    }, _defineProperty(_ref362, "stopColor", "color(display-p3 1.0000 0.9922 0.9569)"), _defineProperty(_ref362, "stopOpacity", 0.0256), _ref362)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#FFFEFC",
    stopOpacity: 0.01,
    style: (_ref363 = {
      stopColor: "#FFFEFC"
    }, _defineProperty(_ref363, "stopColor", "color(display-p3 1.0000 0.9961 0.9882)"), _defineProperty(_ref363, "stopOpacity", 0.01), _ref363)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(130.932 66.5586) rotate(-180) scale(1.46121 1.45676)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4E6",
    style: (_ref364 = {
      stopColor: "#FFF4E6"
    }, _defineProperty(_ref364, "stopColor", "color(display-p3 1.0000 0.9569 0.9020)"), _defineProperty(_ref364, "stopOpacity", 1), _ref364)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FBF0DD",
    style: (_ref365 = {
      stopColor: "#FBF0DD"
    }, _defineProperty(_ref365, "stopColor", "color(display-p3 0.9843 0.9412 0.8667)"), _defineProperty(_ref365, "stopOpacity", 1), _ref365)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F0E7C7",
    style: (_ref366 = {
      stopColor: "#F0E7C7"
    }, _defineProperty(_ref366, "stopColor", "color(display-p3 0.9412 0.9059 0.7804)"), _defineProperty(_ref366, "stopOpacity", 1), _ref366)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E4DDAB",
    style: (_ref367 = {
      stopColor: "#E4DDAB"
    }, _defineProperty(_ref367, "stopColor", "color(display-p3 0.8941 0.8667 0.6706)"), _defineProperty(_ref367, "stopOpacity", 1), _ref367)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#ECE8C6",
    stopOpacity: 0.4489,
    style: (_ref368 = {
      stopColor: "#ECE8C6"
    }, _defineProperty(_ref368, "stopColor", "color(display-p3 0.9255 0.9098 0.7765)"), _defineProperty(_ref368, "stopOpacity", 0.4489), _ref368)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F4F1DE",
    stopOpacity: 0.1444,
    style: (_ref369 = {
      stopColor: "#F4F1DE"
    }, _defineProperty(_ref369, "stopColor", "color(display-p3 0.9569 0.9451 0.8706)"), _defineProperty(_ref369, "stopOpacity", 0.1444), _ref369)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FAF9F0",
    stopOpacity: 0.0324,
    style: (_ref370 = {
      stopColor: "#FAF9F0"
    }, _defineProperty(_ref370, "stopColor", "color(display-p3 0.9804 0.9765 0.9412)"), _defineProperty(_ref370, "stopOpacity", 0.0324), _ref370)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#FDFDFA",
    stopOpacity: 0.01,
    style: (_ref371 = {
      stopColor: "#FDFDFA"
    }, _defineProperty(_ref371, "stopColor", "color(display-p3 0.9922 0.9922 0.9804)"), _defineProperty(_ref371, "stopOpacity", 0.01), _ref371)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.7377 34.6041) rotate(180) scale(1.4612 1.45676)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4E6",
    style: (_ref372 = {
      stopColor: "#FFF4E6"
    }, _defineProperty(_ref372, "stopColor", "color(display-p3 1.0000 0.9569 0.9020)"), _defineProperty(_ref372, "stopOpacity", 1), _ref372)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FBF0DD",
    style: (_ref373 = {
      stopColor: "#FBF0DD"
    }, _defineProperty(_ref373, "stopColor", "color(display-p3 0.9843 0.9412 0.8667)"), _defineProperty(_ref373, "stopOpacity", 1), _ref373)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F0E7C7",
    style: (_ref374 = {
      stopColor: "#F0E7C7"
    }, _defineProperty(_ref374, "stopColor", "color(display-p3 0.9412 0.9059 0.7804)"), _defineProperty(_ref374, "stopOpacity", 1), _ref374)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E4DDAB",
    style: (_ref375 = {
      stopColor: "#E4DDAB"
    }, _defineProperty(_ref375, "stopColor", "color(display-p3 0.8941 0.8667 0.6706)"), _defineProperty(_ref375, "stopOpacity", 1), _ref375)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#ECE8C6",
    stopOpacity: 0.4489,
    style: (_ref376 = {
      stopColor: "#ECE8C6"
    }, _defineProperty(_ref376, "stopColor", "color(display-p3 0.9255 0.9098 0.7765)"), _defineProperty(_ref376, "stopOpacity", 0.4489), _ref376)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F4F1DE",
    stopOpacity: 0.1444,
    style: (_ref377 = {
      stopColor: "#F4F1DE"
    }, _defineProperty(_ref377, "stopColor", "color(display-p3 0.9569 0.9451 0.8706)"), _defineProperty(_ref377, "stopOpacity", 0.1444), _ref377)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FAF9F0",
    stopOpacity: 0.0324,
    style: (_ref378 = {
      stopColor: "#FAF9F0"
    }, _defineProperty(_ref378, "stopColor", "color(display-p3 0.9804 0.9765 0.9412)"), _defineProperty(_ref378, "stopOpacity", 0.0324), _ref378)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#FDFDFA",
    stopOpacity: 0.01,
    style: (_ref379 = {
      stopColor: "#FDFDFA"
    }, _defineProperty(_ref379, "stopColor", "color(display-p3 0.9922 0.9922 0.9804)"), _defineProperty(_ref379, "stopOpacity", 0.01), _ref379)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(144.162 151.12) rotate(180) scale(1.46121 1.45676)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4E6",
    style: (_ref380 = {
      stopColor: "#FFF4E6"
    }, _defineProperty(_ref380, "stopColor", "color(display-p3 1.0000 0.9569 0.9020)"), _defineProperty(_ref380, "stopOpacity", 1), _ref380)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FBF0DD",
    style: (_ref381 = {
      stopColor: "#FBF0DD"
    }, _defineProperty(_ref381, "stopColor", "color(display-p3 0.9843 0.9412 0.8667)"), _defineProperty(_ref381, "stopOpacity", 1), _ref381)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F0E7C7",
    style: (_ref382 = {
      stopColor: "#F0E7C7"
    }, _defineProperty(_ref382, "stopColor", "color(display-p3 0.9412 0.9059 0.7804)"), _defineProperty(_ref382, "stopOpacity", 1), _ref382)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E4DDAB",
    style: (_ref383 = {
      stopColor: "#E4DDAB"
    }, _defineProperty(_ref383, "stopColor", "color(display-p3 0.8941 0.8667 0.6706)"), _defineProperty(_ref383, "stopOpacity", 1), _ref383)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#ECE8C6",
    stopOpacity: 0.4489,
    style: (_ref384 = {
      stopColor: "#ECE8C6"
    }, _defineProperty(_ref384, "stopColor", "color(display-p3 0.9255 0.9098 0.7765)"), _defineProperty(_ref384, "stopOpacity", 0.4489), _ref384)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F4F1DE",
    stopOpacity: 0.1444,
    style: (_ref385 = {
      stopColor: "#F4F1DE"
    }, _defineProperty(_ref385, "stopColor", "color(display-p3 0.9569 0.9451 0.8706)"), _defineProperty(_ref385, "stopOpacity", 0.1444), _ref385)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FAF9F0",
    stopOpacity: 0.0324,
    style: (_ref386 = {
      stopColor: "#FAF9F0"
    }, _defineProperty(_ref386, "stopColor", "color(display-p3 0.9804 0.9765 0.9412)"), _defineProperty(_ref386, "stopOpacity", 0.0324), _ref386)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#FDFDFA",
    stopOpacity: 0.01,
    style: (_ref387 = {
      stopColor: "#FDFDFA"
    }, _defineProperty(_ref387, "stopColor", "color(display-p3 0.9922 0.9922 0.9804)"), _defineProperty(_ref387, "stopOpacity", 0.01), _ref387)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(126.818 162.047) rotate(-180) scale(1.4612 1.45676)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4E6",
    style: (_ref388 = {
      stopColor: "#FFF4E6"
    }, _defineProperty(_ref388, "stopColor", "color(display-p3 1.0000 0.9569 0.9020)"), _defineProperty(_ref388, "stopOpacity", 1), _ref388)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FBF0DD",
    style: (_ref389 = {
      stopColor: "#FBF0DD"
    }, _defineProperty(_ref389, "stopColor", "color(display-p3 0.9843 0.9412 0.8667)"), _defineProperty(_ref389, "stopOpacity", 1), _ref389)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F0E7C7",
    style: (_ref390 = {
      stopColor: "#F0E7C7"
    }, _defineProperty(_ref390, "stopColor", "color(display-p3 0.9412 0.9059 0.7804)"), _defineProperty(_ref390, "stopOpacity", 1), _ref390)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E4DDAB",
    style: (_ref391 = {
      stopColor: "#E4DDAB"
    }, _defineProperty(_ref391, "stopColor", "color(display-p3 0.8941 0.8667 0.6706)"), _defineProperty(_ref391, "stopOpacity", 1), _ref391)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#ECE8C6",
    stopOpacity: 0.4489,
    style: (_ref392 = {
      stopColor: "#ECE8C6"
    }, _defineProperty(_ref392, "stopColor", "color(display-p3 0.9255 0.9098 0.7765)"), _defineProperty(_ref392, "stopOpacity", 0.4489), _ref392)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F4F1DE",
    stopOpacity: 0.1444,
    style: (_ref393 = {
      stopColor: "#F4F1DE"
    }, _defineProperty(_ref393, "stopColor", "color(display-p3 0.9569 0.9451 0.8706)"), _defineProperty(_ref393, "stopOpacity", 0.1444), _ref393)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FAF9F0",
    stopOpacity: 0.0324,
    style: (_ref394 = {
      stopColor: "#FAF9F0"
    }, _defineProperty(_ref394, "stopColor", "color(display-p3 0.9804 0.9765 0.9412)"), _defineProperty(_ref394, "stopOpacity", 0.0324), _ref394)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#FDFDFA",
    stopOpacity: 0.01,
    style: (_ref395 = {
      stopColor: "#FDFDFA"
    }, _defineProperty(_ref395, "stopColor", "color(display-p3 0.9922 0.9922 0.9804)"), _defineProperty(_ref395, "stopOpacity", 0.01), _ref395)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(137.403 45.1262) scale(9.85 9.82004)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DAAB3",
    style: (_ref396 = {
      stopColor: "#7DAAB3"
    }, _defineProperty(_ref396, "stopColor", "color(display-p3 0.4902 0.6667 0.7020)"), _defineProperty(_ref396, "stopOpacity", 1), _ref396)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(82.4547 105.905) scale(15.3987 15.3518)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DAAB3",
    style: (_ref397 = {
      stopColor: "#7DAAB3"
    }, _defineProperty(_ref397, "stopColor", "color(display-p3 0.4902 0.6667 0.7020)"), _defineProperty(_ref397, "stopOpacity", 1), _ref397)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(142.487 94.2155) scale(9.85 9.82004)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DAAB3",
    style: (_ref398 = {
      stopColor: "#7DAAB3"
    }, _defineProperty(_ref398, "stopColor", "color(display-p3 0.4902 0.6667 0.7020)"), _defineProperty(_ref398, "stopOpacity", 1), _ref398)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(106.706 48.2976) scale(8.60065 8.57448)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DAAB3",
    style: (_ref399 = {
      stopColor: "#7DAAB3"
    }, _defineProperty(_ref399, "stopColor", "color(display-p3 0.4902 0.6667 0.7020)"), _defineProperty(_ref399, "stopOpacity", 1), _ref399)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.5186 66.3728) scale(8.60065 8.57448)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DAAB3",
    style: (_ref400 = {
      stopColor: "#7DAAB3"
    }, _defineProperty(_ref400, "stopColor", "color(display-p3 0.4902 0.6667 0.7020)"), _defineProperty(_ref400, "stopOpacity", 1), _ref400)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.3014 102.088) scale(12.901 12.8617)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DAAB3",
    style: (_ref401 = {
      stopColor: "#7DAAB3"
    }, _defineProperty(_ref401, "stopColor", "color(display-p3 0.4902 0.6667 0.7020)"), _defineProperty(_ref401, "stopOpacity", 1), _ref401)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(69.3775 135.525) scale(12.901 12.8617)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DAAB3",
    style: (_ref402 = {
      stopColor: "#7DAAB3"
    }, _defineProperty(_ref402, "stopColor", "color(display-p3 0.4902 0.6667 0.7020)"), _defineProperty(_ref402, "stopOpacity", 1), _ref402)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(104.737 142.932) scale(12.901 12.8617)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DAAB3",
    style: (_ref403 = {
      stopColor: "#7DAAB3"
    }, _defineProperty(_ref403, "stopColor", "color(display-p3 0.4902 0.6667 0.7020)"), _defineProperty(_ref403, "stopOpacity", 1), _ref403)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(125.111 117.045) scale(6.33732 6.31804)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DAAB3",
    style: (_ref404 = {
      stopColor: "#7DAAB3"
    }, _defineProperty(_ref404, "stopColor", "color(display-p3 0.4902 0.6667 0.7020)"), _defineProperty(_ref404, "stopOpacity", 1), _ref404)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint58_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(136.505 117.835) scale(6.33732 6.31804)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DAAB3",
    style: (_ref405 = {
      stopColor: "#7DAAB3"
    }, _defineProperty(_ref405, "stopColor", "color(display-p3 0.4902 0.6667 0.7020)"), _defineProperty(_ref405, "stopOpacity", 1), _ref405)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint59_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(88.3959 113.875) scale(6.33732 6.31804)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DAAB3",
    style: (_ref406 = {
      stopColor: "#7DAAB3"
    }, _defineProperty(_ref406, "stopColor", "color(display-p3 0.4902 0.6667 0.7020)"), _defineProperty(_ref406, "stopOpacity", 1), _ref406)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint60_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.3803 113.65) scale(6.33732 6.31804)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DAAB3",
    style: (_ref407 = {
      stopColor: "#7DAAB3"
    }, _defineProperty(_ref407, "stopColor", "color(display-p3 0.4902 0.6667 0.7020)"), _defineProperty(_ref407, "stopOpacity", 1), _ref407)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint61_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(144.197 123.867) scale(6.33732 6.31804)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DAAB3",
    style: (_ref408 = {
      stopColor: "#7DAAB3"
    }, _defineProperty(_ref408, "stopColor", "color(display-p3 0.4902 0.6667 0.7020)"), _defineProperty(_ref408, "stopOpacity", 1), _ref408)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint62_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(126.613 138.754) scale(9.50598 9.47706)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DAAB3",
    style: (_ref409 = {
      stopColor: "#7DAAB3"
    }, _defineProperty(_ref409, "stopColor", "color(display-p3 0.4902 0.6667 0.7020)"), _defineProperty(_ref409, "stopOpacity", 1), _ref409)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint63_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(133.576 149.802) scale(9.50598 9.47706)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DAAB3",
    style: (_ref410 = {
      stopColor: "#7DAAB3"
    }, _defineProperty(_ref410, "stopColor", "color(display-p3 0.4902 0.6667 0.7020)"), _defineProperty(_ref410, "stopOpacity", 1), _ref410)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint64_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(144.195 151.104) scale(9.50598 9.47706)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DAAB3",
    style: (_ref411 = {
      stopColor: "#7DAAB3"
    }, _defineProperty(_ref411, "stopColor", "color(display-p3 0.4902 0.6667 0.7020)"), _defineProperty(_ref411, "stopOpacity", 1), _ref411)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint65_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(155.022 134.489) scale(9.50598 9.47706)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DAAB3",
    style: (_ref412 = {
      stopColor: "#7DAAB3"
    }, _defineProperty(_ref412, "stopColor", "color(display-p3 0.4902 0.6667 0.7020)"), _defineProperty(_ref412, "stopOpacity", 1), _ref412)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint66_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(162.833 125.438) scale(6.33732 6.31804)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DAAB3",
    style: (_ref413 = {
      stopColor: "#7DAAB3"
    }, _defineProperty(_ref413, "stopColor", "color(display-p3 0.4902 0.6667 0.7020)"), _defineProperty(_ref413, "stopOpacity", 1), _ref413)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint67_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(126.731 162.373) scale(9.50598 9.47707)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DAAB3",
    style: (_ref414 = {
      stopColor: "#7DAAB3"
    }, _defineProperty(_ref414, "stopColor", "color(display-p3 0.4902 0.6667 0.7020)"), _defineProperty(_ref414, "stopOpacity", 1), _ref414)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint68_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(107.988 159.3) scale(9.50598 9.47706)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DAAB3",
    style: (_ref415 = {
      stopColor: "#7DAAB3"
    }, _defineProperty(_ref415, "stopColor", "color(display-p3 0.4902 0.6667 0.7020)"), _defineProperty(_ref415, "stopOpacity", 1), _ref415)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint69_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(100.19 170.178) scale(9.50598 9.47706)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DAAB3",
    style: (_ref416 = {
      stopColor: "#7DAAB3"
    }, _defineProperty(_ref416, "stopColor", "color(display-p3 0.4902 0.6667 0.7020)"), _defineProperty(_ref416, "stopOpacity", 1), _ref416)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint70_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.4689 153.156) scale(9.50598 9.47706)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DAAB3",
    style: (_ref417 = {
      stopColor: "#7DAAB3"
    }, _defineProperty(_ref417, "stopColor", "color(display-p3 0.4902 0.6667 0.7020)"), _defineProperty(_ref417, "stopOpacity", 1), _ref417)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint71_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(71.1915 166.563) scale(9.50598 9.47706)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DAAB3",
    style: (_ref418 = {
      stopColor: "#7DAAB3"
    }, _defineProperty(_ref418, "stopColor", "color(display-p3 0.4902 0.6667 0.7020)"), _defineProperty(_ref418, "stopOpacity", 1), _ref418)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint72_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.1486 149.802) scale(9.50598 9.47706)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DAAB3",
    style: (_ref419 = {
      stopColor: "#7DAAB3"
    }, _defineProperty(_ref419, "stopColor", "color(display-p3 0.4902 0.6667 0.7020)"), _defineProperty(_ref419, "stopOpacity", 1), _ref419)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint73_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.34 138.038) scale(9.50598 9.47706)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DAAB3",
    style: (_ref420 = {
      stopColor: "#7DAAB3"
    }, _defineProperty(_ref420, "stopColor", "color(display-p3 0.4902 0.6667 0.7020)"), _defineProperty(_ref420, "stopOpacity", 1), _ref420)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint74_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.3947 130.404) scale(9.50598 9.47706)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DAAB3",
    style: (_ref421 = {
      stopColor: "#7DAAB3"
    }, _defineProperty(_ref421, "stopColor", "color(display-p3 0.4902 0.6667 0.7020)"), _defineProperty(_ref421, "stopOpacity", 1), _ref421)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint75_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.1505 125.458) scale(9.50598 9.47706)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DAAB3",
    style: (_ref422 = {
      stopColor: "#7DAAB3"
    }, _defineProperty(_ref422, "stopColor", "color(display-p3 0.4902 0.6667 0.7020)"), _defineProperty(_ref422, "stopOpacity", 1), _ref422)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint76_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.0255 117.143) scale(9.50598 9.47706)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DAAB3",
    style: (_ref423 = {
      stopColor: "#7DAAB3"
    }, _defineProperty(_ref423, "stopColor", "color(display-p3 0.4902 0.6667 0.7020)"), _defineProperty(_ref423, "stopOpacity", 1), _ref423)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint77_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.2592 96.9108) scale(6.33732 6.31804)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DAAB3",
    style: (_ref424 = {
      stopColor: "#7DAAB3"
    }, _defineProperty(_ref424, "stopColor", "color(display-p3 0.4902 0.6667 0.7020)"), _defineProperty(_ref424, "stopOpacity", 1), _ref424)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint78_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.5014 86.0798) scale(6.33732 6.31804)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DAAB3",
    style: (_ref425 = {
      stopColor: "#7DAAB3"
    }, _defineProperty(_ref425, "stopColor", "color(display-p3 0.4902 0.6667 0.7020)"), _defineProperty(_ref425, "stopOpacity", 1), _ref425)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint79_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.6576 77.9875) scale(6.33732 6.31804)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DAAB3",
    style: (_ref426 = {
      stopColor: "#7DAAB3"
    }, _defineProperty(_ref426, "stopColor", "color(display-p3 0.4902 0.6667 0.7020)"), _defineProperty(_ref426, "stopOpacity", 1), _ref426)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint80_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.1017 79.4185) scale(9.50598 9.47706)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DAAB3",
    style: (_ref427 = {
      stopColor: "#7DAAB3"
    }, _defineProperty(_ref427, "stopColor", "color(display-p3 0.4902 0.6667 0.7020)"), _defineProperty(_ref427, "stopOpacity", 1), _ref427)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint81_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.3165 92.398) scale(9.50598 9.47706)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DAAB3",
    style: (_ref428 = {
      stopColor: "#7DAAB3"
    }, _defineProperty(_ref428, "stopColor", "color(display-p3 0.4902 0.6667 0.7020)"), _defineProperty(_ref428, "stopOpacity", 1), _ref428)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint82_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.976 52.1843) scale(6.33732 6.31804)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DAAB3",
    style: (_ref429 = {
      stopColor: "#7DAAB3"
    }, _defineProperty(_ref429, "stopColor", "color(display-p3 0.4902 0.6667 0.7020)"), _defineProperty(_ref429, "stopOpacity", 1), _ref429)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint83_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.6947 55.7839) scale(6.33732 6.31804)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DAAB3",
    style: (_ref430 = {
      stopColor: "#7DAAB3"
    }, _defineProperty(_ref430, "stopColor", "color(display-p3 0.4902 0.6667 0.7020)"), _defineProperty(_ref430, "stopOpacity", 1), _ref430)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint84_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.2026 38.0104) scale(6.33732 6.31804)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DAAB3",
    style: (_ref431 = {
      stopColor: "#7DAAB3"
    }, _defineProperty(_ref431, "stopColor", "color(display-p3 0.4902 0.6667 0.7020)"), _defineProperty(_ref431, "stopOpacity", 1), _ref431)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint85_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.2182 28.8097) scale(6.33732 6.31804)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DAAB3",
    style: (_ref432 = {
      stopColor: "#7DAAB3"
    }, _defineProperty(_ref432, "stopColor", "color(display-p3 0.4902 0.6667 0.7020)"), _defineProperty(_ref432, "stopOpacity", 1), _ref432)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint86_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.9948 62.8366) rotate(-19.1758) scale(33.6401 6.32012)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DAAB3",
    style: (_ref433 = {
      stopColor: "#7DAAB3"
    }, _defineProperty(_ref433, "stopColor", "color(display-p3 0.4902 0.6667 0.7020)"), _defineProperty(_ref433, "stopOpacity", 1), _ref433)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint87_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(99.7361 50.0431) rotate(-15.6546) scale(28.2582 6.31945)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DAAB3",
    style: (_ref434 = {
      stopColor: "#7DAAB3"
    }, _defineProperty(_ref434, "stopColor", "color(display-p3 0.4902 0.6667 0.7020)"), _defineProperty(_ref434, "stopOpacity", 1), _ref434)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint88_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.324 100.599) rotate(40.1739) scale(28.2417 8.10699)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DAAB3",
    style: (_ref435 = {
      stopColor: "#7DAAB3"
    }, _defineProperty(_ref435, "stopColor", "color(display-p3 0.4902 0.6667 0.7020)"), _defineProperty(_ref435, "stopOpacity", 1), _ref435)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint89_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(126.632 153.598) rotate(-30.4736) scale(28.2554 8.10306)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DAAB3",
    style: (_ref436 = {
      stopColor: "#7DAAB3"
    }, _defineProperty(_ref436, "stopColor", "color(display-p3 0.4902 0.6667 0.7020)"), _defineProperty(_ref436, "stopOpacity", 1), _ref436)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint90_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(100.865 158.489) rotate(-167.876) scale(28.2738 8.09779)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DAAB3",
    style: (_ref437 = {
      stopColor: "#7DAAB3"
    }, _defineProperty(_ref437, "stopColor", "color(display-p3 0.4902 0.6667 0.7020)"), _defineProperty(_ref437, "stopOpacity", 1), _ref437)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint91_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(128.036 117.356) rotate(-174.656) scale(28.2769 4.78263)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DAAB3",
    style: (_ref438 = {
      stopColor: "#7DAAB3"
    }, _defineProperty(_ref438, "stopColor", "color(display-p3 0.4902 0.6667 0.7020)"), _defineProperty(_ref438, "stopOpacity", 1), _ref438)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint92_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.6864 109.829) rotate(66.7969) scale(28.2049 8.11757)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DAAB3",
    style: (_ref439 = {
      stopColor: "#7DAAB3"
    }, _defineProperty(_ref439, "stopColor", "color(display-p3 0.4902 0.6667 0.7020)"), _defineProperty(_ref439, "stopOpacity", 1), _ref439)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint93_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(72.7453 145.39) rotate(71.708) scale(28.2 8.11897)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DAAB3",
    style: (_ref440 = {
      stopColor: "#7DAAB3"
    }, _defineProperty(_ref440, "stopColor", "color(display-p3 0.4902 0.6667 0.7020)"), _defineProperty(_ref440, "stopOpacity", 1), _ref440)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint94_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.2366 73.0641) rotate(122.769) scale(23.263 6.68966)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DAAB3",
    style: (_ref441 = {
      stopColor: "#7DAAB3"
    }, _defineProperty(_ref441, "stopColor", "color(display-p3 0.4902 0.6667 0.7020)"), _defineProperty(_ref441, "stopOpacity", 1), _ref441)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint95_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.7149 60.8294) rotate(122.769) scale(16.1845 4.65413)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DAAB3",
    style: (_ref442 = {
      stopColor: "#7DAAB3"
    }, _defineProperty(_ref442, "stopColor", "color(display-p3 0.4902 0.6667 0.7020)"), _defineProperty(_ref442, "stopOpacity", 1), _ref442)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint96_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.3661 37.7105) rotate(167.048) scale(16.217 4.64482)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DAAB3",
    style: (_ref443 = {
      stopColor: "#7DAAB3"
    }, _defineProperty(_ref443, "stopColor", "color(display-p3 0.4902 0.6667 0.7020)"), _defineProperty(_ref443, "stopOpacity", 1), _ref443)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint97_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(101.795 25.4052) rotate(-151.613) scale(25.7973 2.47831)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DAAB3",
    style: (_ref444 = {
      stopColor: "#7DAAB3"
    }, _defineProperty(_ref444, "stopColor", "color(display-p3 0.4902 0.6667 0.7020)"), _defineProperty(_ref444, "stopOpacity", 1), _ref444)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint98_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(120.637 27.9982) rotate(-134.787) scale(20.6472 2.24577)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DAAB3",
    style: (_ref445 = {
      stopColor: "#7DAAB3"
    }, _defineProperty(_ref445, "stopColor", "color(display-p3 0.4902 0.6667 0.7020)"), _defineProperty(_ref445, "stopOpacity", 1), _ref445)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint99_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.0987 87.6159) rotate(90) scale(19.0321 8.21244)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DAAB3",
    style: (_ref446 = {
      stopColor: "#7DAAB3"
    }, _defineProperty(_ref446, "stopColor", "color(display-p3 0.4902 0.6667 0.7020)"), _defineProperty(_ref446, "stopOpacity", 1), _ref446)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint100_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.7178 153.297) rotate(36.0569) scale(19.07 8.19612)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DAAB3",
    style: (_ref447 = {
      stopColor: "#7DAAB3"
    }, _defineProperty(_ref447, "stopColor", "color(display-p3 0.4902 0.6667 0.7020)"), _defineProperty(_ref447, "stopOpacity", 1), _ref447)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint101_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(67.1472 164.779) rotate(24.4741) scale(16.944 4.82516)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DAAB3",
    style: (_ref448 = {
      stopColor: "#7DAAB3"
    }, _defineProperty(_ref448, "stopColor", "color(display-p3 0.4902 0.6667 0.7020)"), _defineProperty(_ref448, "stopOpacity", 1), _ref448)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint102_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.1122 123.859) rotate(63.9512) scale(16.9112 4.83451)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DAAB3",
    style: (_ref449 = {
      stopColor: "#7DAAB3"
    }, _defineProperty(_ref449, "stopColor", "color(display-p3 0.4902 0.6667 0.7020)"), _defineProperty(_ref449, "stopOpacity", 1), _ref449)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint103_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(86.0993 96.0026) rotate(113.253) scale(16.9093 4.83506)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DAAB3",
    style: (_ref450 = {
      stopColor: "#7DAAB3"
    }, _defineProperty(_ref450, "stopColor", "color(display-p3 0.4902 0.6667 0.7020)"), _defineProperty(_ref450, "stopOpacity", 1), _ref450)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint104_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(91.6877 102.86) rotate(166.749) scale(16.9502 4.82341)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DAAB3",
    style: (_ref451 = {
      stopColor: "#7DAAB3"
    }, _defineProperty(_ref451, "stopColor", "color(display-p3 0.4902 0.6667 0.7020)"), _defineProperty(_ref451, "stopOpacity", 1), _ref451)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint105_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(111.001 141.003) rotate(166.749) scale(16.9502 4.82341)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DAAB3",
    style: (_ref452 = {
      stopColor: "#7DAAB3"
    }, _defineProperty(_ref452, "stopColor", "color(display-p3 0.4902 0.6667 0.7020)"), _defineProperty(_ref452, "stopOpacity", 1), _ref452)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint106_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.9656 38.547) rotate(137.467) scale(20.0684 4.79457)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DAAB3",
    style: (_ref453 = {
      stopColor: "#7DAAB3"
    }, _defineProperty(_ref453, "stopColor", "color(display-p3 0.4902 0.6667 0.7020)"), _defineProperty(_ref453, "stopOpacity", 1), _ref453)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint107_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(70.2104 21.0309) scale(6.33732 6.31804)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DAAB3",
    style: (_ref454 = {
      stopColor: "#7DAAB3"
    }, _defineProperty(_ref454, "stopColor", "color(display-p3 0.4902 0.6667 0.7020)"), _defineProperty(_ref454, "stopOpacity", 1), _ref454)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint108_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(92.8256 21.5959) scale(6.33732 6.31804)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DAAB3",
    style: (_ref455 = {
      stopColor: "#7DAAB3"
    }, _defineProperty(_ref455, "stopColor", "color(display-p3 0.4902 0.6667 0.7020)"), _defineProperty(_ref455, "stopOpacity", 1), _ref455)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint109_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(99.1635 17.6935) scale(6.33732 6.31804)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DAAB3",
    style: (_ref456 = {
      stopColor: "#7DAAB3"
    }, _defineProperty(_ref456, "stopColor", "color(display-p3 0.4902 0.6667 0.7020)"), _defineProperty(_ref456, "stopOpacity", 1), _ref456)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint110_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(114.052 20.1393) scale(6.33732 6.31804)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DAAB3",
    style: (_ref457 = {
      stopColor: "#7DAAB3"
    }, _defineProperty(_ref457, "stopColor", "color(display-p3 0.4902 0.6667 0.7020)"), _defineProperty(_ref457, "stopOpacity", 1), _ref457)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint111_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.7455 34.5119) scale(6.33732 6.31804)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DAAB3",
    style: (_ref458 = {
      stopColor: "#7DAAB3"
    }, _defineProperty(_ref458, "stopColor", "color(display-p3 0.4902 0.6667 0.7020)"), _defineProperty(_ref458, "stopOpacity", 1), _ref458)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint112_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(143.648 36.1237) scale(6.33732 6.31804)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DAAB3",
    style: (_ref459 = {
      stopColor: "#7DAAB3"
    }, _defineProperty(_ref459, "stopColor", "color(display-p3 0.4902 0.6667 0.7020)"), _defineProperty(_ref459, "stopOpacity", 1), _ref459)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint113_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(157.685 58.1407) rotate(42.1231) scale(7.81423 2.35426)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DAAB3",
    style: (_ref460 = {
      stopColor: "#7DAAB3"
    }, _defineProperty(_ref460, "stopColor", "color(display-p3 0.4902 0.6667 0.7020)"), _defineProperty(_ref460, "stopOpacity", 1), _ref460)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint114_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(151.305 66.2357) rotate(59.9244) scale(7.80712 2.35641)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DAAB3",
    style: (_ref461 = {
      stopColor: "#7DAAB3"
    }, _defineProperty(_ref461, "stopColor", "color(display-p3 0.4902 0.6667 0.7020)"), _defineProperty(_ref461, "stopOpacity", 1), _ref461)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint115_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(161.48 61.5441) scale(6.33732 6.31804)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DAAB3",
    style: (_ref462 = {
      stopColor: "#7DAAB3"
    }, _defineProperty(_ref462, "stopColor", "color(display-p3 0.4902 0.6667 0.7020)"), _defineProperty(_ref462, "stopOpacity", 1), _ref462)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint116_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(130.949 66.4255) scale(6.33732 6.31804)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DAAB3",
    style: (_ref463 = {
      stopColor: "#7DAAB3"
    }, _defineProperty(_ref463, "stopColor", "color(display-p3 0.4902 0.6667 0.7020)"), _defineProperty(_ref463, "stopOpacity", 1), _ref463)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint117_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(153.757 71.9762) scale(6.33732 6.31804)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DAAB3",
    style: (_ref464 = {
      stopColor: "#7DAAB3"
    }, _defineProperty(_ref464, "stopColor", "color(display-p3 0.4902 0.6667 0.7020)"), _defineProperty(_ref464, "stopOpacity", 1), _ref464)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint118_radial_3437_366",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(85.3116 18.2205) scale(8.60065 8.57448)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DAAB3",
    style: (_ref465 = {
      stopColor: "#7DAAB3"
    }, _defineProperty(_ref465, "stopColor", "color(display-p3 0.4902 0.6667 0.7020)"), _defineProperty(_ref465, "stopOpacity", 1), _ref465)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3437_366"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 181.371,
    height: 181.371,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(0 0.814453)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBae1);
export default __webpack_public_path__ + "static/media/BAE-1.88815a00aa08ccffe3fd1accb5bfb8b7.svg";
export { ForwardRef as ReactComponent };